webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(10);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(12);
	
	var _ngTagsInput = __webpack_require__(14);
	
	var _ngTagsInput2 = _interopRequireDefault(_ngTagsInput);
	
	__webpack_require__(15);
	
	var _app = __webpack_require__(16);
	
	var _auth = __webpack_require__(17);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(28);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(36);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _calendar = __webpack_require__(51);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _navbar = __webpack_require__(62);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _main = __webpack_require__(64);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _app2 = __webpack_require__(18);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(20);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _modal = __webpack_require__(66);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _filters = __webpack_require__(70);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _miscServices = __webpack_require__(77);
	
	var _miscServices2 = _interopRequireDefault(_miscServices);
	
	__webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('calApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _main2.default, _app3.default, _util2.default, _calendar2.default, _filters2.default, _modal2.default, 'ngTagsInput', 'ui.bootstrap.contextMenu', _miscServices2.default]).config(_app.routeConfig).run(['$rootScope', '$location', 'Auth', function ($rootScope, $location, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        $location.path('/');
	      }
	    });
	  });
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['calApp'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(13);
	module.exports = 'validation.match';


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/*! ngTagsInput v3.2.0 License: MIT */!function(){"use strict";var a={backspace:8,tab:9,enter:13,escape:27,space:32,up:38,down:40,left:37,right:39,"delete":46,comma:188},b=9007199254740991,c=["text","email","url"],d=angular.module("ngTagsInput",[]);d.directive("tagsInput",["$timeout","$document","$window","$q","tagsInputConfig","tiUtil",function(d,e,f,g,h,i){function j(a,b,c,d){var e,f,h,j,k={};return e=function(b){return i.safeToString(b[a.displayProperty])},f=function(b,c){b[a.displayProperty]=c},h=function(b){var d=e(b),f=d&&d.length>=a.minLength&&d.length<=a.maxLength&&a.allowedTagsPattern.test(d)&&!i.findInObjectArray(k.items,b,a.keyProperty||a.displayProperty);return g.when(f&&c({$tag:b})).then(i.promisifyValue)},j=function(a){return g.when(d({$tag:a})).then(i.promisifyValue)},k.items=[],k.addText=function(a){var b={};return f(b,a),k.add(b)},k.add=function(c){var d=e(c);return a.replaceSpacesWithDashes&&(d=i.replaceSpacesWithDashes(d)),f(c,d),h(c).then(function(){k.items.push(c),b.trigger("tag-added",{$tag:c})})["catch"](function(){d&&b.trigger("invalid-tag",{$tag:c})})},k.remove=function(a){var c=k.items[a];return j(c).then(function(){return k.items.splice(a,1),k.clearSelection(),b.trigger("tag-removed",{$tag:c}),c})},k.select=function(a){0>a?a=k.items.length-1:a>=k.items.length&&(a=0),k.index=a,k.selected=k.items[a]},k.selectPrior=function(){k.select(--k.index)},k.selectNext=function(){k.select(++k.index)},k.removeSelected=function(){return k.remove(k.index)},k.clearSelection=function(){k.selected=null,k.index=-1},k.getItems=function(){return a.useStrings?k.items.map(e):k.items},k.clearSelection(),k}function k(a){return-1!==c.indexOf(a)}return{restrict:"E",require:"ngModel",scope:{tags:"=ngModel",text:"=?",templateScope:"=?",tagClass:"&",onTagAdding:"&",onTagAdded:"&",onInvalidTag:"&",onTagRemoving:"&",onTagRemoved:"&",onTagClicked:"&"},replace:!1,transclude:!0,templateUrl:"ngTagsInput/tags-input.html",controller:["$scope","$attrs","$element",function(a,c,d){a.events=i.simplePubSub(),h.load("tagsInput",a,c,{template:[String,"ngTagsInput/tag-item.html"],type:[String,"text",k],placeholder:[String,"Add a tag"],tabindex:[Number,null],removeTagSymbol:[String,String.fromCharCode(215)],replaceSpacesWithDashes:[Boolean,!0],minLength:[Number,3],maxLength:[Number,b],addOnEnter:[Boolean,!0],addOnSpace:[Boolean,!1],addOnComma:[Boolean,!0],addOnBlur:[Boolean,!0],addOnPaste:[Boolean,!1],pasteSplitPattern:[RegExp,/,/],allowedTagsPattern:[RegExp,/.+/],enableEditingLastTag:[Boolean,!1],minTags:[Number,0],maxTags:[Number,b],displayProperty:[String,"text"],keyProperty:[String,""],allowLeftoverText:[Boolean,!1],addFromAutocompleteOnly:[Boolean,!1],spellcheck:[Boolean,!0],useStrings:[Boolean,!1]}),a.tagList=new j(a.options,a.events,i.handleUndefinedResult(a.onTagAdding,!0),i.handleUndefinedResult(a.onTagRemoving,!0)),this.registerAutocomplete=function(){d.find("input");return{addTag:function(b){return a.tagList.add(b)},getTags:function(){return a.tagList.items},getCurrentTagText:function(){return a.newTag.text()},getOptions:function(){return a.options},getTemplateScope:function(){return a.templateScope},on:function(b,c){return a.events.on(b,c,!0),this}}},this.registerTagItem=function(){return{getOptions:function(){return a.options},removeTag:function(b){a.disabled||a.tagList.remove(b)}}}}],link:function(b,c,g,h){var j,k,l=[a.enter,a.comma,a.space,a.backspace,a["delete"],a.left,a.right],m=b.tagList,n=b.events,o=b.options,p=c.find("input"),q=["minTags","maxTags","allowLeftoverText"];j=function(){h.$setValidity("maxTags",m.items.length<=o.maxTags),h.$setValidity("minTags",m.items.length>=o.minTags),h.$setValidity("leftoverText",b.hasFocus||o.allowLeftoverText?!0:!b.newTag.text())},k=function(){d(function(){p[0].focus()})},h.$isEmpty=function(a){return!a||!a.length},b.newTag={text:function(a){return angular.isDefined(a)?(b.text=a,void n.trigger("input-change",a)):b.text||""},invalid:null},b.track=function(a){return a[o.keyProperty||o.displayProperty]},b.getTagClass=function(a,c){var d=a===m.selected;return[b.tagClass({$tag:a,$index:c,$selected:d}),{selected:d}]},b.$watch("tags",function(a){if(a){if(m.items=i.makeObjectArray(a,o.displayProperty),o.useStrings)return;b.tags=m.items}else m.items=[]}),b.$watch("tags.length",function(){j(),h.$validate()}),g.$observe("disabled",function(a){b.disabled=a}),b.eventHandlers={input:{keydown:function(a){n.trigger("input-keydown",a)},focus:function(){b.hasFocus||(b.hasFocus=!0,n.trigger("input-focus"))},blur:function(){d(function(){var a=e.prop("activeElement"),d=a===p[0],f=c[0].contains(a);(d||!f)&&(b.hasFocus=!1,n.trigger("input-blur"))})},paste:function(a){a.getTextData=function(){var b=a.clipboardData||a.originalEvent&&a.originalEvent.clipboardData;return b?b.getData("text/plain"):f.clipboardData.getData("Text")},n.trigger("input-paste",a)}},host:{click:function(){b.disabled||k()}},tag:{click:function(a){n.trigger("tag-clicked",{$tag:a})}}},n.on("tag-added",b.onTagAdded).on("invalid-tag",b.onInvalidTag).on("tag-removed",b.onTagRemoved).on("tag-clicked",b.onTagClicked).on("tag-added",function(){b.newTag.text("")}).on("tag-added tag-removed",function(){b.tags=m.getItems(),h.$setDirty(),k()}).on("invalid-tag",function(){b.newTag.invalid=!0}).on("option-change",function(a){-1!==q.indexOf(a.name)&&j()}).on("input-change",function(){m.clearSelection(),b.newTag.invalid=null}).on("input-focus",function(){c.triggerHandler("focus"),h.$setValidity("leftoverText",!0)}).on("input-blur",function(){o.addOnBlur&&!o.addFromAutocompleteOnly&&m.addText(b.newTag.text()),c.triggerHandler("blur"),j()}).on("input-keydown",function(c){var d,e,f,g,h=c.keyCode,j={};i.isModifierOn(c)||-1===l.indexOf(h)||(j[a.enter]=o.addOnEnter,j[a.comma]=o.addOnComma,j[a.space]=o.addOnSpace,d=!o.addFromAutocompleteOnly&&j[h],e=(h===a.backspace||h===a["delete"])&&m.selected,g=h===a.backspace&&0===b.newTag.text().length&&o.enableEditingLastTag,f=(h===a.backspace||h===a.left||h===a.right)&&0===b.newTag.text().length&&!o.enableEditingLastTag,d?m.addText(b.newTag.text()):g?(m.selectPrior(),m.removeSelected().then(function(a){a&&b.newTag.text(a[o.displayProperty])})):e?m.removeSelected():f&&(h===a.left||h===a.backspace?m.selectPrior():h===a.right&&m.selectNext()),(d||f||e||g)&&c.preventDefault())}).on("input-paste",function(a){if(o.addOnPaste){var b=a.getTextData(),c=b.split(o.pasteSplitPattern);c.length>1&&(c.forEach(function(a){m.addText(a)}),a.preventDefault())}})}}}]),d.directive("tiTagItem",["tiUtil",function(a){return{restrict:"E",require:"^tagsInput",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(b,c,d,e){var f=e.registerTagItem(),g=f.getOptions();b.$$template=g.template,b.$$removeTagSymbol=g.removeTagSymbol,b.$getDisplayText=function(){return a.safeToString(b.data[g.displayProperty])},b.$removeTag=function(){f.removeTag(b.$index)},b.$watch("$parent.$index",function(a){b.$index=a})}}}]),d.directive("autoComplete",["$document","$timeout","$sce","$q","tagsInputConfig","tiUtil",function(b,c,d,e,f,g){function h(a,b,c){var d,f,h,i={};return h=function(){return b.tagsInput.keyProperty||b.tagsInput.displayProperty},d=function(a,c){return a.filter(function(a){return!g.findInObjectArray(c,a,h(),function(a,c){return b.tagsInput.replaceSpacesWithDashes&&(a=g.replaceSpacesWithDashes(a),c=g.replaceSpacesWithDashes(c)),g.defaultComparer(a,c)})})},i.reset=function(){f=null,i.items=[],i.visible=!1,i.index=-1,i.selected=null,i.query=null},i.show=function(){b.selectFirstMatch?i.select(0):i.selected=null,i.visible=!0},i.load=g.debounce(function(c,j){i.query=c;var k=e.when(a({$query:c}));f=k,k.then(function(a){k===f&&(a=g.makeObjectArray(a.data||a,h()),a=d(a,j),i.items=a.slice(0,b.maxResultsToShow),i.items.length>0?i.show():i.reset())})},b.debounceDelay),i.selectNext=function(){i.select(++i.index)},i.selectPrior=function(){i.select(--i.index)},i.select=function(a){0>a?a=i.items.length-1:a>=i.items.length&&(a=0),i.index=a,i.selected=i.items[a],c.trigger("suggestion-selected",a)},i.reset(),i}function i(a,b){var c=a.find("li").eq(b),d=c.parent(),e=c.prop("offsetTop"),f=c.prop("offsetHeight"),g=d.prop("clientHeight"),h=d.prop("scrollTop");h>e?d.prop("scrollTop",e):e+f>g+h&&d.prop("scrollTop",e+f-g)}return{restrict:"E",require:"^tagsInput",scope:{source:"&",matchClass:"&"},templateUrl:"ngTagsInput/auto-complete.html",controller:["$scope","$element","$attrs",function(a,b,c){a.events=g.simplePubSub(),f.load("autoComplete",a,c,{template:[String,"ngTagsInput/auto-complete-match.html"],debounceDelay:[Number,100],minLength:[Number,3],highlightMatchedText:[Boolean,!0],maxResultsToShow:[Number,10],loadOnDownArrow:[Boolean,!1],loadOnEmpty:[Boolean,!1],loadOnFocus:[Boolean,!1],selectFirstMatch:[Boolean,!0],displayProperty:[String,""]}),a.suggestionList=new h(a.source,a.options,a.events),this.registerAutocompleteMatch=function(){return{getOptions:function(){return a.options},getQuery:function(){return a.suggestionList.query}}}}],link:function(b,c,d,e){var f,h=[a.enter,a.tab,a.escape,a.up,a.down],j=b.suggestionList,k=e.registerAutocomplete(),l=b.options,m=b.events;l.tagsInput=k.getOptions(),f=function(a){return a&&a.length>=l.minLength||!a&&l.loadOnEmpty},b.templateScope=k.getTemplateScope(),b.addSuggestionByIndex=function(a){j.select(a),b.addSuggestion()},b.addSuggestion=function(){var a=!1;return j.selected&&(k.addTag(angular.copy(j.selected)),j.reset(),a=!0),a},b.track=function(a){return a[l.tagsInput.keyProperty||l.tagsInput.displayProperty]},b.getSuggestionClass=function(a,c){var d=a===j.selected;return[b.matchClass({$match:a,$index:c,$selected:d}),{selected:d}]},k.on("tag-added tag-removed invalid-tag input-blur",function(){j.reset()}).on("input-change",function(a){f(a)?j.load(a,k.getTags()):j.reset()}).on("input-focus",function(){var a=k.getCurrentTagText();l.loadOnFocus&&f(a)&&j.load(a,k.getTags())}).on("input-keydown",function(c){var d=c.keyCode,e=!1;if(!g.isModifierOn(c)&&-1!==h.indexOf(d))return j.visible?d===a.down?(j.selectNext(),e=!0):d===a.up?(j.selectPrior(),e=!0):d===a.escape?(j.reset(),e=!0):(d===a.enter||d===a.tab)&&(e=b.addSuggestion()):d===a.down&&b.options.loadOnDownArrow&&(j.load(k.getCurrentTagText(),k.getTags()),e=!0),e?(c.preventDefault(),c.stopImmediatePropagation(),!1):void 0}),m.on("suggestion-selected",function(a){i(c,a)})}}}]),d.directive("tiAutocompleteMatch",["$sce","tiUtil",function(a,b){return{restrict:"E",require:"^autoComplete",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(c,d,e,f){var g=f.registerAutocompleteMatch(),h=g.getOptions();c.$$template=h.template,c.$index=c.$parent.$index,c.$highlight=function(c){return h.highlightMatchedText&&(c=b.safeHighlight(c,g.getQuery())),a.trustAsHtml(c)},c.$getDisplayText=function(){return b.safeToString(c.data[h.displayProperty||h.tagsInput.displayProperty])}}}}]),d.directive("tiTranscludeAppend",function(){return function(a,b,c,d,e){e(function(a){b.append(a)})}}),d.directive("tiAutosize",["tagsInputConfig",function(a){return{restrict:"A",require:"ngModel",link:function(b,c,d,e){var f,g,h=a.getTextAutosizeThreshold();f=angular.element('<span class="input"></span>'),f.css("display","none").css("visibility","hidden").css("width","auto").css("white-space","pre"),c.parent().append(f),g=function(a){var b,e=a;return angular.isString(e)&&0===e.length&&(e=d.placeholder),e&&(f.text(e),f.css("display",""),b=f.prop("offsetWidth"),f.css("display","none")),c.css("width",b?b+h+"px":""),a},e.$parsers.unshift(g),e.$formatters.unshift(g),d.$observe("placeholder",function(a){e.$modelValue||g(a)})}}}]),d.directive("tiBindAttrs",function(){return function(a,b,c){a.$watch(c.tiBindAttrs,function(a){angular.forEach(a,function(a,b){c.$set(b,a)})},!0)}}),d.provider("tagsInputConfig",function(){var a={},b={},c=3;this.setDefaults=function(b,c){return a[b]=c,this},this.setActiveInterpolation=function(a,c){return b[a]=c,this},this.setTextAutosizeThreshold=function(a){return c=a,this},this.$get=["$interpolate",function(d){var e={};return e[String]=function(a){return a},e[Number]=function(a){return parseInt(a,10)},e[Boolean]=function(a){return"true"===a.toLowerCase()},e[RegExp]=function(a){return new RegExp(a)},{load:function(c,f,g,h){var i=function(){return!0};f.options={},angular.forEach(h,function(h,j){var k,l,m,n,o,p;k=h[0],l=h[1],m=h[2]||i,n=e[k],o=function(){var b=a[c]&&a[c][j];return angular.isDefined(b)?b:l},p=function(a){f.options[j]=a&&m(a)?n(a):o()},b[c]&&b[c][j]?g.$observe(j,function(a){p(a),f.events.trigger("option-change",{name:j,newValue:a})}):p(g[j]&&d(g[j])(f.$parent))})},getTextAutosizeThreshold:function(){return c}}}]}),d.factory("tiUtil",["$timeout","$q",function(a,b){var c={};return c.debounce=function(b,c){var d;return function(){var e=arguments;a.cancel(d),d=a(function(){b.apply(null,e)},c)}},c.makeObjectArray=function(a,b){if(!angular.isArray(a)||0===a.length||angular.isObject(a[0]))return a;var c=[];return a.forEach(function(a){var d={};d[b]=a,c.push(d)}),c},c.findInObjectArray=function(a,b,d,e){var f=null;return e=e||c.defaultComparer,a.some(function(a){return e(a[d],b[d])?(f=a,!0):void 0}),f},c.defaultComparer=function(a,b){return c.safeToString(a).toLowerCase()===c.safeToString(b).toLowerCase()},c.safeHighlight=function(a,b){function d(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}if(a=c.encodeHTML(a),b=c.encodeHTML(b),!b)return a;var e=new RegExp("&[^;]+;|"+d(b),"gi");return a.replace(e,function(a){return a.toLowerCase()===b.toLowerCase()?"<em>"+a+"</em>":a})},c.safeToString=function(a){return angular.isUndefined(a)||null==a?"":a.toString().trim()},c.encodeHTML=function(a){return c.safeToString(a).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")},c.handleUndefinedResult=function(a,b){return function(){var c=a.apply(null,arguments);return angular.isUndefined(c)?b:c}},c.replaceSpacesWithDashes=function(a){return c.safeToString(a).replace(/\s/g,"-")},c.isModifierOn=function(a){return a.shiftKey||a.ctrlKey||a.altKey||a.metaKey},c.promisifyValue=function(a){return a=angular.isUndefined(a)?!0:a,b[a?"when":"reject"]()},c.simplePubSub=function(){var a={};return{on:function(b,c,d){return b.split(" ").forEach(function(b){a[b]||(a[b]=[]);var e=d?[].unshift:[].push;e.call(a[b],c)}),this},trigger:function(b,d){var e=a[b]||[];return e.every(function(a){return c.handleUndefinedResult(a,!0)(d)}),this}}},c}]),d.run(["$templateCache",function(a){a.put("ngTagsInput/tags-input.html",'<div class="host" tabindex="-1" ng-click="eventHandlers.host.click()" ti-transclude-append><div class="tags" ng-class="{focused: hasFocus}"><ul class="tag-list"><li class="tag-item" ng-repeat="tag in tagList.items track by track(tag)" ng-class="getTagClass(tag, $index)" ng-click="eventHandlers.tag.click(tag)"><ti-tag-item scope="templateScope" data="::tag"></ti-tag-item></li></ul><input class="input" autocomplete="off" ng-model="newTag.text" ng-model-options="{getterSetter: true}" ng-keydown="eventHandlers.input.keydown($event)" ng-focus="eventHandlers.input.focus($event)" ng-blur="eventHandlers.input.blur($event)" ng-paste="eventHandlers.input.paste($event)" ng-trim="false" ng-class="{\'invalid-tag\': newTag.invalid}" ng-disabled="disabled" ti-bind-attrs="{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}" ti-autosize></div></div>'),a.put("ngTagsInput/tag-item.html",'<span ng-bind="$getDisplayText()"></span> <a class="remove-button" ng-click="$removeTag()" ng-bind="::$$removeTagSymbol"></a>'),a.put("ngTagsInput/auto-complete.html",'<div class="autocomplete" ng-if="suggestionList.visible"><ul class="suggestion-list"><li class="suggestion-item" ng-repeat="item in suggestionList.items track by track(item)" ng-class="getSuggestionClass(item, $index)" ng-click="addSuggestionByIndex($index)" ng-mouseenter="suggestionList.select($index)"><ti-autocomplete-match scope="templateScope" data="::item"></ti-autocomplete-match></li></ul></div>'),a.put("ngTagsInput/auto-complete-match.html",'<span ng-bind-html="$highlight($getDisplayText())"></span>')}])}();

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	(function($, angular) {
	
	  // eslint-disable-next-line angular/file-name, angular/no-service-method
	  angular.module('ui.bootstrap.contextMenu', [])
	    .service('CustomService', function () {
	      'use strict';
	
	      return {
	        initialize: function (item) {
	          console.log('got here', item);
	        }
	      };
	
	    })
	    .constant('ContextMenuEvents', {
	      // Triggers when all the context menus have been closed
	      ContextMenuAllClosed: 'context-menu-all-closed',
	      // Triggers when any single conext menu is called.
	      // Closing all context menus triggers this for each level open
	      ContextMenuClosed: 'context-menu-closed',
	      // Triggers right before the very first context menu is opened
	      ContextMenuOpening: 'context-menu-opening',
	      // Triggers right after any context menu is opened
	      ContextMenuOpened: 'context-menu-opened'
	    })
	    .directive('contextMenu', ['$rootScope', 'ContextMenuEvents', '$parse', '$q', 'CustomService', '$sce', '$document', '$window', '$compile',
	      function ($rootScope, ContextMenuEvents, $parse, $q, custom, $sce, $document, $window, $compile) {
	
	        var _contextMenus = [];
	        // Contains the element that was clicked to show the context menu
	        var _clickedElement = null;
	        var DEFAULT_ITEM_TEXT = '"New Item';
	        var _emptyText = 'empty';
	
	        function createAndAddOptionText(params) {
	          // Destructuring:
	          var $scope = params.$scope;
	          var item = params.item;
	          var event = params.event;
	          var modelValue = params.modelValue;
	          var $promises = params.$promises;
	          var nestedMenu = params.nestedMenu;
	          var $li = params.$li;
	          var leftOriented = String(params.orientation).toLowerCase() === 'left';
	
	          var optionText = null;
	
	          if (item.html) {
	            if (angular.isFunction(item.html)) {
	              // runs the function that expects a jQuery/jqLite element
	              optionText = item.html($scope);
	            } else {
	              // Incase we want to compile html string to initialize their custom directive in html string
	              if (item.compile) {
	                optionText = $compile(item.html)($scope);
	              } else {
	                // Assumes that the developer already placed a valid jQuery/jqLite element
	                optionText = item.html;
	              }
	            }
	          } else {
	
	            var $a = $('<a>');
	            var $anchorStyle = {};
	
	            if (leftOriented) {
	              $anchorStyle.textAlign = 'right';
	              $anchorStyle.paddingLeft = '8px';
	            } else {
	              $anchorStyle.textAlign = 'left';
	              $anchorStyle.paddingRight = '8px';
	            }
	
	            $a.css($anchorStyle);
	            $a.addClass('dropdown-item');
	            $a.attr({ tabindex: '-1', href: '#' });
	
	            var textParam = item.text || item[0];
	            var text = DEFAULT_ITEM_TEXT;
	
	            if (typeof textParam === 'string') {
	              text = textParam;
	            } else if (typeof textParam === 'function') {
	              text = textParam.call($scope, $scope, event, modelValue);
	            }
	
	            var $promise = $q.when(text);
	            $promises.push($promise);
	            $promise.then(function (pText) {
	              if (nestedMenu) {
	                var $arrow;
	                var $boldStyle = {
	                  fontFamily: 'monospace',
	                  fontWeight: 'bold'
	                };
	
	                if (leftOriented) {
	                  $arrow = '&lt;';
	                  $boldStyle.float = 'left';
	                } else {
	                  $arrow = '&gt;';
	                  $boldStyle.float = 'right';
	                }
	
	                var $bold = $('<strong style="font-family:monospace;font-weight:bold;float:right;">' + $arrow + '</strong>');
	                $bold.css($boldStyle);
	                $a.css('cursor', 'default');
	                $a.append($bold);
	              }
	              $a.append(pText);
	            });
	
	            optionText = $a;
	          }
	
	          $li.append(optionText);
	
	          return optionText;
	        };
	
	        /**
	         * Process each individual item
	         *
	         * Properties of params:
	         * - $scope
	         * - event
	         * - modelValue
	         * - level
	         * - item
	         * - $ul
	         * - $li
	         * - $promises
	         */
	        function processItem(params) {
	          var nestedMenu = extractNestedMenu(params);
	
	          // if html property is not defined, fallback to text, otherwise use default text
	          // if first item in the item array is a function then invoke .call()
	          // if first item is a string, then text should be the string.
	
	          var text = DEFAULT_ITEM_TEXT;
	          var currItemParam = angular.extend({}, params);
	          var item = params.item;
	          var enabled = item.enabled === undefined ? item[2] : item.enabled;
	
	          currItemParam.nestedMenu = nestedMenu;
	          currItemParam.enabled = resolveBoolOrFunc(enabled, params);
	          currItemParam.text = createAndAddOptionText(currItemParam);
	
	          registerCurrentItemEvents(currItemParam);
	
	        };
	
	        /*
	         * Registers the appropriate mouse events for options if the item is enabled.
	         * Otherwise, it ensures that clicks to the item do not propagate.
	         */
	        function registerCurrentItemEvents (params) {
	          // Destructuring:
	          var item = params.item;
	          var $ul = params.$ul;
	          var $li = params.$li;
	          var $scope = params.$scope;
	          var modelValue = params.modelValue;
	          var level = params.level;
	          var event = params.event;
	          var text = params.text;
	          var nestedMenu = params.nestedMenu;
	          var enabled = params.enabled;
	          var orientation = String(params.orientation).toLowerCase();
	          var customClass = params.customClass;
	
	          if (enabled) {
	            var openNestedMenu = function ($event) {
	              removeContextMenus(level + 1);
	              /*
	               * The object here needs to be constructed and filled with data
	               * on an "as needed" basis. Copying the data from event directly
	               * or cloning the event results in unpredictable behavior.
	               */
	              /// adding the original event in the object to use the attributes of the mouse over event in the promises
	              var ev = {
	                pageX: orientation === 'left' ? event.pageX - $ul[0].offsetWidth + 1 : event.pageX + $ul[0].offsetWidth - 1,
	                pageY: $ul[0].offsetTop + $li[0].offsetTop - 3,
	                // eslint-disable-next-line angular/window-service
	                view: event.view || window,
	                target: event.target,
	                event: $event
	              };
	
	              /*
	               * At this point, nestedMenu can only either be an Array or a promise.
	               * Regardless, passing them to `when` makes the implementation singular.
	               */
	              $q.when(nestedMenu).then(function(promisedNestedMenu) {
	                if (angular.isFunction(promisedNestedMenu)) {
	                  //  support for dynamic subitems
	                  promisedNestedMenu = promisedNestedMenu.call($scope, $scope, event, modelValue, text, $li);
	                }
	                var nestedParam = {
	                  $scope : $scope,
	                  event : ev,
	                  options : promisedNestedMenu,
	                  modelValue : modelValue,
	                  level : level + 1,
	                  orientation: orientation,
	                  customClass: customClass
	                };
	                renderContextMenu(nestedParam);
	              });
	            };
	
	            $li.on('click', function ($event) {
	              if($event.which == 1) {
	                $event.preventDefault();
	                $scope.$apply(function () {
	
	                  var cleanupFunction = function () {
	                    $(event.currentTarget).removeClass('context');
	                    removeAllContextMenus();
	                  };
	                  var clickFunction = angular.isFunction(item.click)
	                    ? item.click
	                    : (angular.isFunction(item[1])
	                      ? item[1]
	                      : null);
	
	                  if (clickFunction) {
	                    var res = clickFunction.call($scope, $scope, event, modelValue, text, $li);
	                    if(res === undefined || res) {
	                      cleanupFunction();
	                    }
	                  } else {
	                    cleanupFunction();
	                  }
	                });
	              }
	            });
	
	            $li.on('mouseover', function ($event) {
	              $scope.$apply(function () {
	                if (nestedMenu) {
	                  openNestedMenu($event);
	                } else {
	                  removeContextMenus(level + 1);
	                }
	              });
	            });
	          } else {
	            setElementDisabled($li);
	          }
	        };
	
	        /**
	         * @param params - an object containing the `item` parameter
	         * @returns an Array or a Promise containing the children,
	         *          or null if the option has no submenu
	         */
	        function extractNestedMenu(params) {
	          // Destructuring:
	          var item = params.item;
	
	          // New implementation:
	          if (item.children) {
	            if (angular.isFunction(item.children)) {
	              // Expects a function that returns a Promise or an Array
	              return item.children();
	            } else if (angular.isFunction(item.children.then) || angular.isArray(item.children)) {
	              // Returns the promise
	              // OR, returns the actual array
	              return item.children;
	            }
	
	            return null;
	
	          } else {
	            // nestedMenu is either an Array or a Promise that will return that array.
	            // NOTE: This might be changed soon as it's a hangover from an old implementation
	
	            return angular.isArray(item[1]) ||
	                (item[1] && angular.isFunction(item[1].then)) ? item[1] : angular.isArray(item[2]) ||
	                (item[2] && angular.isFunction(item[2].then)) ? item[2] : angular.isArray(item[3]) ||
	                (item[3] && angular.isFunction(item[3].then)) ? item[3] : null;
	          }
	        }
	
	        /**
	         * Responsible for the actual rendering of the context menu.
	         *
	         * The parameters in params are:
	         * - $scope = the scope of this context menu
	         * - event = the event that triggered this context menu
	         * - options = the options for this context menu
	         * - modelValue = the value of the model attached to this context menu
	         * - level = the current context menu level (defauts to 0)
	         * - customClass = the custom class to be used for the context menu
	         */
	        function renderContextMenu (params) {
	          /// <summary>Render context menu recursively.</summary>
	
	          // Destructuring:
	          var $scope = params.$scope;
	          var event = params.event;
	          var options = params.options;
	          var modelValue = params.modelValue;
	          var level = params.level;
	          var customClass = params.customClass;
	
	          // Initialize the container. This will be passed around
	          var $ul = initContextMenuContainer(params);
	          params.$ul = $ul;
	
	          // Register this level of the context menu
	          _contextMenus.push($ul);
	
	          /*
	           * This object will contain any promises that we have
	           * to wait for before trying to adjust the context menu.
	           */
	          var $promises = [];
	          params.$promises = $promises;
	
	          angular.forEach(options, function (item) {
	
	            if (item === null) {
	              appendDivider($ul);
	            } else {
	              // If displayed is anything other than a function or a boolean
	              var displayed = resolveBoolOrFunc(item.displayed, params);
	
	              // Only add the <li> if the item is displayed
	              if (displayed) {
	                var $li = $('<li>');
	                var itemParams = angular.extend({}, params);
	                itemParams.item = item;
	                itemParams.$li = $li;
	
	                if (typeof item[0] === 'object') {
	                  custom.initialize($li, item);
	                } else {
	                  processItem(itemParams);
	                }
	                if (resolveBoolOrFunc(item.hasTopDivider, itemParams, false)) {
	                  appendDivider($ul);
	                }
	                $ul.append($li);
	                if (resolveBoolOrFunc(item.hasBottomDivider, itemParams, false)) {
	                  appendDivider($ul);
	                }
	              }
	            }
	          });
	
	          if ($ul.children().length === 0) {
	            var $emptyLi = angular.element('<li>');
	            setElementDisabled($emptyLi);
	            $emptyLi.html('<a>' + _emptyText + '</a>');
	            $ul.append($emptyLi);
	          }
	
	          $document.find('body').append($ul);
	
	          doAfterAllPromises(params);
	
	          $rootScope.$broadcast(ContextMenuEvents.ContextMenuOpened, {
	            context: _clickedElement,
	            contextMenu: $ul,
	            params: params
	          });
	        };
	
	        /**
	         * calculate if drop down menu would go out of screen at left or bottom
	         * calculation need to be done after element has been added (and all texts are set; thus the promises)
	         * to the DOM the get the actual height
	         */
	        function doAfterAllPromises (params) {
	
	          // Desctructuring:
	          var $ul = params.$ul;
	          var $promises = params.$promises;
	          var level = params.level;
	          var event = params.event;
	          var leftOriented = String(params.orientation).toLowerCase() === 'left';
	
	          $q.all($promises).then(function () {
	            var topCoordinate  = event.pageY;
	            var menuHeight = angular.element($ul[0]).prop('offsetHeight');
	            var winHeight = $window.pageYOffset + event.view.innerHeight;
	
	            /// the 20 pixels in second condition are considering the browser status bar that sometimes overrides the element
	            if (topCoordinate > menuHeight && winHeight - topCoordinate < menuHeight + 20) {
	              topCoordinate = event.pageY - menuHeight;
	              /// If the element is a nested menu, adds the height of the parent li to the topCoordinate to align with the parent
	              if(level && level > 0) {
	                topCoordinate += event.event.currentTarget.offsetHeight;
	              }
	            } else if(winHeight <= menuHeight) {
	              // If it really can't fit, reset the height of the menu to one that will fit
	              angular.element($ul[0]).css({ 'height': winHeight - 5, 'overflow-y': 'scroll' });
	              // ...then set the topCoordinate height to 0 so the menu starts from the top
	              topCoordinate = 0;
	            } else if(winHeight - topCoordinate < menuHeight) {
	              var reduceThresholdY = 5;
	              if(topCoordinate < reduceThresholdY) {
	                reduceThresholdY = topCoordinate;
	              }
	              topCoordinate = winHeight - menuHeight - reduceThresholdY;
	            }
	
	            var leftCoordinate = event.pageX;
	            var menuWidth = angular.element($ul[0]).prop('offsetWidth');
	            var winWidth = event.view.innerWidth + window.pageXOffset;
	            var padding = 5;
	
	            if (leftOriented) {
	              if (winWidth - leftCoordinate > menuWidth && leftCoordinate < menuWidth + padding) {
	                leftCoordinate = padding;
	              } else if (leftCoordinate < menuWidth) {
	                var reduceThresholdX = 5;
	                if (winWidth - leftCoordinate < reduceThresholdX + padding) {
	                  reduceThresholdX = winWidth - leftCoordinate + padding;
	                }
	                leftCoordinate = menuWidth + reduceThresholdX + padding;
	              } else {
	                leftCoordinate = leftCoordinate - menuWidth;
	              }
	            } else {
	              if (leftCoordinate > menuWidth && winWidth - leftCoordinate - padding < menuWidth) {
	                leftCoordinate = winWidth - menuWidth - padding;
	              } else if(winWidth - leftCoordinate < menuWidth) {
	                var reduceThresholdX = 5;
	                if(leftCoordinate < reduceThresholdX + padding) {
	                  reduceThresholdX = leftCoordinate + padding;
	                }
	                leftCoordinate = winWidth - menuWidth - reduceThresholdX - padding;
	              }
	            }
	
	            $ul.css({
	              display: 'block',
	              position: 'absolute',
	              left: leftCoordinate + 'px',
	              top: topCoordinate + 'px'
	            });
	          });
	
	        };
	
	        /**
	         * Creates the container of the context menu (a <ul> element),
	         * applies the appropriate styles and then returns that container
	         *
	         * @return a <ul> jqLite/jQuery element
	         */
	        function initContextMenuContainer(params) {
	          // Destructuring
	          var customClass = params.customClass;
	
	          var $ul = $('<ul>');
	          $ul.addClass('dropdown-menu');
	          $ul.attr({ 'role': 'menu' });
	          $ul.css({
	            display: 'block',
	            position: 'absolute',
	            left: params.event.pageX + 'px',
	            top: params.event.pageY + 'px',
	            'z-index': 10000
	          });
	
	          if(customClass) { $ul.addClass(customClass); }
	
	          return $ul;
	        }
	
	        function isTouchDevice() {
	          return 'ontouchstart' in window  || navigator.maxTouchPoints; // works on most browsers | works on IE10/11 and Surface
	        }
	
	        /**
	         * Removes the context menus with level greater than or equal
	         * to the value passed. If undefined, null or 0, all context menus
	         * are removed.
	         */
	        function removeContextMenus (level) {
	          while (_contextMenus.length && (!level || _contextMenus.length > level)) {
	            var cm = _contextMenus.pop();
	            $rootScope.$broadcast(ContextMenuEvents.ContextMenuClosed, { context: _clickedElement, contextMenu: cm });
	            cm.remove();
	          }
	          if(!level) {
	            $rootScope.$broadcast(ContextMenuEvents.ContextMenuAllClosed, { context: _clickedElement });
	          }
	        }
	
	        function removeOnScrollEvent(e) {
	          removeAllContextMenus(e);
	        }
	
	        function removeOnOutsideClickEvent(e) {
	
	          var $curr = $(e.target);
	          var shouldRemove = true;
	
	          while($curr.length) {
	            if ($curr.hasClass('dropdown-menu')) {
	              shouldRemove = false;
	              break;
	            } else {
	              $curr = $curr.parent();
	            }
	          }
	          if (shouldRemove) {
	            removeAllContextMenus(e);
	          }
	        }
	
	        function removeAllContextMenus(e) {
	          $document.find('body').off('mousedown touchstart', removeOnOutsideClickEvent);
	          $document.off('scroll', removeOnScrollEvent);
	          $(_clickedElement).removeClass('context');
	          removeContextMenus();
	          $rootScope.$broadcast('');
	        }
	
	        function isBoolean(a) {
	          return a === false || a === true;
	        }
	
	        /** Resolves a boolean or a function that returns a boolean
	         * Returns true by default if the param is null or undefined
	         * @param a - the parameter to be checked
	         * @param params - the object for the item's parameters
	         * @param defaultValue - the default boolean value to use if the parameter is
	         *  neither a boolean nor function. True by default.
	         */
	        function resolveBoolOrFunc(a, params, defaultValue) {
	          var item = params.item;
	          var $scope = params.$scope;
	          var event = params.event;
	          var modelValue = params.modelValue;
	
	          defaultValue = isBoolean(defaultValue) ? defaultValue : true;
	
	          if (isBoolean(a)) {
	            return a;
	          } else if (angular.isFunction(a)) {
	            return a.call($scope, $scope, event, modelValue);
	          } else {
	            return defaultValue;
	          }
	        }
	
	        function appendDivider($ul) {
	          var $li = angular.element('<li>');
	          $li.addClass('divider');
	          $ul.append($li);
	        }
	
	        function setElementDisabled($li) {
	          $li.on('click', function ($event) {
	            $event.preventDefault();
	          });
	          $li.addClass('disabled');
	        }
	
	        return function ($scope, element, attrs) {
	          var openMenuEvents = ['contextmenu'];
	          _emptyText = $scope.$eval(attrs.contextMenuEmptyText) || 'empty';
	
	          if(attrs.contextMenuOn && typeof(attrs.contextMenuOn) === 'string'){
	            openMenuEvents = attrs.contextMenuOn.split(',');
	          }
	
	          angular.forEach(openMenuEvents, function (openMenuEvent) {
	            element.on(openMenuEvent.trim(), function (event) {
	              // Cleanup any leftover contextmenus(there are cases with longpress on touch where we
	              // still see multiple contextmenus)
	              removeAllContextMenus();
	
	              if(!attrs.allowEventPropagation) {
	                event.stopPropagation();
	                event.preventDefault();
	              }
	
	              // Don't show context menu if on touch device and element is draggable
	              if(isTouchDevice() && element.attr('draggable') === 'true') {
	                return false;
	              }
	
	              // Remove if the user clicks outside
	              $document.find('body').on('mousedown touchstart', removeOnOutsideClickEvent);
	              // Remove the menu when the scroll moves
	              $document.on('scroll', removeOnScrollEvent);
	
	              _clickedElement = event.currentTarget;
	              $(_clickedElement).addClass('context');
	
	              $scope.$apply(function () {
	                var options = $scope.$eval(attrs.contextMenu);
	                var customClass = attrs.contextMenuClass;
	                var modelValue = $scope.$eval(attrs.model);
	                var orientation = attrs.contextMenuOrientation;
	
	                $q.when(options).then(function(promisedMenu) {
	                  if (angular.isFunction(promisedMenu)) {
	                    //  support for dynamic items
	                    promisedMenu = promisedMenu.call($scope, $scope, event, modelValue);
	                  }
	                  var params = {
	                    '$scope' : $scope,
	                    'event' : event,
	                    'options' : promisedMenu,
	                    'modelValue' : modelValue,
	                    'level' : 0,
	                    'customClass' : customClass,
	                    'orientation': orientation
	                  };
	                  $rootScope.$broadcast(ContextMenuEvents.ContextMenuOpening, { context: _clickedElement });
	                  renderContextMenu(params);
	                });
	              });
	
	              // Remove all context menus if the scope is destroyed
	              $scope.$on('$destroy', function () {
	                removeAllContextMenus();
	              });
	            });
	          });
	
	          if (attrs.closeMenuOn) {
	            $scope.$on(attrs.closeMenuOn, function () {
	              removeAllContextMenus();
	            });
	          }
	        };
	      }]);
	// eslint-disable-next-line angular/window-service
	})(window.angular.element, window.angular);


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(18);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(20);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(22);
	
	var _router = __webpack_require__(23);
	
	var _auth = __webpack_require__(24);
	
	var _user = __webpack_require__(27);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('calApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.constants', []).constant('appConfig', __webpack_require__(19)).name;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin'],
	  isSandbox: global.isSandbox,
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('main');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'calendar' : 'main');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('main');
	      });
	    }
	  });
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(25);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(29);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _settings = __webpack_require__(32);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _signup = __webpack_require__(34);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.account', [_angularUiRouter2.default, _settings2.default, _signup2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      'ngInject';
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      Auth.logout();
	      $state.go(referrer);
	    }]
	  }).state('signup', {
	    url: '/signup',
	    template: __webpack_require__(30),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(31),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <h1>Sign up</h1>\r\n    </div>\r\n    <div class=\"col-sm-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && vm.submitted,\r\n                                            'has-error': form.name.$invalid && vm.submitted }\">\r\n          <label>Name</label>\r\n\r\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.user.name\"\r\n                 required/>\r\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">\r\n            A name is required\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\r\n                                            'has-error': form.email.$invalid && vm.submitted }\">\r\n          <label>Email</label>\r\n\r\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\"\r\n                 required\r\n                 mongoose-error/>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\r\n            Doesn't look like a valid email.\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\r\n            What's your email address?\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">\r\n            {{ vm.errors.email }}\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\r\n                                            'has-error': form.password.$invalid && vm.submitted }\">\r\n          <label>Password</label>\r\n\r\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\"\r\n                 ng-minlength=\"3\"\r\n                 required\r\n                 mongoose-error/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"(form.password.$error.minlength || form.password.$error.required) && vm.submitted\">\r\n            Password must be at least 3 characters.\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\r\n            {{ vm.errors.password }}\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\r\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\r\n          <label>Confirm Password</label>\r\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\r\n                 match=\"vm.user.password\"\r\n                 ng-minlength=\"3\" required/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\r\n            Passwords must match.\r\n          </p>\r\n        </div>\r\n\r\n        <div>\r\n          <button class=\"btn btn-inverse btn-lg btn-register\" type=\"submit\">\r\n            Sign up\r\n          </button>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </div>\r\n  <hr>\r\n</div>\r\n"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <h1>Change Password</h1>\r\n    </div>\r\n    <div class=\"col-sm-12\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\r\n\r\n        <div class=\"form-group\">\r\n          <label>Current Password</label>\r\n\r\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\r\n                 mongoose-error/>\r\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\r\n              {{ vm.errors.other }}\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label>New Password</label>\r\n\r\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\r\n                 ng-minlength=\"3\"\r\n                 required/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\r\n            Password must be at least 3 characters.\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n          <label>Confirm New Password</label>\r\n\r\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\r\n                 match=\"vm.user.newPassword\"\r\n                 ng-minlength=\"3\"\r\n                 required=\"\"/>\r\n          <p class=\"help-block\"\r\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\r\n            Passwords must match.\r\n          </p>\r\n\r\n        </div>\r\n\r\n        <p class=\"help-block\"> {{ vm.message }} </p>\r\n\r\n        <button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(33);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(35);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  SignupController.$inject = ['Auth', '$state'];
	  function SignupController(Auth, $state) {
	    _classCallCheck(this, SignupController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {};
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(SignupController, [{
	    key: 'register',
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        return this.Auth.createUser({
	          name: this.user.name,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          _angular2.default.forEach(err.errors, function (error, field) {
	            form[field].$setValidity('mongoose', false);
	            _this.errors[field] = error.message;
	          });
	        });
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(37);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _student = __webpack_require__(45);
	
	var _student2 = _interopRequireDefault(_student);
	
	var _tutor = __webpack_require__(46);
	
	var _tutor2 = _interopRequireDefault(_tutor);
	
	var _settings = __webpack_require__(47);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _colourSearch = __webpack_require__(48);
	
	var _colourSearch2 = _interopRequireDefault(_colourSearch);
	
	var _studentInfo = __webpack_require__(49);
	
	var _studentInfo2 = _interopRequireDefault(_studentInfo);
	
	var _exportTutor = __webpack_require__(50);
	
	var _exportTutor2 = _interopRequireDefault(_exportTutor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.admin', ['calApp.auth', 'ui.router']).config(_admin2.default).controller('StudentController', _student2.default).controller('TutorController', _tutor2.default).controller('SettingsController', _settings2.default).controller('ColourSearchController', _colourSearch2.default).controller('StudentInfoController', _studentInfo2.default).controller('ExportTutorController', _exportTutor2.default).name;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: __webpack_require__(38),
	    authenticate: 'admin'
	  }).state('admin.student', {
	    url: '/student',
	    template: __webpack_require__(39),
	    controller: 'StudentController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  }).state('admin.tutor', {
	    url: '/tutor',
	    template: __webpack_require__(40),
	    controller: 'TutorController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  }).state('admin.settings', {
	    url: '/settings',
	    template: __webpack_require__(41),
	    controller: 'SettingsController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  }).state('admin.colourSearch', {
	    url: '/colour-search',
	    template: __webpack_require__(42),
	    controller: 'ColourSearchController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  }).state('admin.studentInfo', {
	    url: '/student-info',
	    template: __webpack_require__(43),
	    controller: 'StudentInfoController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  }).state('admin.exportTutor', {
	    url: '/export-tutor',
	    template: __webpack_require__(44),
	    controller: 'ExportTutorController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\" ui-view>\r\n</div>\r\n"

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <h1>Students\r\n      <button type=\"button\" class=\"btn btn-lg btn-default pull-right\" ng-click=\"admin.export(admin.students)\"\r\n        ng-disabled=\"!admin.students\">Export All</button>\r\n      <button type=\"button\" class=\"btn btn-lg btn-default pull-right\" style=\"margin-right: 10px\"\r\n        ng-click=\"admin.export(admin.actives)\" ng-disabled=\"!admin.actives\">Export Active</button>\r\n    </h1>\r\n  </div>\r\n</div>\r\n<br>\r\n<hr>\r\n<form ng-submit=\"admin.addStudent(newStudent); newStudent={}; notes = false;\" ng-init=\"newStudent = {}\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>First Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"newStudent.firstName\" placeholder=\"First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"newStudent.lastName\" placeholder=\"First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Data</label>\r\n        <div class=\"data-button-wrap\">\r\n          <button type=\"button\" ng-init=\"newStudent.var3 = false\" ng-click=\"newStudent.var3 =! newStudent.var3\"\r\n            ng-class=\"{'active': newStudent.var3}\"><i class=\"fa fa-{{admin.icons.third}}\"\r\n              aria-hidden=\"true\"></i></button>\r\n          <button type=\"button\" ng-init=\"newStudent.var4 = false\" ng-click=\"newStudent.var4 =! newStudent.var4\"\r\n            ng-class=\"{'active': newStudent.var4}\"><i class=\"fa fa-{{admin.icons.fourth}}\"\r\n              aria-hidden=\"true\"></i></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Grade</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"number\" class=\"form-control\" ng-min=\"1\" ng-max=\"12\" placeholder=\"Grade\"\r\n            ng-model=\"newStudent.grade\" ng-disabled=\"newStudent.isTertiary\" ng-required=\"!newStudent.isTertiary\">\r\n          <span class=\"input-group-addon tertiary\" ng-click=\"newStudent.isTertiary = !newStudent.isTertiary\"\r\n            ng-class=\"{'active': newStudent.isTertiary}\" title=\"Is this a tertiary student?\">\r\n            <i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Client First Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"newStudent.clientFirstName\" placeholder=\"Client First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Client Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"newStudent.clientLastName\" placeholder=\"Client Last Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>CRM ID</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"newStudent.crmID\" placeholder=\"CRM ID\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Price</label>\r\n        <select class=\"form-control\" required ng-model=\"newStudent.price\" placeholder=\"Price\">\r\n          <option ng-value=\"price\" ng-repeat=\"price in admin.prices\">{{price}}</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n \r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Contact Email</label>\r\n        <input type=\"email\" class=\"form-control\" ng-model=\"newStudent.clientEmail\" placeholder=\"Contact Email\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Contact PH</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"newStudent.clientPh\" placeholder=\"Contact PH\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Subjects</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"newStudent.subjects\" placeholder=\"Subjects\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" ng-show=\"notes\">\r\n    <div class=\"col-sm-12\">\r\n      <div class=\"form-group\">\r\n        <label>Student Notes</label>\r\n        <textarea class=\"form-control\" ng-model=\"newStudent.studentNotes\" rows=\"4\"></textarea>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group add-notes-group\">\r\n        <button type=\"button\" class=\"btn btn-primary btn-lg btn-block\" ng-init=\"notes = false\"\r\n          ng-click=\"notes =! notes\">Add Notes</button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-8\">\r\n      <div class=\"form-group add-notes-group\">\r\n        <button type=\"submit\" class=\"btn btn-success btn-lg btn-block\">Add Student</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n</form>\r\n<hr>\r\n<div class=\"row\">\r\n  <div class=\"col-sm-9\">\r\n    <div class=\"form-group\">\r\n      <input type=\"search\" class=\"form-control\" ng-model=\"admin.search\" placeholder=\"Search here...\">\r\n    </div>\r\n  </div>\r\n  <div class=\"col-sm-3 text-right\">\r\n    <div ng-init=\"currentPage = 0; pageSize = 100;\">\r\n      <button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\">\r\n        Previous\r\n      </button>\r\n      {{currentPage + 1}}/{{(admin.students.length/pageSize | roundUp) || 1}}\r\n      <button class=\"btn btn-default\" ng-disabled=\"currentPage >= admin.students.length/pageSize - 1\"\r\n        ng-click=\"currentPage=currentPage+1\">\r\n        Next\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<table class=\"table table-striped\">\r\n  <thead>\r\n    <tr>\r\n      <th>#</th>\r\n      <th>Student Name</th>\r\n      <th>Client Name</th>\r\n      <th>CRM ID</th>\r\n      <th>Grade\r\n        <span class=\"glyphicon glyphicon-arrow-up\" aria-hidden=\"true\" ng-click=\"tableOrder = 'grade'\"></span>\r\n        <span class=\"glyphicon glyphicon-arrow-down\" aria-hidden=\"true\" ng-click=\"tableOrder = '-grade'\"></span></th>\r\n      <th>Email</th>\r\n      <th>Phone</th>\r\n      <th>Data</th>\r\n      <th>Actions</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody ng-init=\"tableOrder = '-dateCreated'\">\r\n    <tr\r\n      ng-repeat=\"student in admin.students | filter: admin.search | startFrom:currentPage*pageSize | limitTo:pageSize | orderBy: tableOrder\">\r\n      <th scope=\"row\">{{$index + 1}}</th>\r\n      <td>{{student.firstName + ' ' + student.lastName}}</td>\r\n      <td>{{student.clientFirstName + ' ' + student.clientLastName}}</td>\r\n      <td>{{student.crmID}}</td>\r\n      <td>{{student.isTertiary ? 'T' : student.grade}}</td>\r\n      <td>{{student.clientEmail}}</td>\r\n      <td>{{student.clientPh}}</td>\r\n      <td>\r\n        <div class=\"data-button-wrap\">\r\n          <div ng-class=\"{'active': student.var3}\">\r\n            <i class=\"fa fa-{{admin.icons.third}}\" aria-hidden=\"true\"></i>\r\n          </div>\r\n          <div ng-class=\"{'active': student.var4}\">\r\n            <i class=\"fa fa-{{admin.icons.fourth}}\" aria-hidden=\"true\"></i>\r\n          </div>\r\n        </div>\r\n      </td>\r\n      <td><button class=\"btn btn-default edit-button\" ng-click=\"admin.openModal(student)\">Edit</button></td>\r\n    </tr>\r\n  </tbody>\r\n</table>"

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <h1>Tutors<button type=\"button\" class=\"btn btn-lg btn-default pull-right\" ng-click=\"admin.export(admin.tutors)\">Export All</button></h1>\r\n  </div>\r\n</div>\r\n<br>\r\n<hr>\r\n<form ng-submit=\"admin.addTutor(newTutor); newTutor={}; notes = false;\" ng-init=\"newTutor = {}\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n      <div class=\"form-group\">\r\n        <label>First Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"newTutor.firstName\" placeholder=\"First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div class=\"form-group\">\r\n        <label>Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"newTutor.lastName\" placeholder=\"First Name\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n      <div class=\"form-group\">\r\n        <label>Phone</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"newTutor.phone\" placeholder=\"Phone\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div class=\"form-group\">\r\n        <label>Email Address</label>\r\n        <input type=\"email\" class=\"form-control\" ng-model=\"newTutor.email\" placeholder=\"Email Address\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <button type=\"submit\" class=\"btn btn-success btn-lg btn-block\">Add Tutor</button>\r\n    </div> \r\n  </div>\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n</form>\r\n<hr>\r\n<div class=\"row\">\r\n  <div class=\"col-sm-9\">\r\n    <div class=\"form-group\">\r\n      <input type=\"search\" class=\"form-control\" ng-model=\"admin.search\" placeholder=\"Search here...\">\r\n    </div>\r\n  </div>\r\n  <div class=\"col-sm-3 text-right\">\r\n    <div ng-init=\"currentPage = 0; pageSize = 100;\">\r\n      <button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\">\r\n        Previous\r\n      </button>\r\n      {{currentPage + 1}}/{{(admin.tutors.length/pageSize | roundUp) || 1}}\r\n      <button class=\"btn btn-default\" ng-disabled=\"currentPage >= admin.tutors.length/pageSize - 1\" ng-click=\"currentPage=currentPage+1\">\r\n        Next\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<table class=\"table table-striped\">\r\n  <thead>\r\n    <tr>\r\n      <th>#</th>\r\n      <th>Name</th>\r\n      <th>Email</th>\r\n      <th>Phone</th>\r\n      <th>Date Added</th>\r\n      <th>Actions</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr ng-repeat=\"tutor in admin.tutors | filter: admin.search | startFrom:currentPage*pageSize | limitTo:pageSize | orderBy: 'dateCreated'\">\r\n      <th scope=\"row\">{{$index + 1}}</th>\r\n      <td>{{tutor.firstName + ' ' + tutor.lastName}}</td>\r\n      <td>{{tutor.email}}</td>\r\n      <td>{{tutor.phone}}</td>\r\n      <td>{{tutor.dateCreated | date:'dd/MM/yyyy'}}</td>\r\n      <td>\r\n        <button class=\"btn btn-default edit-button\" ng-click=\"admin.toggleActive(tutor)\">{{tutor.isActive ? 'Inactivate' : 'Activate'}}</button>\r\n        <button class=\"btn btn-default edit-button\" ng-click=\"admin.openModal(tutor)\">Edit</button>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table>"

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <h1>Settings</h1>\r\n  </div>\r\n</div>\r\n<br>\r\n<hr>\r\n<div>\r\n  <h4>Student Settings</h4>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n      <button type=\"button\" ng-click=\"admin.addYear()\" class=\"btn btn-default btn-lg\" style=\"margin-top: 20px\">Start New School Year</button>\r\n    </div>\r\n    <div class=\"col-md-6\" ng-if=\"admin.isSandbox\">\r\n      <h4>Database Settings</h4>\r\n      <button type=\"button\" ng-click=\"admin.resetDatabase()\" class=\"btn btn-default btn-lg\" style=\"margin-top: 20px;\">Reset Database</button>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<hr>\r\n<div>\r\n  <h4>Term Settings</h4>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Term</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"admin.term.termNo\" placeholder=\"Term\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Start Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\" required ng-model=\"admin.term.startDate\" placeholder=\"Start Date\" is-open=\"opened\" close-text=\"Close\">\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>End Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\" required ng-model=\"admin.term.endDate\" placeholder=\"End Date\" is-open=\"opened2\" close-text=\"Close\">\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened2 = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>6th Sunday of Term</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" required ng-model=\"admin.term.sixthSunday\" placeholder=\"6th Sunday of Term\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label style=\"opacity: 0\">Save Term Details</label>\r\n        <button type=\"button\" class=\"btn btn-success btn-block\" ng-disabled=\"!admin.term.termNo || !admin.term.startDate || !admin.term.endDate || !admin.term.sixthSunday\" ng-click=\"admin.updateSettings()\">\r\n          <span>Save</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label style=\"opacity: 0\">Generate Emails</label>\r\n        <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"admin.generateEmails()\">\r\n          <span>Generate Emails</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div>\r\n    <div class=\"alert alert-danger\" ng-show=\"admin.term.fail\">\r\n      There was an error. Please refresh and try again.\r\n    </div>\r\n    <div class=\"alert alert-success\" ng-show=\"admin.term.success\">\r\n      Term settings successfully updated.\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<hr>\r\n<div>\r\n  <h4>SMS Settings</h4>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Mobile Number 1 (default)</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"admin.smssettings.mobileNumber1\" placeholder=\"Default Number\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Mobile Number 2</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"admin.smssettings.mobileNumber2\" placeholder=\"Mobile Number 2\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Mobile Number 3</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"admin.smssettings.mobileNumber3\" placeholder=\"Mobile Number 3\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label style=\"opacity: 0\">Update SMS Sender Information</label>\r\n        <button type=\"button\" class=\"btn btn-success btn-block\" ng-disabled=\"!admin.smssettings.mobileNumber1 || !admin.smssettings.mobileNumber2 || !admin.smssettings.mobileNumber3\" ng-click=\"admin.updateSMSSettings()\">\r\n          <span>Update</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div>\r\n    <div class=\"alert alert-danger\" ng-show=\"admin.smssettings.fail\">\r\n      There was an error. Please refresh and try again.\r\n    </div>\r\n    <div class=\"alert alert-success\" ng-show=\"admin.smssettings.success\">\r\n      SMS settings successfully updated.\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<hr>\r\n  <div>\r\n    <h4>Icon Settings</h4>\r\n    <p>Only use the name of the icon, i.e., don't include 'fa'. <a href=\"http://fontawesome.io/icons/\" target=\"_blank\">Click here for a list of icons.</a></p>\r\n    <form ng-submit=\"admin.saveIcons()\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>First Icon (temp) (lesson)</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.first\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Second Icon (temp) (lesson)</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.second\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Third Icon (permanent) (student)</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.third\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Fourth Icon (permanent) (student)</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.fourth\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Fifth Icon (temp) (lesson)</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.fifth\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Sixth Icon (temp) (lesson)</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.sixth\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Year 12 Icon</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons.year12\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Temporary Icon : Unknown</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons._tempUnknown\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Permanent Icon : Unknown</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons._permUnknown\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Permanent Icon 2 : Unknown</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons._perm2Unknown\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <div class=\"form-group\">\r\n            <label>Notes</label>\r\n            <input class=\"form-control\" type=\"text\" ng-model=\"admin.icons._note\" required placeholder=\"'Phone', 'Cross', etc.\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <div class=\"alert alert-danger\" ng-show=\"admin.fail\">\r\n          There was an error. Please refresh and try again.\r\n        </div>\r\n        <div class=\"alert alert-success\" ng-show=\"admin.success\">\r\n          Icons successfully updated.\r\n        </div>\r\n      </div>\r\n      <div class=\"text-right\">\r\n        <button class=\"btn btn-success\" type=\"submit\">Save Icons</button>\r\n      </div>\r\n    </form>\r\n  </div>\r\n  <div class=\"loading-wrap\" ng-show=\"admin.loading\">\r\n    <svg id=\"load\" x=\"0px\" y=\"0px\" viewBox=\"0 0 150 150\">\r\n        <circle id=\"loading-inner\" cx=\"75\" cy=\"75\" r=\"60\"/>\r\n    </svg>\r\n  </div>\r\n"

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <h1>Colour Search<button type=\"button\" class=\"btn btn-lg btn-default pull-right\" ng-disabled=\"!admin.less || !admin.less.length\" ng-click=\"admin.export(admin.less)\">Export Data</button></h1>\r\n  </div>\r\n</div>\r\n<br>\r\n<hr>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Colour</label>\r\n        <select class=\"form-control\" required ng-model=\"admin.search.colour\" placeholder=\"Select a colour\">\r\n          <option ng-value=\"colour\" ng-repeat=\"colour in admin.colours\">{{colour}}</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Start Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\"  required ng-model=\"admin.search.start\" placeholder=\"Start Date\" is-open=\"opened\" close-text=\"Close\" >\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>End Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\"  required ng-model=\"admin.search.end\" placeholder=\"Start Date\" is-open=\"opened2\" close-text=\"Close\" >\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened2 = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label style=\"opacity: 0\">Start Date</label>\r\n        <button type=\"button\" class=\"btn btn-success btn-block\" ng-disabled=\"!admin.search.start || !admin.search.end || !admin.search.colour || !admin.search.colour[0]\" ng-click=\"admin.processLessons()\">\r\n          <span>Search</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n<hr>\r\n<table class=\"table table-striped\">\r\n  <thead>\r\n    <tr>\r\n      <th>Student Name</th>\r\n      <th>Occurences</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr ng-repeat=\"lesson in admin.less\">\r\n      <td>{{lesson.student.firstName + ' ' + lesson.student.lastName}}</td>\r\n      <td>{{lesson.found}}</td>\r\n    </tr>\r\n    <tr>\r\n      <th>Total</th>\r\n      <th>{{admin.total}}</th>\r\n    </tr>\r\n  </tbody>\r\n</table>\r\n"

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <h1>Student Report</h1>\r\n  </div>\r\n</div>\r\n<br>\r\n<hr>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Student Name</label>\r\n        <tags-input ng-model=\"admin.search.student\"\r\n                name=\"selectedStudent\"\r\n                placeholder=\" \"\r\n                add-from-autocomplete-only=\"true\"\r\n                replace-spaces-with-dashes=\"false\"\r\n                display-property=\"fullName\">\r\n          <auto-complete source=\"admin.returnFilter(admin.students, $query)\" \r\n                       min-length=\"1\" ></auto-complete>\r\n        </tags-input>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Start Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\"  required ng-model=\"admin.search.start\" placeholder=\"Start Date\" is-open=\"opened\" close-text=\"Close\" >\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>End Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\"  required ng-model=\"admin.search.end\" placeholder=\"Start Date\" is-open=\"opened2\" close-text=\"Close\" >\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened2 = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <label style=\"opacity: 0\">start</label>\r\n      <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"admin.processLessons()\" ng-disabled=\"!admin.search.end || !admin.search.start || !admin.search.student || !admin.search.student[0]\">\r\n      <span>Search</span>\r\n    </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n<hr>\r\n<table class=\"table table-striped\">\r\n  <thead>\r\n    <tr>\r\n      <th>Colour</th>\r\n      <th>Count</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr ng-repeat=\"count in admin.counts\">\r\n      <td style=\"text-transform: capitalize;\">{{count[0]}}</td>\r\n      <td>{{count[1]}}</td>\r\n    </tr>\r\n    <tr>\r\n      <th>Total</th>\r\n      <th>{{admin.total}}</th>\r\n    </tr>\r\n  </tbody>\r\n</table>\r\n"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <h1>Tutor Report<button type=\"button\" class=\"btn btn-lg btn-default pull-right\" ng-disabled=\"!admin.less || !admin.less.length\" ng-click=\"admin.export(admin.less)\">Export Data</button></h1>\r\n  </div>\r\n</div>\r\n<br>\r\n<hr>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Tutor Name</label>\r\n        <tags-input ng-model=\"admin.search.tutor\"\r\n                placeholder=\" \"\r\n                add-from-autocomplete-only=\"true\"\r\n                replace-spaces-with-dashes=\"false\"\r\n                display-property=\"fullName\">\r\n          <auto-complete source=\"admin.returnFilter(admin.tutors, $query)\" \r\n                       min-length=\"1\" ></auto-complete>\r\n        </tags-input>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>Start Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\"  required ng-model=\"admin.search.start\" placeholder=\"Start Date\" is-open=\"opened\" close-text=\"Close\" >\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label>End Date</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/y\"  required ng-model=\"admin.search.end\" placeholder=\"Start Date\" is-open=\"opened2\" close-text=\"Close\" >\r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened2 = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-3\">\r\n      <div class=\"form-group\">\r\n        <label style=\"opacity: 0\">Terms</label><br>\r\n        <button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"admin.submit()\">\r\n          <span>Search</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n  <div>\r\n    \r\n  </div>\r\n<hr>\r\n<table class=\"table table-striped\">\r\n  <thead>\r\n    <tr>\r\n      <th>Student Name</th>\r\n      <th>Total Time</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr ng-repeat=\"lesson in admin.less\">\r\n      <td>{{lesson.student.fullName}}</td>\r\n      <td>{{lesson.totalTime}}</td>\r\n    </tr>\r\n    <tr>\r\n      <th>Total</th>\r\n      <th>{{admin.totalTime || 0}}</th>\r\n    </tr>\r\n  </tbody>\r\n</table>\r\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StudentController = function () {
	
	  /*@ngInject*/
	  StudentController.$inject = ['$http', '$scope', 'Modal', 'JSONToCSVConvertor'];
	  function StudentController($http, $scope, Modal, JSONToCSVConvertor) {
	    _classCallCheck(this, StudentController);
	
	    this.$http = $http;
	    this.Modal = Modal;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	  }
	
	  _createClass(StudentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.grab();
	
	      this.$http.get('/api/students/active').then(function (response) {
	        _this.actives = response.data;
	      });
	
	      this.$http.get('/api/icons').then(function (response) {
	        _this.icons = response.data[0] || {
	          first: '',
	          second: '',
	          third: '',
	          fourth: '',
	          year12: ''
	        };
	      });
	      this.prices = ['$60', '$70', '$80'];
	    }
	  }, {
	    key: 'export',
	    value: function _export(data) {
	
	      data = data.map(function (student) {
	        return {
	          'Full Name': student.firstName + ' ' + student.lastName,
	          'First Name': student.firstName || ' ',
	          'Last Name': student.lastName || ' ',
	          'Client Full Name': student.clientFirstName + ' ' + student.clientLastName,
	          'Client First Name': student.clientFirstName || ' ',
	          'Client Last Name': student.clientLastName || ' ',
	          'Email': student.clientEmail || ' ',
	          'Phone': student.clientPh || ' ',
	          'Grade': student.grade || ' ',
	          'Subjects': student.subjects || ' ',
	          'CRM ID': student.crmID || ' ',
	          'Is Active': student.isActive || 'false',
	          'Is Tertiary': student.isTertiary || 'false'
	        };
	      });
	
	      this.JSONToCSVConvertor(data, 'Student Export', true);
	    }
	  }, {
	    key: 'grab',
	    value: function grab() {
	      var _this2 = this;
	
	      this.$http.get('/api/students').then(function (response) {
	        _this2.students = response.data;
	      });
	    }
	  }, {
	    key: 'mergeNames',
	    value: function mergeNames(student) {
	      var name = student.firstName + ' ' + student.lastName;
	      if (student.clientFirstName || student.clientLastName) {
	        name += ' - ' + student.clientFirstName + ' ' + student.clientLastName;
	      }
	      return name;
	    }
	  }, {
	    key: 'addStudent',
	    value: function addStudent(newStudent) {
	      var _this3 = this;
	
	      if (newStudent) {
	        newStudent.fullName = this.mergeNames(newStudent);
	        this.$http.post('/api/students', newStudent).then(function (res) {
	          _this3.grab();
	          _this3.error = '';
	        }).catch(function (res) {
	          _this3.error = JSON.stringify(res.data, null, '\t');
	        });
	      }
	    }
	  }, {
	    key: 'patchStudent',
	    value: function patchStudent(student, callback) {
	      var _this4 = this;
	
	      if (student) {
	        student.fullName = this.mergeNames(student);
	        this.$http.put('/api/students/' + String(student._id), student).then(function (res) {
	          _this4.grab();
	          _this4.error = '';
	          callback();
	        }).catch(function (res) {
	          console.log(res);
	          _this4.error = JSON.stringify(res.data, null, '\t');
	        });
	      }
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(student) {
	      this.Modal.editStudent(student);
	    }
	  }]);
	
	  return StudentController;
	}();
	
	exports.default = StudentController;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TutorController = function () {
	
	  /*@ngInject*/
	  TutorController.$inject = ['$http', '$scope', 'Modal', 'JSONToCSVConvertor'];
	  function TutorController($http, $scope, Modal, JSONToCSVConvertor) {
	    _classCallCheck(this, TutorController);
	
	    this.$http = $http;
	    this.Modal = Modal;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	  }
	
	  _createClass(TutorController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.grab();
	    }
	  }, {
	    key: 'grab',
	    value: function grab() {
	      var _this = this;
	
	      this.$http.get('/api/tutors').then(function (response) {
	        _this.tutors = response.data;
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(data) {
	      this.JSONToCSVConvertor(data, 'Tutor Export', true);
	    }
	  }, {
	    key: 'addTutor',
	    value: function addTutor(newTutor) {
	      var _this2 = this;
	
	      if (newTutor) {
	        newTutor.fullName = newTutor.firstName + ' ' + newTutor.lastName;
	        this.$http.post('/api/tutors', newTutor).then(function (res) {
	          _this2.grab();
	          _this2.error = '';
	        }).catch(function (res) {
	          _this2.error = JSON.stringify(res.data, null, '\t');
	        });
	      }
	    }
	  }, {
	    key: 'toggleActive',
	    value: function toggleActive(tutor) {
	      tutor.isActive = !tutor.isActive;
	      this.$http.put('/api/tutors/' + String(tutor._id), { isActive: tutor.isActive });
	    }
	  }, {
	    key: 'patchTutor',
	    value: function patchTutor(tutor, callback) {
	      var _this3 = this;
	
	      if (tutor) {
	        tutor.fullName = tutor.firstName + ' ' + tutor.lastName;
	        this.$http.put('/api/tutors/' + String(tutor._id), tutor).then(function (res) {
	          _this3.grab();
	          _this3.error = '';
	          callback();
	        }).catch(function (res) {
	          _this3.error = JSON.stringify(res.data, null, '\t');
	        });
	      }
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(tutor) {
	      this.Modal.editTutor(tutor);
	    }
	  }]);
	
	  return TutorController;
	}();
	
	exports.default = TutorController;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', '$filter', 'ColorFinder', 'DateFinder', 'ValidIndexes'];
		function _class($http, $filter, ColorFinder, DateFinder, ValidIndexes) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.$filter = $filter;
			this.ColorFinder = ColorFinder;
			this.DateFinder = DateFinder;
			this.ValidIndexes = ValidIndexes;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/students').then(function (response) {
					_this.students = response.data;
				});
	
				this.$http.get('/api/icons').then(function (response) {
					_this.icons = response.data[0] || {
						first: '',
						second: '',
						third: '',
						fourth: '',
						fifth: '',
						sixth: '',
						year12: '',
						_note: '',
						_tempUnknown: '',
						_permUnknown: '',
						_perm2Unknown: ''
	
					};
				});
	
				this.$http.get('/api/termsettings').then(function (response) {
					if (response && response.data && response.data[0]) {
						console.log(response.data[0]);
						_this.term = {
							_id: response.data[0]._id,
							termNo: response.data[0].termNo,
							startDate: Date.parse(response.data[0].startDate),
							endDate: Date.parse(response.data[0].endDate),
							sixthSunday: response.data[0].sixthSunday
						};
					} else {
						_this.term = {
							termNo: '',
							startDate: '',
							endDate: '',
							sixthSunday: ''
						};
					}
				});
				this.$http.get('/api/lessons').then(function (response) {
					_this.sessions = response.data;
				});
	
				this.$http.get('/api/smssettings').then(function (response) {
					_this.smssettings = response.data[0] || {
						mobileNumber1: '',
						mobileNumber2: '',
						mobileNumber3: ''
	
					};
				});
	
				this.isSandbox = location.hostname.includes('sandbox');
				this.loading = false;
			}
		}, {
			key: 'resetDatabase',
			value: function resetDatabase() {
				if (confirm('Are you sure you want to refresh the database?')) {
					this.$http.get('/api/users/new-database');
				}
			}
		}, {
			key: 'addYear',
			value: function addYear() {
				var _this2 = this;
	
				if (confirm('Are you sure you want to do this?')) {
					this.students.forEach(function (student) {
						if (!student.isTertiary) {
							if (student.grade == 12) {
								student.isTertiary = true;
								student.isActive = false;
							} else {
								student.grade++;
							}
	
							_this2.$http.put('/api/students/' + String(student._id), student);
						}
					});
				}
			}
		}, {
			key: 'saveIcons',
			value: function saveIcons() {
				var _this3 = this;
	
				this.success = false;
				this.fail = false;
				if (this.icons._id) {
					this.$http.put('/api/icons/' + String(this.icons._id), this.icons).then(function (res) {
						_this3.success = true;
					}).catch(function (res) {
						_this3.fail = true;
					});
				} else {
					this.$http.post('/api/icons', this.icons).then(function (res) {
						_this3.success = true;
					}).catch(function (res) {
						_this3.fail = true;
					});
				}
			}
		}, {
			key: 'updateSettings',
			value: function updateSettings() {
				var _this4 = this;
	
				this.success = false;
				this.fail = false;
	
				if (this.term._id) {
					this.$http.put('/api/termsettings/' + String(this.term._id), this.term).then(function (res) {
						_this4.term.success = true;
					}).catch(function (res) {
						_this4.term.fail = true;
					});
				} else {
					this.$http.post('/api/termsettings', this.term).then(function (res) {
						_this4.term.success = true;
					}).catch(function (res) {
						_this4.term.fail = true;
					});
				}
	
				getWeekendsOfTerm();
			}
		}, {
			key: 'updateSMSSettings',
			value: function updateSMSSettings() {
				var _this5 = this;
	
				this.success = false;
				this.fail = false;
	
				if (this.smssettings._id) {
					this.$http.put('/api/smssettings/' + String(this.smssettings._id), this.smssettings).then(function (res) {
						_this5.smssettings.success = true;
					}).catch(function (res) {
						_this5.smssettings.fail = true;
					});
				} else {
					this.$http.post('/api/smssettings', this.smssettings).then(function (res) {
						_this5.smssettings.success = true;
					}).catch(function (res) {
						_this5.smssettings.fail = true;
					});
				}
			}
		}, {
			key: 'generateEmails',
			value: function generateEmails() {
				var _this6 = this;
	
				if (confirm('Are you sure you want to send student e-mails?')) {
					this.loading = true;
					var start = new Date(this.term.startDate);
					var end = new Date(this.term.endDate);
					var termNo = this.term.termNo;
					var sixthSunday = this.term.sixthSunday;
					var studentIds = this.getStudentIds();
	
					var studentSessions = this.sessions.filter(function (session) {
						return studentIds.has(session.clientUID);
					});
	
					var sessionData = [];
					studentSessions.forEach(function (session) {
						var validIndexes = _this6.ValidIndexes(session, start, end);
						validIndexes.forEach(function (index) {
	
							var sessionDate = _this6.DateFinder(session, index);
							var formattedDate = _this6.$filter('toDateString')(sessionDate);
							var parsedDate = _this6.$filter('reparseDate')(formattedDate);
							var color = _this6.ColorFinder(session, index);
							sessionData.push({
								clientUID: session.clientUID,
								duration: session.duration / 60,
								sessionDate: sessionDate,
								date: parsedDate,
								color: color
							});
						});
					});
	
					sessionData = sessionData.filter(function (session) {
						var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple'];
						var color = session.color.toLowerCase();
						return acceptedColors.includes(color);
					});
	
					sessionData = sessionData.sort(function (a, b) {
						if (a.sessionDate < b.sessionDate) {
							return -1;
						}
	
						if (a.sessionDate > b.sessionDate) {
							return 1;
						}
	
						if (a.basicTime < b.basicTime) {
							return -1;
						}
	
						if (a.basicTime > b.basicTime) {
							return 1;
						}
	
						return 0;
					});
	
					console.log(sessionData.length);
					var studentsData = [];
					var weekEnderResults = this.getWeekendsOfTerm();
					studentIds.forEach(function (sID) {
						var sessionsForStudent = sessionData.filter(function (session) {
							return session.clientUID == sID;
						});
						var weekListInfo = _this6.retrieveHoursPerWeek(weekEnderResults, sessionsForStudent);
						var student = _this6.students.find(function (s) {
							return s._id == sID;
						});
						studentsData.push({
							clientEmailAddress: student.clientEmail.toLowerCase(),
							clientName: student.clientFirstName,
							studentName: student.firstName,
							termNo: termNo,
							sixthSunday: sixthSunday,
							hoursCompleted: weekListInfo.hoursCompleted,
							hoursToFinish: 10 - weekListInfo.hoursCompleted,
							weekList: weekListInfo.weekList
						});
					});
	
					studentsData = studentsData.filter(function (s) {
						return s.clientEmailAddress != "contact@gspt.com.au";
					}).sort(function (a, b) {
						if (a.clientEmailAddress < b.clientEmailAddress) {
							return -1;
						}
	
						if (a.clientEmailAddress > b.clientEmailAddress) {
							return 1;
						}
						return 0;
					});
					console.log(studentsData);
	
					this.$http.post('/api/students/send-email-notif', {
						subject: 'Tuition Schedule to Finish Term ' + termNo,
						studentInfo: studentsData
					}).then(function () {
						return console.log("success");
					}, function () {
						return console.log("error");
					});
	
					console.log("reached end of generate emails");
				}
				this.loading = false;
			}
		}, {
			key: 'retrieveHoursPerWeek',
			value: function retrieveHoursPerWeek(weekEnderResults, sessionData) {
				var hoursCompleted = 0;
				var weekListInfo = {
					hoursCompleted: 0,
					weekList: []
				};
	
				weekEnderResults.forEach(function (weekend, i, weekends) {
					var weekendDate = new Date(weekend.value);
					weekend.duration = 0;
					sessionData.forEach(function (session) {
						var sessionDate = new Date(session.date);
						if (i == 0 && sessionDate <= weekendDate) {
							weekend.duration += session.duration;
						} else if (i > 0) {
							var weekendStart = new Date(weekends[i - 1].value);
							if (sessionDate >= weekendStart && sessionDate <= weekendDate) {
								weekend.duration += session.duration;
							}
						}
					});
	
					var month = ("0" + (weekendDate.getMonth() + 1)).slice(-2);
					var date = ("0" + weekendDate.getDate()).slice(-2);
	
					var status = i > 4 ? 'Scheduled' : 'Completed';
					var toBeRescheduled = false;
					if (i >= 0 && i <= 4) {
						weekListInfo.hoursCompleted += weekend.duration;
						if (weekend.duration == 0) {
							status += " (To Be Rescheduled)";
							toBeRescheduled = true;
						}
					} else if (i == 9) {
						status += '  (Does This Session Need To Be Rescheduled?)';
					}
					weekListInfo.weekList.push({
						value: 'Week Ending ' + date + '/' + month + ' - ' + weekend.duration + ' Hour ' + status,
						toBeRescheduled: toBeRescheduled
					});
				});
				return weekListInfo;
			}
		}, {
			key: 'getStudentIds',
			value: function getStudentIds() {
				var _this7 = this;
	
				var weekEnderResults = this.getWeekendsOfTerm();
	
				var start = new Date(weekEnderResults[4].value);
				start.setDate(start.getDate() + 1);
				var end = new Date(weekEnderResults[5].value);
	
				console.log("Start date:" + start);
				console.log("End date" + end);
	
				var studentIds = [];
	
				var sessions = this.sessions.map(function (session) {
					if (!session.student && session.clientUID) {
						session.student = _this7.students.find(function (s) {
							return s._id === session.clientUID;
						});
					}
					return session;
				});
				sessions.forEach(function (session) {
					var validIndexes = _this7.ValidIndexes(session, start, end);
	
					validIndexes.forEach(function (index) {
						var sessionDate = _this7.DateFinder(session, index);
						var formattedDate = _this7.$filter('toDateString')(sessionDate);
						var parsedDate = _this7.$filter('reparseDate')(formattedDate);
						var color = _this7.ColorFinder(session, index);
						studentIds.push(session.clientUID);
					});
				});
	
				studentIds = new Set(studentIds.sort());
				var studentEmailInfo = [];
				studentIds.forEach(function (studentId) {
					var student = _this7.students.find(function (s) {
						return s._id == studentId;
					});
					studentEmailInfo.push({
						clientEmailAddress: student.clientEmail,
						clientName: student.clientFirstName,
						studentName: student.firstName
					});
				});
	
				return studentIds;
			}
		}, {
			key: 'getWeekendsOfTerm',
			value: function getWeekendsOfTerm() {
				var start = new Date(this.term.startDate);
				var end = new Date(this.term.endDate);
				var weekEnderResults = [];
				var day = 0;
				var current = new Date(start);
	
				current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
				end.setDate(end.getDate() + (7 - end.getDay()) % 7);
	
				while (current <= end) {
					var weekEnder = new Date(+current);
					weekEnderResults.push({
						value: weekEnder,
						duration: 0
					});
					current.setDate(current.getDate() + 7);
				}
	
				return weekEnderResults;
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', '$filter', 'JSONToCSVConvertor', 'ColorFinder', 'HourFinder'];
	  function _class($http, $filter, JSONToCSVConvertor, ColorFinder, HourFinder) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.$filter = $filter;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.ColorFinder = ColorFinder;
	    this.HourFinder = HourFinder;
	    this.total = 0;
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.search = {
	        colour: 'Dark Orange'
	      };
	      this.colours = ['Blue', 'Dark Blue', 'Striped Blue', 'Orange', 'Dark Orange', 'Striped Orange', 'Red', 'Dark Red', 'Striped Red', 'Purple', 'Dark Purple', 'Striped Purple', 'Grey', 'Dark Grey', 'Striped Grey', 'Green', 'Dark Green', 'Striped Green', 'Yellow', 'Dark Yellow', 'Striped Yellow', 'Lime', 'Dark Lime', 'Striped Lime'];
	      this.$http.get('/api/lessons/').then(function (res) {
	        _this.lessons = res.data;
	      });
	
	      this.$http.get('/api/students').then(function (response) {
	        _this.students = response.data.filter(function (student) {
	          return student.isActive;
	        });
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(data) {
	      data = data.map(function (entity) {
	        var newObj = {};
	        if (entity.student) {
	          newObj.clientName = entity.student.firstName + ' ' + entity.student.lastName;
	        } else {
	          newObj.clientName = 'Hidden User';
	        }
	        newObj.found = entity.found;
	        return newObj;
	      });
	      this.JSONToCSVConvertor(data, 'Tutor Export - ' + this.search.colour, true);
	    }
	  }, {
	    key: 'processLessons',
	    value: function processLessons() {
	      var _this2 = this;
	
	      var _search = this.search,
	          colour = _search.colour,
	          start = _search.start,
	          end = _search.end;
	
	
	      var temper = this.lessons.filter(function (lesson) {
	        return !lesson.isHidden;
	      });
	      temper = temper.map(function (lesson) {
	        return _this2.colourInstances(lesson, colour, start, end);
	      });
	
	      var temper2 = [];
	
	      temper.forEach(function (lesson) {
	        var foundEr = false;
	        temper2.some(function (found, index) {
	          if (found.clientUID === lesson.clientUID) {
	            temper2[index].found += lesson.found;
	            foundEr = true;
	            return true;
	          }
	        });
	        if (foundEr === false) {
	          temper2.push(lesson);
	        }
	      });
	
	      this.less = temper2.sort(function (a, b) {
	        return a.found - b.found;
	      });
	
	      this.total = 0;
	      this.less.forEach(function (lesson) {
	        _this2.total += lesson.found;
	      });
	    }
	  }, {
	    key: 'colourInstances',
	    value: function colourInstances(lesson, colour, start, end) {
	      var msDay = 1000 * 60 * 60 * 24;
	      colour = colour.toLowerCase();
	
	      this.students.forEach(function (student) {
	        if (lesson.clientUID == student._id) lesson.student = student;
	      });
	
	      lesson.newDate = this.$filter('reparseDate')(lesson.date);
	      lesson.found = 0;
	
	      if (lesson.newDate > end) {
	        return lesson;
	      }
	
	      var maxPossible = Math.floor((end.getTime() - lesson.newDate.getTime()) / msDay / lesson.frequency) + 1;
	
	      if (lesson.instances !== 0 && lesson.instances < maxPossible) {
	        maxPossible = lesson.instances;
	      }
	
	      var startIndex = 0;
	      if (start > lesson.newDate) {
	        var dif = (start.getTime() - lesson.newDate.getTime()) / msDay;
	        startIndex = Math.ceil(dif / lesson.frequency);
	      }
	
	      for (var i = startIndex; i < maxPossible; i++) {
	        if (lesson.overwriteVisibility && lesson.overwriteVisibility[i] === true) {
	          continue;
	        }
	
	        var lessonColor = this.ColorFinder(lesson, i);
	        if (lessonColor === colour) {
	          lesson.found += 1;
	        }
	      }
	
	      return lesson;
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', '$filter', 'ColorFinder'];
	  function _class($http, $filter, ColorFinder) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.$filter = $filter;
	    this.ColorFinder = ColorFinder;
	    this.total = 0;
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.search = {};
	      this.$http.get('/api/lessons/').then(function (res) {
	        _this.lessons = res.data;
	      });
	
	      this.$http.get('/api/students').then(function (response) {
	        _this.students = response.data.filter(function (student) {
	          return student.isActive;
	        });
	      });
	    }
	  }, {
	    key: 'returnFilter',
	    value: function returnFilter(results, $query) {
	      return results.filter(function (item) {
	        return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
	      });
	    }
	  }, {
	    key: 'processFound',
	    value: function processFound(found) {
	      var text = '';
	
	      for (var key in found) {
	        text += key + ': ';
	        text += found[key] + ', ';
	      }
	
	      return text;
	    }
	  }, {
	    key: 'processLessons',
	    value: function processLessons() {
	      var _this2 = this;
	
	      var _search = this.search,
	          start = _search.start,
	          end = _search.end,
	          student = _search.student;
	
	
	      student = student[0];
	      var temper = this.lessons.filter(function (lesson) {
	        return !lesson.isHidden;
	      });
	      temper = temper.filter(function (lesson) {
	        return student._id === lesson.clientUID;
	      });
	      temper = temper.map(function (lesson) {
	        return _this2.colourInstances(lesson, start, end);
	      });
	
	      var counts = [];
	
	      temper.forEach(function (lesson) {
	
	        var lessonCount = lesson.found;
	
	        if (!lessonCount) {
	          return;
	        }
	
	        for (var key in lessonCount) {
	          if (key.includes('red')) {
	            continue;
	          }
	          var countIndex = counts.findIndex(function (count) {
	            return count[0] === key;
	          });
	
	          if (countIndex === -1) {
	            counts.push([key, lessonCount[key]]);
	          } else {
	            counts[countIndex][1] += lessonCount[key];
	          }
	        }
	      });
	
	      this.counts = counts;
	
	      this.total = 0;
	      this.counts.forEach(function (count) {
	        _this2.total += count[1];
	      });
	    }
	  }, {
	    key: 'colourInstances',
	    value: function colourInstances(lesson, start, end) {
	      var msDay = 1000 * 60 * 60 * 24;
	
	      lesson.newDate = this.$filter('reparseDate')(lesson.date);
	      lesson.found = {};
	
	      if (lesson.newDate > end) {
	        return lesson;
	      }
	
	      var maxPossible = Math.floor((end.getTime() - lesson.newDate.getTime()) / msDay / lesson.frequency) + 1;
	
	      if (lesson.instances !== 0 && lesson.instances < maxPossible) {
	        maxPossible = lesson.instances;
	      }
	
	      var startIndex = 0;
	      if (start > lesson.newDate) {
	        var dif = (start.getTime() - lesson.newDate.getTime()) / msDay;
	        startIndex = Math.ceil(dif / lesson.frequency);
	      }
	
	      for (var i = startIndex; i < maxPossible; i++) {
	        if (lesson.overwriteVisibility && lesson.overwriteVisibility[i] === true) {
	          continue;
	        }
	
	        var fonCol = this.ColorFinder(lesson, i);
	
	        if (lesson.found[fonCol]) {
	          lesson.found[fonCol] += 1;
	        } else {
	          lesson.found[fonCol] = 1;
	        }
	      }
	
	      return lesson;
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', '$filter', 'JSONToCSVConvertor', 'HourFinder', 'ColorFinder', 'ValidIndexes'];
	  function _class($http, $filter, JSONToCSVConvertor, HourFinder, ColorFinder, ValidIndexes) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.$filter = $filter;
	    this.search = {};
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.HourFinder = HourFinder;
	    this.ColorFinder = ColorFinder;
	    this.ValidIndexes = ValidIndexes;
	    this.results = [];
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get('/api/tutors').then(function (response) {
	        _this.tutors = response.data;
	      });
	
	      this.$http.get('/api/lessons').then(function (response) {
	        _this.lessons = response.data;
	      });
	
	      this.$http.get('/api/students').then(function (response) {
	        _this.students = response.data;
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export(data) {
	      data = data.map(function (entity) {
	        return {
	          clientName: entity.student.fullName,
	          time: entity.totalTime
	        };
	      });
	
	      data.push({ clientName: 'Total Time', time: this.totalTime });
	
	      this.JSONToCSVConvertor(data, 'Tutor Export ' + this.search.tutor[0].fullName, true);
	    }
	  }, {
	    key: 'returnFilter',
	    value: function returnFilter(results, $query) {
	      return results.filter(function (item) {
	        return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.results = [];
	      var msDay = 1000 * 60 * 60 * 24;
	      var _search = this.search,
	          start = _search.start,
	          end = _search.end,
	          tutor = _search.tutor;
	
	
	      if (!start || !end || !tutor.length) {
	        return;
	      }
	
	      tutor = tutor[0];
	
	      var tutorsLessons = this.lessons.filter(function (entity) {
	        return entity.tutorUID === tutor._id;
	      });
	      tutorsLessons.forEach(function (entity) {
	        return _this2.timeCompress(entity, start, end);
	      });
	
	      this.results = this.results.sort(function (a, b) {
	        if (a.student.fullName < b.student.fullName) return -1;
	        if (a.student.fullName > b.student.fullName) return 1;
	        return 0;
	      });
	
	      this.totalTime = 0;
	
	      this.results.forEach(function (ent) {
	        _this2.totalTime += ent.totalTime;
	      });
	
	      this.less = this.results;
	    }
	  }, {
	    key: 'timeCompress',
	    value: function timeCompress(lesson, start, end) {
	      var _this3 = this;
	
	      lesson.student = this.students.find(function (student) {
	        return lesson.clientUID == student._id;
	      });
	
	      var validIndexes = this.ValidIndexes(lesson, start, end);
	
	      validIndexes.forEach(function (index) {
	        var effectiveColor = _this3.ColorFinder(lesson, index);
	        if (effectiveColor.includes('red') || effectiveColor.includes('grey') || effectiveColor.includes('yellow')) {
	          return;
	        };
	
	        var student = {
	          first: lesson.student.firstName,
	          last: lesson.student.lastName,
	          fullName: lesson.student.fullName
	        };
	
	        if (lesson.overwriteName && lesson.overwriteName[index]) {
	          student.first = lesson.overwriteName[index];
	          student.last = null;
	          student.fullName = lesson.overwriteName[index] + ' - Overwritten Name';
	        }
	
	        _this3.addToResults({
	          student: student,
	          totalTime: _this3.HourFinder(lesson, index) / 60
	        });
	      });
	    }
	  }, {
	    key: 'addToResults',
	    value: function addToResults(data) {
	      var foundIndex = this.results.findIndex(function (result) {
	        return result.student.fullName === data.student.fullName;
	      });
	
	      if (foundIndex === -1) {
	        return this.results.push(data);
	      }
	
	      this.results[foundIndex].totalTime += data.totalTime;
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _calendar = __webpack_require__(52);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _sendSms = __webpack_require__(57);
	
	var _sendSms2 = _interopRequireDefault(_sendSms);
	
	var _session = __webpack_require__(58);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _editSession = __webpack_require__(59);
	
	var _editSession2 = _interopRequireDefault(_editSession);
	
	var _colourCount = __webpack_require__(60);
	
	var _colourCount2 = _interopRequireDefault(_colourCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('calendar', {
	    url: '/calendar',
	    template: __webpack_require__(61),
	    controller: 'CalendarController',
	    controllerAs: 'vm',
	    authenticate: 'admin'
	  });
	}
	
	exports.default = _angular2.default.module('calApp.calendar', ['calApp.auth', 'ui.router']).config(routes).controller('CalendarController', _calendar2.default).controller('SendSMSController', _sendSms2.default).controller('ColourCountController', _colourCount2.default).controller('SessionController', _session2.default).controller('EditSessionController', _editSession2.default).name;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CalendarController = function () {
		/*@ngInject*/
		CalendarController.$inject = ['Modal', '$http', '$filter', '$uibModal', '$compile', '$timeout', 'copyTextToClipboard', 'ColorFinder', 'HourFinder', 'StartFinder', 'ValidIndexes', 'DateFinder'];
		function CalendarController(Modal, $http, $filter, $uibModal, $compile, $timeout, copyTextToClipboard, ColorFinder, HourFinder, StartFinder, ValidIndexes, DateFinder) {
			_classCallCheck(this, CalendarController);
	
			this.Modal = Modal;
			this.$http = $http;
			this.$filter = $filter;
			this.$uibModal = $uibModal;
			this.$compile = $compile;
			this.$timeout = $timeout;
			this.copyTextToClipboard = copyTextToClipboard;
			this.ColorFinder = ColorFinder;
			this.HourFinder = HourFinder;
			this.StartFinder = StartFinder;
			this.ValidIndexes = ValidIndexes;
			this.DateFinder = DateFinder;
		}
	
		_createClass(CalendarController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.isSandbox = location.host.includes('sandbox');
	
				this.visibleLessons = [];
	
				this.intDay();
	
				this.icons = {
					first: '',
					second: '',
					third: '',
					fourth: '',
					fifth: '',
					sixth: '',
					year12: ''
				};
	
				this.clearIconFilters();
	
				this.$http.get('/api/icons').then(function (response) {
					if (response && response.data && response.data[0]) {
						_this.icons = response.data[0];
					}
					_this.finishedLoad();
				});
	
				this.$http.get('/api/termsettings').then(function (response) {
					if (response && response.data && response.data[0]) {
						_this.term = response.data[0];
					}
					_this.finishedLoad();
				});
	
				this.location = 'paddington';
	
				this.rooms = {
					'paddington': this.createArray(7),
					'cannon hill': this.createArray(6),
					'online': this.createArray(12)
	
				};
	
				this.segments = this.createArray(48);
	
				this.loading = true;
				this.loaded = 0;
	
				this.$http.get('/api/lessons').then(function (response) {
					_this.sessions = response.data;
					_this.finishedLoad();
				});
	
				this.$http.get('/api/students').then(function (response) {
					_this.students = response.data;
					_this.finishedLoad();
				});
	
				this.$http.get('/api/tutors').then(function (response) {
					_this.tutors = response.data;
					_this.finishedLoad();
				});
	
				var changeColour = function changeColour(colour) {
					colour = colour.toLowerCase();
					return function ($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						var _instance = +_targ.dataset.instance;
						_this.editColour(_uid, _instance, colour);
					};
				};
	
				var tempColourChildren = ['Yellow', 'Green', 'Dark Green', 'Orange', 'Purple', 'Red', 'Dark Red'];
				tempColourChildren = tempColourChildren.map(function (item) {
					return {
						text: item,
						click: changeColour(item)
					};
				});
	
				var changeIcon = function changeIcon(icon, perm) {
					return function ($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						var _instance = +_targ.dataset.instance;
						_this.editIcon(_uid, _instance, icon, perm);
					};
				};
	
				var menuDisplayed = function menuDisplayed($itemScope, $event) {
					return !!($event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell'));
				};
	
				var dateSame = function dateSame($itemScope, $event) {
					var today = new Date();
					var tomorrow = new Date();
					tomorrow.setDate(today.getDate() + 1);
					return menuDisplayed($itemScope, $event) && (_this.calendarDate.toDateString() === today.toDateString() || _this.calendarDate.toDateString() === tomorrow.toDateString());
				};
	
				this.menuOptions = [{
					text: 'Add Session',
					hasBottomDivider: true,
					click: function click($itemScope, $event) {
						console.log($itemScope, $event);
						var _time = 1440 / _this.segments.length * $itemScope.$parent.segment;
						_this.addSessionModal(_time, $itemScope.room);
					}
				}, {
					text: 'Copy',
					displayed: menuDisplayed,
					children: [{
						text: 'Phone Number',
						click: function click($itemScope, $event) {
							var text = $event.target.classList.contains('session-cell') ? $event.target.dataset.phone : $event.target.closest('.session-cell').dataset.phone;
							_this.copyTextToClipboard(text);
						}
					}, {
						text: 'Email Address',
						click: function click($itemScope, $event) {
							var text = $event.target.classList.contains('session-cell') ? $event.target.dataset.email : $event.target.closest('.session-cell').dataset.email;
							_this.copyTextToClipboard(text);
						}
					}]
				}, {
					text: 'Delete',
					hasBottomDivider: true,
					displayed: menuDisplayed,
					children: [{
						text: 'Instance',
						click: function click($itemScope, $event) {
							var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
							var _uid = _targ.dataset.id;
							var _instance = +_targ.dataset.instance;
							_this.overwriteHide(_uid, _instance);
						}
					}, {
						text: 'Series',
						click: function click($itemScope, $event) {
							var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
							var _uid = _targ.dataset.id;
							if (confirm('Are you sure you want to permanently delete this series?')) {
								_this.deleteSeries(_uid);
							}
						}
					}]
				}, {
					text: 'SMS Student',
					displayed: dateSame,
					click: function click($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						var _instance = +_targ.dataset.instance;
						var _time = $itemScope.$parent.segment;
						_this.sendSMS(_uid, _instance, _time, false);
					}
				}, {
					text: 'SMS Tutor',
					hasBottomDivider: true,
					displayed: dateSame,
					click: function click($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						var _instance = +_targ.dataset.instance;
						var _time = $itemScope.$parent.segment;
						_this.sendSMS(_uid, _instance, _time, true);
					}
				}, {
					text: 'Email Tutor',
					children: [{
						text: 'This Day',
						click: function click($itemScope, $event) {
							var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
							var uid = targ.dataset.id;
							_this.sendEmail(uid, _this.calendarDate, false, false);
						}
					}, {
						text: 'This Day - With Subjects',
						click: function click($itemScope, $event) {
							var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
							var uid = targ.dataset.id;
							_this.sendEmail(uid, _this.calendarDate, false, true);
						}
					}, {
						text: 'This Week',
						click: function click($itemScope, $event) {
							var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
							var uid = targ.dataset.id;
							_this.sendEmail(uid, _this.calendarDate, true, false);
						}
					}, {
						text: 'This Week - With Subjects',
						click: function click($itemScope, $event) {
							var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
							var uid = targ.dataset.id;
							_this.sendEmail(uid, _this.calendarDate, true, true);
						}
					}]
				}, {
					text: 'Email Student Schedule',
					hasBottomDivider: true,
					click: function click($itemScope, $event) {
						var targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var uid = targ.dataset.id;
						_this.sendEmailScheduleNotif(uid, _this.calendarDate);
					}
				}, {
					text: 'Temporary Icon',
					displayed: menuDisplayed,
					children: [{
						text: '1. Paid',
						click: changeIcon(1, false)
					}, {
						text: '2. New Client',
						click: changeIcon(2, false)
					}, {
						text: '5. Tick',
						click: changeIcon(5, false)
					}, {
						text: '6. Cross',
						click: changeIcon(6, false)
					}, {
						text: 'Unknown',
						click: changeIcon(7, false)
					}]
				}, {
					text: 'Permanent Icon',
					displayed: menuDisplayed,
					hasBottomDivider: true,
					children: [{
						text: '3. Different Pay Rate',
						click: changeIcon(3, true)
					}, {
						text: '4. Payment Stored',
						click: changeIcon(4, true)
					}, {
						text: 'Direct Debit',
						click: changeIcon(8, true)
					}, {
						text: 'Credit Card Stored',
						click: changeIcon(9, true)
					}]
				}, {
					text: 'Toggle Changeover',
					hasBottomDivider: true,
					displayed: menuDisplayed,
					click: function click($itemScope, $event) {
						var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
						var _uid = _targ.dataset.id;
						var _instance = +_targ.dataset.instance;
						_this.overwriteChangeover(_uid, _instance);
					}
				}, {
					text: 'Close'
				}];
			}
		}, {
			key: 'intDay',
			value: function intDay() {
				var today = new Date();
	
				this.calendarDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			}
		}, {
			key: 'editColour',
			value: function editColour(id, instance, colour) {
				var _this2 = this;
	
				var session = this.sessions.find(function (session) {
					return id == session._id;
				});
	
				session.overwriteColor = session.overwriteColor || {};
				session.overwriteColor[instance] = colour;
				this.$http.put('/api/lessons/' + id, {
					overwriteColor: session.overwriteColor
				}).then(function (response) {
					_this2.clearCal();
				});
			}
		}, {
			key: 'clearMessages',
			value: function clearMessages() {
				this.tempSuccess = null;
			}
		}, {
			key: 'studentInactive',
			value: function studentInactive(id, instance) {
				var _this3 = this;
	
				var session = this.sessions.find(function (session) {
					return id == session._id;
				});
	
				this.$http.put('/api/students/' + session.student._id, {
					isActive: false
				}).then(function (response) {
					_this3.clearCal();
				});
			}
		}, {
			key: 'clearIconFilters',
			value: function clearIconFilters() {
				this.iconFilters = {
					first: false,
					second: false,
					third: false,
					fourth: false,
					fifth: false,
					sixth: false,
					year12: false
				};
			}
		}, {
			key: 'sendEmail',
			value: function sendEmail(id, date, isWeek, withSubjects) {
				var _this4 = this;
	
				var msDay = 1000 * 60 * 60 * 24;
				if (isWeek) {
					if (date.getDay() === 0) {
						var startOfWeek = date.getDate() - 7;
					} else {
						var startOfWeek = date.getDate() - (date.getDay() - 1);
					}
	
					var start = new Date(date.getFullYear(), date.getMonth(), startOfWeek);
					var end = new Date(date.getFullYear(), date.getMonth(), startOfWeek + 6);
				} else {
					var start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
					var end = start;
				}
	
				var tutorInfo = [];
				var tutorID = this.sessions.find(function (session) {
					return id == session._id;
				}).tutorUID;
				var tutor = this.tutors.find(function (tutor) {
					return tutorID === tutor._id;
				});
				var tutorSessions = this.sessions.filter(function (session) {
					return tutorID === session.tutorUID;
				}).filter(function (session) {
					return session.date;
				});
	
				var sessionData = [];
	
				tutorSessions.forEach(function (session) {
					var validIndexes = _this4.ValidIndexes(session, start, end);
	
					validIndexes.forEach(function (index) {
	
						var basicTime = _this4.StartFinder(session, index);
	
						console.log(basicTime);
						var formattedTime = _this4.$filter('minuteConvert')(basicTime, false);
						var sessionDate = _this4.DateFinder(session, index);
						var formattedDate = _this4.$filter('toDateString')(sessionDate);
						var color = _this4.ColorFinder(session, index);
	
						sessionData.push({
							studentName: session.student.firstName + " " + session.student.lastName,
							isTertiary: session.student.isTertiary,
							grade: session.student.grade,
							subjects: session.student.subjects,
							time: formattedTime,
							isEmpty: false,
							basicTime: basicTime,
							date: formattedDate,
							sessionDate: sessionDate,
							color: color
						});
					});
				});
	
				if (!isWeek) {
					sessionData = sessionData.filter(function (session) {
						var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple'];
						var color = session.color.toLowerCase();
	
						return acceptedColors.includes(color);
					});
				};
	
				if (sessionData.length === 0) {
					return alert('Something went wrong. No sessions found.');
				}
	
				var datesPresent = [];
				sessionData.forEach(function (session) {
					if (datesPresent.includes(session.date) === false) {
						datesPresent.push(session.date);
					};
				});
	
				var times = [930, 990, 1050, 1110, 1170, 1230, 1290];
	
				datesPresent.forEach(function (datePresent) {
					var filteredSessions = sessionData.filter(function (session) {
						return session.date === datePresent;
					});
	
					times.forEach(function (time) {
						var found = filteredSessions.find(function (session) {
							return session.basicTime === time;
						});
	
						if (!found) {
							var formattedTime = _this4.$filter('minuteConvert')(time, false);
							var sessionDate = _this4.$filter('reparseDate')(datePresent);
	
							sessionData.push({
								basicTime: time,
								isEmpty: true,
								date: datePresent,
								time: formattedTime,
								sessionDate: sessionDate
							});
						}
					});
				});
	
				sessionData = sessionData.sort(function (a, b) {
					if (a.sessionDate < b.sessionDate) {
						return -1;
					}
	
					if (a.sessionDate > b.sessionDate) {
						return 1;
					}
	
					if (a.basicTime < b.basicTime) {
						return -1;
					}
	
					if (a.basicTime > b.basicTime) {
						return 1;
					}
	
					return 0;
				}).filter(function (session) {
					return !session.isEmpty;
				});
	
				var dates = new Set(sessionData.map(function (session) {
					return session.sessionDate;
				}));
	
				var tutorWeek = [];
	
				dates.forEach(function (date) {
					var sessionsOnDay = sessionData.filter(function (session) {
						return session.sessionDate == date;
					});
					var thisDate = new Date(date).toLocaleDateString('en-AU', { weekday: 'long' });
					console.log(sessionsOnDay);
					tutorWeek.push(_defineProperty({}, thisDate, sessionsOnDay));
				});
	
				var schedule = '<ul>';
	
				tutorWeek.forEach(function (day) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
	
						for (var _iterator = Object.entries(day)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var _step$value = _slicedToArray(_step.value, 2),
							    key = _step$value[0],
							    value = _step$value[1];
	
							schedule += '\t<li>' + key + '<ul>';
							value.forEach(function (studentSession) {
	
								if (studentSession.isTertiary) {
									var grade = '(Uni Student)';
								} else {
									var grade = '(Year ' + studentSession.grade + ')';
								}
	
								if (withSubjects && studentSession.subjects) {
									var subjects = ' ' + studentSession.subjects;
								} else {
									var subjects = "";
								}
	
								schedule += '<li>' + studentSession.time + ' - ' + studentSession.studentName + ' ' + grade + subjects + '</li>\n';
							});
	
							schedule += '</ul></li>\n';
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				});
	
				schedule += '</ul>';
	
				var month = ("0" + (start.getMonth() + 1)).slice(-2);
				var date = ("0" + start.getDate()).slice(-2);
				var subjectDate = date + "/" + month;
	
				this.$http.post('/api/tutors/send-email/day', {
					content: schedule,
					range: isWeek ? 'Week Commencing (' + subjectDate + ')' : 'DAY (' + subjectDate + ')',
					tutor: tutor.firstName + ' ' + tutor.lastName,
					emailAddress: tutor.email
				});
			}
		}, {
			key: 'sendEmailScheduleNotif',
			value: function sendEmailScheduleNotif(id, date) {
				var _this5 = this;
	
				var start = new Date(this.term.startDate);
				var end = new Date(this.term.endDate);
				var termNo = this.term.termNo;
				var sixthSunday = this.term.sixthSunday;
	
				var weekEnderResults = [];
				var day = 0;
				var current = new Date(start);
	
				current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
				end.setDate(end.getDate() + (7 - end.getDay()) % 7);
	
				while (current <= end) {
					var weekEnder = new Date(+current);
					weekEnderResults.push({
						value: weekEnder,
						duration: 0
					});
					current.setDate(current.getDate() + 7);
				}
	
				var studentId = this.sessions.find(function (session) {
					return id == session._id;
				}).clientUID;
				var student = this.sessions.find(function (session) {
					return id == session._id;
				}).student;
	
				var sessionData = [];
				var sessions = this.sessions.filter(function (session) {
					return session.clientUID == studentId;
				});
	
				sessions.forEach(function (session) {
					var validIndexes = _this5.ValidIndexes(session, start, end);
	
					validIndexes.forEach(function (index) {
	
						var sessionDate = _this5.DateFinder(session, index);
						var formattedDate = _this5.$filter('toDateString')(sessionDate);
						var parsedDate = _this5.$filter('reparseDate')(formattedDate);
						var color = _this5.ColorFinder(session, index);
						sessionData.push({
							duration: session.duration / 60,
							sessionDate: sessionDate,
							date: parsedDate,
							color: color
						});
					});
				});
	
				sessionData = sessionData.filter(function (session) {
					var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple'];
					var color = session.color.toLowerCase();
					return acceptedColors.includes(color);
				});
	
				sessionData = sessionData.sort(function (a, b) {
					if (a.sessionDate < b.sessionDate) {
						return -1;
					}
	
					if (a.sessionDate > b.sessionDate) {
						return 1;
					}
	
					if (a.basicTime < b.basicTime) {
						return -1;
					}
	
					if (a.basicTime > b.basicTime) {
						return 1;
					}
	
					return 0;
				});
	
				var hoursCompleted = 0;
				var weekList = [];
	
				weekEnderResults.forEach(function (weekend, i, weekends) {
					var weekendDate = new Date(weekend.value);
	
					sessionData.forEach(function (session) {
						var sessionDate = new Date(session.date);
						if (i == 0 && sessionDate <= weekendDate) {
							weekend.duration += session.duration;
						} else if (i > 0) {
							var weekendStart = new Date(weekends[i - 1].value);
							if (sessionDate >= weekendStart && sessionDate <= weekendDate) {
								weekend.duration += session.duration;
							}
						}
					});
	
					var month = ("0" + (weekendDate.getMonth() + 1)).slice(-2);
					var date = ("0" + weekendDate.getDate()).slice(-2);
	
					var status = i > 4 ? 'Scheduled' : 'Completed';
					var toBeRescheduled = false;
					if (i >= 0 && i <= 4) {
						hoursCompleted += weekend.duration;
						if (weekend.duration == 0) {
							status += " (To Be Rescheduled)";
							toBeRescheduled = true;
						}
					} else if (i == 9) {
						status += '  (Does This Session Need To Be Rescheduled?)';
					}
					weekList.push({
						value: 'Week Ending ' + date + '/' + month + ' - ' + weekend.duration + ' Hour ' + status,
						toBeRescheduled: toBeRescheduled
					});
				});
	
				var studentInfo = {
					clientEmailAddress: student.clientEmail,
					clientName: student.clientFirstName,
					studentName: student.firstName,
					termNo: termNo,
					sixthSunday: sixthSunday,
					hoursCompleted: hoursCompleted,
					hoursToFinish: 10 - hoursCompleted,
					weekList: weekList
				};
	
				console.log(studentInfo);
	
				this.$http.post('/api/students/send-email-notif', {
					subject: 'Tuition Schedule to Finish Term ' + termNo,
					studentInfo: [studentInfo]
				});
			}
		}, {
			key: 'sendSMS',
			value: function sendSMS(id, instance, time, isTutor) {
				var session = this.sessions.find(function (session) {
					return id == session._id;
				});
				var tutor = session.tutor;
				var student = session.student;
	
				var today = new Date();
				var tomorrow = new Date();
				tomorrow.setDate(today.getDate() + 1);
				var isTomorrow = this.calendarDate.toDateString() === tomorrow.toDateString();
	
				this.sendSMSModal(student, time, tutor, isTutor, isTomorrow);
			}
		}, {
			key: 'colourCountModal',
			value: function colourCountModal() {
				var _todaysSessions = this.todaysSessions();
				var _calendarDate = this.calendarDate;
	
				this.$uibModal.open({
					template: __webpack_require__(53),
					controller: 'ColourCountController',
					controllerAs: 'vm',
					resolve: {
						todaysSessions: function todaysSessions() {
							return _todaysSessions;
						},
						calendarDate: function calendarDate() {
							return _calendarDate;
						}
					}
				});
			}
		}, {
			key: 'sendSMSModal',
			value: function sendSMSModal(student, time, tutor, isTutor, isTomorrow) {
				var _this6 = this;
	
				this.$uibModal.open({
					template: __webpack_require__(54),
					controller: 'SendSMSController',
					controllerAs: 'vm',
					resolve: {
						data: function data() {
							return {
								student: student,
								time: time,
								tutor: tutor,
								isTutor: isTutor,
								isTomorrow: isTomorrow
							};
						}
					}
				}).result.then(function (res) {
					_this6.tempSuccess = true;
				});
			}
		}, {
			key: 'editIcon',
			value: function editIcon(id, instance, icon, perm) {
				var _this7 = this;
	
				var session = this.sessions.find(function (session) {
					return id == session._id;
				});
	
				if (perm) {
					var key = 'var' + String(icon);
					var property = !session.student[key];
					var change = _defineProperty({}, key, property);
	
					this.$http.put('/api/students/' + session.student._id, change).then(function (response) {
						var student = _this7.students.find(function (s) {
							return s._id === session.student._id;
						});
						student[key] = property;
	
						_this7.clearCal();
					});
	
					return;
				}
	
				var key = 'overwriteVar' + String(icon);
				session[key] = session[key] || {};
				session[key][instance] = !session[key][instance];
				var change = _defineProperty({}, key, session[key]);
	
				this.$http.put('/api/lessons/' + id, change).then(function (response) {
					_this7.clearCal();
				});
			}
		}, {
			key: 'deleteSeries',
			value: function deleteSeries(id) {
				var _this8 = this;
	
				var index = this.sessions.find(function (s) {
					return s._id === id;
				});
				this.sessions = [].concat(_toConsumableArray(this.sessions.slice(0, index)), _toConsumableArray(this.sessions.slice(index + 1)));
				this.$http.delete('/api/lessons/' + id).then(function (res) {
					_this8.clearCal();
				});
			}
		}, {
			key: 'overwriteHide',
			value: function overwriteHide(id, instance) {
				var _this9 = this;
	
				this.sessions.forEach(function (session) {
					if (id == session._id) {
						session.overwriteVisibility = session.overwriteVisibility || {};
						session.overwriteVisibility[instance] = true;
						_this9.$http.put('/api/lessons/' + id, {
							overwriteVisibility: session.overwriteVisibility
						}).then(function (response) {
							_this9.clearCal();
						});
					}
				});
			}
		}, {
			key: 'overwriteChangeover',
			value: function overwriteChangeover(id, instance) {
				var _this10 = this;
	
				this.sessions.forEach(function (session) {
					if (id == session._id) {
						session.overwriteChangeover = session.overwriteChangeover || {};
						if (typeof session.overwriteChangeover[instance] === 'undefined') {
							session.overwriteChangeover[instance] = false;
						} else {
							session.overwriteChangeover[instance] = !session.overwriteChangeover[instance];
						}
	
						_this10.$http.put('/api/lessons/' + id, {
							overwriteChangeover: session.overwriteChangeover
						}).then(function (response) {
							_this10.clearCal();
						});
					}
				});
			}
		}, {
			key: 'iconFilterChange',
			value: function iconFilterChange(key) {
				this.iconFilters[key] = !this.iconFilters[key];
				this.clearCal();
			}
		}, {
			key: 'finishedLoad',
			value: function finishedLoad() {
				this.loaded++;
				if (this.loaded === 5) {
					this.updateCal();
				}
			}
		}, {
			key: 'todaysSessions',
			value: function todaysSessions() {
				var _this11 = this;
	
				var parsedDate = this.$filter('date')(this.calendarDate, 'dd/MM/yyyy');
				var cleanDate = this.$filter('reparseDate')(parsedDate);
				var sessions = this.sessions;
	
				sessions = sessions.filter(function (session) {
					if (!session.date) {
						console.log(session);
						return;
					}
	
					var objSession = _this11.$filter('reparseDate')(session.date);
					var daysAhead = Math.round((cleanDate - objSession) / 86400000);
					var instance = daysAhead / session.frequency;
	
					if (_this11.iconFilters.first && (!session.overwriteVar1 || session.overwriteVar1[instance] !== true)) {
						return;
					}
	
					if (_this11.iconFilters.second && (!session.overwriteVar2 || session.overwriteVar2[instance] !== true)) {
						return;
					}
	
					if (_this11.iconFilters.third && session.student.var3 !== true) {
						return;
					}
	
					if (_this11.iconFilters.fourth && session.student.var4 !== true) {
						return;
					}
	
					if (_this11.iconFilters.fifth && (!session.overwriteVar5 || session.overwriteVar5[instance] !== true)) {
						return;
					}
	
					if (_this11.iconFilters.sixth && (!session.overwriteVar6 || session.overwriteVar6[instance] !== true)) {
						return;
					}
	
					if (_this11.iconFilters.year12 && session.student.grade !== 12) {
						return;
					}
	
					return true;
				});
	
				sessions = sessions.map(function (session) {
					if (!session.student && session.clientUID) {
						session.student = _this11.students.find(function (s) {
							return s._id === session.clientUID;
						});
					}
	
					if (!session.tutor && session.tutorUID) {
						session.tutor = _this11.tutors.find(function (t) {
							return t._id === session.tutorUID;
						});
					}
					return session;
				});
	
				if (this.searchFilter) sessions = this.$filter('filter')(this.sessions, this.searchFilter);
	
				var filteredSessions = sessions.filter(function (session) {
					if (session.isHidden) return;
	
					if (session.location != _this11.location) return;
	
					if (session.date == parsedDate) return true;
	
					console.log(session);
	
					if (session.instances == 1) return;
	
					var objSession = _this11.$filter('reparseDate')(session.date);
	
					if (objSession > cleanDate) return;
	
					var daysAhead = Math.round((cleanDate.getTime() - objSession.getTime()) / 86400000);
	
					if (daysAhead % session.frequency !== 0) return;
	
					var _instance = daysAhead / session.frequency;
	
					if (session.instances === 0) return true;
	
					if (session.instances > _instance) return true;
				});
	
				return filteredSessions.map(function (session) {
					if (session.date == parsedDate) {
						session._instance = 0;
						return session;
					};
	
					var objSession = _this11.$filter('reparseDate')(session.date);
					var daysAhead = Math.round((cleanDate - objSession) / 86400000);
					var _instance = daysAhead / session.frequency;
	
					session._instance = _instance;
	
					return session;
				});
			}
		}, {
			key: 'updateCal',
			value: function updateCal() {
				var _this12 = this;
	
				this.visibleLessons = [];
				var parsedDate = this.$filter('date')(this.calendarDate, 'dd/MM/yyyy');
				var cleanDate = this.$filter('reparseDate')(parsedDate);
				var todaysSessions = this.todaysSessions();
	
				todaysSessions.forEach(function (session) {
					if (!session) {
						console.log(todaysSessions);
						return;
					}
	
					if (session.date == parsedDate) return _this12.addCalendar(session, 0);
	
					var objSession = _this12.$filter('reparseDate')(session.date);
	
					var daysAhead = Math.round((cleanDate - objSession) / 86400000);
	
					var _instance = daysAhead / session.frequency;
	
					_this12.addCalendar(session, _instance);
				});
	
				this.addDropAndDrag();
			}
		}, {
			key: 'handleClick',
			value: function handleClick($event) {
				var _targ = $event.target.classList.contains('free-col') ? $event.target : $event.target.closest('.free-col');
				var _startTime = _targ.dataset.time;
				var _room = _targ.dataset.room;
	
				if (_targ.childElementCount === 0) {
					return this.addSessionModal(_startTime, _room);
				}
	
				var closest = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
				var finalTarg = closest || _targ.firstChild;
				var _uid = finalTarg.dataset.id;
				var _instance = +finalTarg.dataset.instance;
	
				this.editSessionModal(_uid, _instance);
			}
		}, {
			key: 'addDropAndDrag',
			value: function addDropAndDrag() {
				var _this13 = this;
	
				var drop = function drop(ev) {
					ev.preventDefault();
					var id = ev.dataTransfer.getData("text");
					var el = document.querySelector('[data-id="' + id + '"]');
					if (ev.target.appendChild(el)) {
						var instance = +el.dataset.instance;
						var time = +ev.target.dataset.time;
						var room = +ev.target.dataset.room;
	
						var session = _this13.sessions.find(function (session) {
							return id == session._id;
						});
						if (!session) {
							return;
						}
						session.overwriteStart = session.overwriteStart || {};
						session.overwriteStart[instance] = time;
						session.overwriteRoom = session.overwriteRoom || {};
						session.overwriteRoom[instance] = room;
	
						_this13.$http.put('/api/lessons/' + id, {
							overwriteRoom: session.overwriteRoom,
							overwriteStart: session.overwriteStart
						}).then(function (response) {
							_this13.clearCal();
						});
					}
				};
	
				var allowDrop = function allowDrop(ev) {
					ev.preventDefault();
				};
	
				var dragEnter = function dragEnter() {
					this.classList.add('drag-cell');
				};
	
				var dragLeave = function dragLeave() {
					this.classList.remove('drag-cell');
				};
	
				var dragStart = function dragStart(ev) {
					ev.dataTransfer.setData("text", ev.target.dataset.id);
					this.classList.add('in-drag');
					this.closest('table').classList.add('in-drag');
				};
	
				var dragStop = function dragStop() {
					document.querySelectorAll('.in-drag').forEach(function (item) {
						item.classList.remove('in-drag');
					});
					document.querySelectorAll('.drag-cell').forEach(function (item) {
						item.classList.remove('drag-cell');
					});
				};
	
				document.querySelectorAll('.free-col').forEach(function (item) {
					item.ondrop = drop;
					item.ondragover = allowDrop;
					item.ondragenter = dragEnter;
					item.ondragleave = dragLeave;
				});
	
				document.querySelectorAll('.session-cell').forEach(function (item) {
					item.ondragstart = dragStart;
				});
	
				document.ondragend = dragStop;
				document.ondrop = dragStop;
	
				var el = document.querySelector('.table-wrap');
				if (this.loading || this.changingDay) {
					el.scrollTop = 432;
				}
	
				this.changingDay = false;
				this.loading = false;
			}
		}, {
			key: 'reloadCal',
			value: function reloadCal() {
				var _this14 = this;
	
				this.$http.get('/api/lessons').then(function (response) {
					_this14.sessions = response.data;
					_this14.clearCal();
				});
			}
		}, {
			key: 'reloadStudents',
			value: function reloadStudents() {
				var _this15 = this;
	
				this.$http.get('/api/students').then(function (response) {
					_this15.students = response.data;
					_this15.reloadCal();
				});
			}
		}, {
			key: 'addSessionModal',
			value: function addSessionModal(startTime, room) {
				var _this16 = this;
	
				this.$uibModal.open({
					template: __webpack_require__(55),
					controller: 'SessionController',
					controllerAs: 'vm',
					windowClass: 'session-modal',
					resolve: {
						data: function data() {
							return {
								startTime: startTime,
								room: room,
								location: _this16.location,
								date: _this16.calendarDate
							};
						}
					}
				}).result.then(function (res) {
					if (res.reason == 'success') {
						_this16.tempSuccess = true;
						_this16.sessions.push(res.data);
						_this16.clearCal();
					}
				});
			}
		}, {
			key: 'editSessionModal',
			value: function editSessionModal(uid, instance) {
				var _this17 = this;
	
				var _data = this.sessions.find(function (item) {
					return item._id == uid;
				});
	
				if (!_data) return;
	
				_data.aInstance = instance;
	
				this.$uibModal.open({
					template: __webpack_require__(56),
					controller: 'EditSessionController',
					controllerAs: 'vm',
					windowClass: 'session-modal',
					resolve: {
						data: function data() {
							return _data;
						}
					}
				}).result.then(function (res) {
					if (res.reason == 'success') {
						_this17.tempSuccess = true;
						var index = _this17.sessions.findIndex(function (s) {
							return s._id === res.data._id;
						});
						_this17.sessions[index] = res.data;
	
						_this17.clearCal();
					}
				});
			}
		}, {
			key: 'clearCal',
			value: function clearCal(delayUpdate) {
				var _this18 = this;
	
				console.log('clearing calendar');
				document.querySelectorAll('.session-cell').forEach(function (item) {
					item.parentNode.removeChild(item);
				});
				if (delayUpdate) {
					this.$timeout(function () {
						_this18.updateCal();
					}, 300);
				} else {
					this.updateCal();
				}
			}
		}, {
			key: 'scrubAll',
			value: function scrubAll() {
				var _this19 = this;
	
				this.$http.get('/api/lessons/scrub-all').then(function (response) {
					_this19.reloadStudents();
				});
			}
		}, {
			key: 'scrubDay',
			value: function scrubDay() {
				var _this20 = this;
	
				this.$http.post('/api/lessons/scrub-day', { list: this.visibleLessons }).then(function (response) {
					_this20.reloadStudents();
				});
			}
		}, {
			key: 'addCalendar',
			value: function addCalendar(session, instance) {
	
				if (session.overwriteVisibility && session.overwriteVisibility[instance]) {
					return;
				}
	
				this.visibleLessons.push(session._id);
	
				var identifier = 't' + session.startTime + 'r' + session.room;
	
	
				var specificNotes = session.overwriteNotes && instance in session.overwriteNotes ? session.overwriteNotes[instance] : null;
	
	
				var color = this.ColorFinder(session, instance);
	
				var _div = document.createElement('div');
				if (color.indexOf(' ') != -1) {
					var _temp = color.split(' ');
					color = _temp[1] + ' ' + _temp[0];
				}
				_div.className = 'session-cell';
				_div.id = 'a-' + identifier;
				_div.setAttribute('draggable', 'true');
				_div.setAttribute('data-id', session._id);
				_div.setAttribute('data-phone', session.student.clientPh);
				_div.setAttribute('data-email', session.student.clientEmail);
				_div.setAttribute('data-instance', instance);
	
				var _duration = this.HourFinder(session, instance);
				_div.style.height = 'calc(' + String(100 * (_duration / 30)) + '% - 4px)';
				if (_duration < 60) _div.className += ' single-cell';
	
				var isChangeover = session.overwriteChangeover && instance in session.overwriteChangeover ? session.overwriteChangeover[instance] : session.changeover;
				if (isChangeover) {
					_div.className += ' changeover';
				}
	
				if (session.isChangeover && session.isChangeover[instance]) _div.className += ' changeover';
	
				if (session.overwriteName && session.overwriteName[instance]) {
					_div.innerHTML = '<span class="student">' + session.overwriteName[instance] + '</span>';
				} else {
					_div.innerHTML = '<span class="student">' + session.student.firstName + ' ' + session.student.lastName + '</span>';
				}
	
				_div.innerHTML += '<span class="tutor">' + session.tutor.firstName + ' ' + session.tutor.lastName + '</span>';
	
				var compiledNotes = '';
				if (session.globalNotes) {
					_div.innerHTML += '<br><span class="notes global-notes">' + session.globalNotes + '</span>';
					compiledNotes += 'Global Notes: \n' + session.globalNotes + '\n';
				}
				if (specificNotes) {
					_div.innerHTML += '<br><span class="notes specific-notes">' + specificNotes + '</span>';
					compiledNotes += 'Specific Notes: \n' + specificNotes + '\n';
				}
	
				if (session.student.clientFirstName || session.student.clientLastName) {
					compiledNotes += 'Contact Name: ' + session.student.clientFirstName + ' ' + session.student.clientLastName + '\n';
				}
	
				if (session.student.clientPh) {
					compiledNotes += 'Contact Number: ' + session.student.clientPh + '\n';
				}
	
				if (session.student.grade) {
					compiledNotes += 'Student Year: ' + session.student.grade + '\n';
				}
	
				if (session.student.subjects) {
					compiledNotes += 'Subjects: ' + session.student.subjects;
				}
	
				if (session.tutor && session.tutor.phone) {
					compiledNotes += 'Tutor Number: ' + session.tutor.phone + '\n';
				}
	
				_div.setAttribute('title', compiledNotes);
	
				var _icons = '';
				if (session.overwriteVar1 && session.overwriteVar1[instance] === true) _icons += '<i class="fa fa-' + this.icons.first + ' norm-icon" aria-hidden="true"></i>';
				if (session.overwriteVar2 && session.overwriteVar2[instance] === true) _icons += '<i class="fa fa-' + this.icons.second + ' norm-icon" aria-hidden="true"></i>';
				if (session.student.var3) _icons += '<i class="fa fa-' + this.icons.third + ' norm-icon" aria-hidden="true"></i>';
				if (session.student.var4) _icons += '<i class="fa fa-' + this.icons.fourth + ' norm-icon" aria-hidden="true"></i>';
				if (session.overwriteVar5 && session.overwriteVar5[instance] === true) _icons += '<i class="fa fa-' + this.icons.fifth + ' norm-icon" aria-hidden="true"></i>';
				if (session.overwriteVar6 && session.overwriteVar6[instance] === true) _icons += '<i class="fa fa-' + this.icons.sixth + ' norm-icon" aria-hidden="true"></i>';
				if (session.overwriteVar7 && session.overwriteVar7[instance] === true) _icons += '<i class="fa fa-' + this.icons._tempUnknown + ' norm-icon" aria-hidden="true"></i>';
				if (session.student.var8) _icons += '<i class="fa fa-' + this.icons._permUnknown + ' norm-icon" aria-hidden="true"></i>';
				if (session.student.var9) _icons += '<i class="fa fa-' + this.icons._perm2Unknown + ' norm-icon" aria-hidden="true"></i>';
				if (session.student.grade == 12) _icons += '<i class="fa fa-' + this.icons.year12 + ' grade-12" aria-hidden="true"></i>';
				if (specificNotes) _icons += '<i class="fa fa-' + this.icons._note + ' norm-icon" aria-hidden="true"></i>';
				if (session.student.price == '$60') _icons += '<i class="fa"><strong>60</strong></i>';
				if (session.student.price == '$70') _icons += '<i class="fa"><strong>70</strong></i>';
				if (session.student.price == '$80') _icons += '<i class="fa"><strong>80</strong></i>';
				if (_icons) _div.innerHTML += '<div class="icon-row">' + _icons + '</div>';
	
				_div.innerHTML += '<div class="a-bg ' + 'aa' + color + '"></div>';
	
				var _start = this.StartFinder(session, instance);
				var _room = session.overwriteRoom && instance in session.overwriteRoom ? session.overwriteRoom[instance] : session.room;
				var _targ = document.getElementById('t' + _start + 'r' + _room);
	
				_targ && _targ.insertBefore(_div, null);
			}
		}, {
			key: 'isCurrentDay',
			value: function isCurrentDay(index) {
				return this.calendarDate.getDay() === index;
			}
		}, {
			key: 'setDayOfWeek',
			value: function setDayOfWeek(index) {
				this.changingDay = true;
				var newIndex = (index + 1) % 7;
	
				var targetDate = this.calendarDate.getDate() + (newIndex - this.calendarDate.getDay());
				if (this.calendarDate.getDay() === 0) {
					targetDate -= 7;
				} else if (newIndex === 0) {
					targetDate += 7;
				}
	
				this.calendarDate = new Date(this.calendarDate.setDate(targetDate));
				this.clearCal();
			}
		}, {
			key: 'createArray',
			value: function createArray(length) {
				return Array.apply(null, Array(length)).map(function (x, i) {
					return i;
				});
			}
		}, {
			key: 'addDays',
			value: function addDays(days) {
				this.changingDay = true;
				this.calendarDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), this.calendarDate.getDate() + days);
				this.clearCal();
			}
		}, {
			key: 'changeLocation',
			value: function changeLocation(location) {
				this.changingDay = true;
				this.location = location;
				this.clearCal(true);
			}
		}]);
	
		return CalendarController;
	}();
	
	exports.default = CalendarController;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n\t<h4 class=\"modal-title\">Daily Colour Count</h4>\r\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\r\n</div>\r\n<div class=\"modal-body\">\r\n\t<table class=\"table table-striped\">\r\n\t\t<thead>\r\n\t\t\t<tr>\r\n\t\t\t\t<th>Colour</th>\r\n\t\t\t\t<th>Count</th>\r\n\t\t\t</tr>\r\n\t\t</thead>\r\n\t\t<tbody>\r\n\t\t\t<tr ng-repeat=\"(key, count) in vm.counts\" ng-if=\"count\">\r\n\t\t\t\t<td style=\"text-transform: capitalize;\">{{key}}</td>\r\n\t\t\t\t<td>{{count}}</td>\r\n\t\t\t</tr>\r\n\t\t\t<tr>\r\n\t\t\t\t<th>Total</th>\r\n\t\t\t\t<th>{{vm.total}}</th>\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t<p>The colour count only includes Blue, Green, Dark Green, Purple, Dark Purple, Orange, Dark Orange, Red and Dark Blue.</p>\r\n\t<p>Note that the colour Red does not contribute to the final total.</p>\r\n\t<hr>\r\n\t<div class=\"text-right\">\r\n\t\t<span style=\"margin-right: 30px\" ng-show=\"vm.saved\">Saved</span>\r\n\t\t<span style=\"margin-right: 30px\">\r\n\t\t\t<span>Last Save:</span>\r\n\t\t\t<span ng-hide=\"vm.loaded\">Loading...</span>\r\n\t\t\t<span ng-show=\"vm.loaded\">{{(vm.lastWrite | date:'dd/MM/yyyy') || 'Never'}}</span>\r\n\t\t</span>\r\n\t\t<button class=\"btn btn-lg btn-success\" type=\"button\" ng-click=\"vm.writeDB()\" ng-disabled=\"!vm.counts || vm.counts.length === 0\">\r\n\t\t\t<span>Write to DB</span>\r\n\t\t</button>\r\n\t</div>\r\n</div>"

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit($close)\">\r\n<div class=\"modal-header\">\r\n\t<h4 class=\"modal-title\">Send {{vm.isTutor ? 'Tutor' : 'Student'}} SMS</h4>\r\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\r\n</div>\r\n<div class=\"modal-body\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-6\">\r\n\t\t\t<label>{{vm.isTutor ? 'Tutor' : 'Client'}} Phone Number</label>\r\n\t\t\t<input type=\"tel\" required class=\"form-control\" ng-model=\"vm.phone\" ng-change=\"vm.changed = true\" />\r\n\t\t</div>\r\n\t\t<div class=\"col-md-6\">\r\n\t\t\t<label>Sender Number</label>\r\n\t\t\t<select class=\"form-control\" required ng-model=\"vm.defaultSenderNumber\" placeholder=\"Select a sender\">\r\n\t\t\t\t<option ng-value=\"number\" ng-repeat=\"number in vm.sendernumbers\">{{number}}</option>\r\n\t\t\t  </select>\r\n\t\t</div>\r\n\t\t<div class=\"col-md-6\" ng-show=\"vm.changed\">\r\n\t\t\t<label style=\"margin-top: 30px\"><input type=\"checkbox\" style=\"margin-right: 10px\" ng-model=\"vm.save\">Permanently save changes</label>\r\n\t\t</div>\r\n\t</div>\r\n\t<hr>\r\n\t<label>SMS Message, dont use hyphens, avoid symbols</label>\r\n\t<textarea class=\"form-control\" rows=\"10\" ng-maxlength=\"150\" required ng-model=\"vm.message\"></textarea>\r\n\t<p style=\"margin-top: 10px\">Max length 150. Current length: {{vm.message.length}}</p>\r\n\t<div class=\"alert alert-danger\" ng-show=\"vm.error\" ng-bind=\"vm.error\" style=\"margin-top: 20px\">\r\n  \t</div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss('close')\">Close</button>\r\n\t<button type=\"submit\" class=\"btn btn-success\">Send</button>\r\n</div>\r\n</form>"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit($resolve.data, $close)\">\r\n<div class=\"modal-header\">\r\n\t<h4 class=\"modal-title\">Create New Session</h4>\r\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\r\n</div>\r\n<div class=\"modal-body\">\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label>Student</label>\r\n\t\t\t<div class=\"select-wrap\">\r\n\t\t\t\t<tags-input ng-model=\"vm.selectedStudent\"\r\n\t\t\t\tng-disabled=\"vm.selectedStudent\" \r\n\t                  name=\"selectedStudent\"\r\n\t                  placeholder=\" \"\r\n\t                  add-from-autocomplete-only=\"true\"\r\n\t                  replace-spaces-with-dashes=\"false\"\r\n\t                  display-property=\"fullName\" required tabindex=\"-1\">\r\n\t\t        \t<auto-complete source=\"vm.returnFilter(vm.students, $query)\" \r\n\t\t                       min-length=\"1\" ></auto-complete>\r\n\t\t      \t</tags-input>\r\n\t\t      \t<button class=\"btn btn-danger\" ng-click=\"vm.selectedStudent = null\" ng-show=\"vm.selectedStudent\" tabindex=\"-1\">Edit</button>\r\n\t      \t</div>\r\n\t\t</div>\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label>Tutor</label>\r\n\t\t\t<div class=\"select-wrap\">\r\n\t\t\t\t<tags-input ng-model=\"vm.selectedTutor\"\r\n\t\t\t\tng-disabled=\"vm.selectedTutor\" \r\n\t                  name=\"selectedTutor\"\r\n\t                  placeholder=\" \"\r\n\t                  add-from-autocomplete-only=\"true\"\r\n\t                  replace-spaces-with-dashes=\"false\"\r\n\t                  display-property=\"fullName\" required>\r\n\t\t        \t<auto-complete source=\"vm.returnFilter(vm.tutors, $query)\" \r\n\t\t                       min-length=\"1\" ></auto-complete>\r\n\t\t      \t</tags-input>\r\n\t\t      \t<button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.selectedTutor = null\" ng-show=\"vm.selectedTutor\" tabindex=\"-1\">Edit</button>\r\n\t      \t</div>\r\n\t\t</div>\r\n\t\t<div class=\"form-group duration-group\">\r\n\t\t\t<label>Duration</label>\r\n\t\t\t<div>\r\n\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-repeat=\"duration in [30,60,90,120,150,180,210,240]\" ng-click=\"vm.changeDuration(duration)\" ng-class=\"{'btn-primary': vm.newSession.duration == duration}\">{{duration}} m</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"form-group color-group\">\r\n\t\t\t<label>Color</label>\r\n\t\t\t<div>\r\n\t\t\t\t<span class=\"color-box aa{{color}}\" ng-repeat=\"color in vm.colors\" ng-click=\"vm.newSession.color = color\" ng-class=\"{'active': vm.newSession.color == color}\"></span>\r\n\t\t\t</div>\r\n\t\t\t<div>\r\n\t\t\t\t<span class=\"color-box dark aa{{color}}\" ng-repeat=\"color in vm.colors\" ng-click=\"vm.newSession.color = 'dark ' + color\" ng-class=\"{'active': vm.newSession.color == 'dark ' + color}\"></span>\r\n\t\t\t</div>\r\n\t\t\t<div>\r\n\t\t\t\t<span class=\"color-box striped aa{{color}}\" ng-repeat=\"color in vm.colors\" ng-click=\"vm.newSession.color = 'striped ' + color\" ng-class=\"{'active': vm.newSession.color == 'striped ' + color}\"></span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<hr>\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<div class=\"row\">\r\n\t\t\t\t<div class=\"col-md-6\">\r\n\t\t\t\t\t<label>Frequency</label>\r\n\t\t\t\t\t<div>\r\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newSession.frequency = 0; vm.showNotes = true;\" ng-class=\"{'btn-primary': vm.newSession.frequency == 0}\">One Off</button>\r\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newSession.frequency = 7\" ng-class=\"{'btn-primary': vm.newSession.frequency == 7}\">Weekly</button>\r\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newSession.frequency = 14\" ng-class=\"{'btn-primary': vm.newSession.frequency == 14}\">Fortnightly</button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-md-6\" ng-show=\"vm.newSession.frequency\">\r\n\t\t\t\t\t<label>Occurences</label>\r\n\t\t\t\t\t<div class=\"flex\">\r\n\t\t\t          <input type=\"number\" class=\"form-control\" min=\"2\" placeholder=\"Occurences\" ng-model=\"vm.newSession.instances\" ng-disabled=\"vm.inf\" ng-required=\"!vm.inf && vm.newSession.frequency\">\r\n\t\t\t          <button type=\"button\" class=\"btn btn-default tertiary\" style=\"margin-left: 3px\" ng-click=\"vm.inf = !vm.inf\" ng-class=\"{'btn-primary': vm.inf}\">∞\r\n\t\t\t          </button>\r\n\t\t\t        </div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"form-group row\">\r\n\t\t\t<div class=\"col-sm-6\">\r\n  \t\t\t\t<label>Overwrite Student Name</label>\r\n  \t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.newSession.overwriteName[0]\" ng-disabled=\"vm.newSession.duration === 30\">\r\n  \t\t\t</div>\r\n  \t\t\t<div class=\"col-sm-6\">\r\n  \t\t\t\t<label>Changeover Line</label>\r\n  \t\t\t\t<div>\r\n  \t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newSession._changeover = 'present';\" ng-class=\"{'btn-primary': vm.newSession._changeover ===  'present'}\">Series</button>\r\n\t\t\t\t\t<button type=\"button\" \r\n\t\t\t\t\t\tclass=\"btn btn-default\" \r\n\t\t\t\t\t\tng-hide=\"vm.newSession.frequency === 0\"\r\n\t\t\t\t\t\tng-click=\"vm.newSession._changeover = 'one off'\" \r\n\t\t\t\t\t\tng-class=\"{'btn-primary': vm.newSession._changeover === 'one off'}\">Instance</button>\r\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newSession._changeover = null;\" ng-class=\"{'btn-primary': !vm.newSession._changeover}\">None</button>\r\n  \t\t\t\t</div>\r\n  \t\t\t</div>\r\n  \t\t</div>\r\n\t\t<div class=\"form-group\" ng-show=\"vm.showNotes\">\r\n\t\t\t<hr>\r\n\t\t\t<label>Notes</label>\r\n\t\t\t<textarea class=\"form-control\" ng-model=\"vm.newSession.globalNotes\" rows=\"4\" placeholder=\"Global notes section\"></textarea>\r\n\t\t</div>\r\n\t\t<div class=\"alert alert-danger\" ng-show=\"vm.error\">\r\n    \t\tThere was an error:<br>\r\n    \t\t<code>{{vm.error}}</code>\r\n  \t\t</div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n\t<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss('close')\">Close</button>\r\n\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.showNotes = !vm.showNotes\" ng-bind=\"vm.showNotes ? 'Hide Notes' : 'Add Notes'\"></button>\r\n\t<button type=\"submit\" class=\"btn btn-success\">Create</button>\r\n</div>\r\n</form>"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit(vm.data, $close)\">\r\n\t<div class=\"modal-header\">\r\n\t\t<h4 class=\"modal-title\">Edit Session</h4>\r\n\t\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span\r\n\t\t\t\taria-hidden=\"true\">&times;</span></button>\r\n\t</div>\r\n\t<div class=\"modal-body\">\r\n\t\t<div class=\"form-group\" ng-if=\"vm.tutors\">\r\n\t\t\t<label>Tutor</label>\r\n\t\t\t<div class=\"select-wrap\">\r\n\t\t\t\t<tags-input ng-model=\"vm.selectedTutor\" ng-disabled=\"vm.selectedTutor.length\" name=\"selectedTutor\"\r\n\t\t\t\t\tplaceholder=\" \" add-from-autocomplete-only=\"true\" replace-spaces-with-dashes=\"false\"\r\n\t\t\t\t\tdisplay-property=\"fullName\" required>\r\n\t\t\t\t\t<auto-complete source=\"vm.returnFilter(vm.tutors, $query)\" min-length=\"1\"></auto-complete>\r\n\t\t\t\t</tags-input>\r\n\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.selectedTutor = []\"\r\n\t\t\t\t\tng-show=\"vm.selectedTutor.length\" tabindex=\"-1\">Edit</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"form-group row\">\r\n\t\t\t<label class=\"col-sm-3\">Student</label>\r\n\t\t\t<div class=\"col-sm-3\">{{vm.returnName(vm.data)}}</div>\r\n\t\t</div>\r\n\t\t<div class=\"form-group row\">\r\n\t\t\t<label class=\"col-sm-3\">Client Name</label>\r\n\t\t\t<div class=\"col-sm-3\">{{vm.data.student.clientFirstName + ' ' + vm.data.student.clientLastName}}</div>\r\n\t\t\t<label class=\"col-sm-3\">CRM ID</label>\r\n\t\t\t<div class=\"col-sm-3\">{{vm.data.student.crmID}}</div>\r\n\t\t</div>\r\n\t\t<hr>\r\n\t\t<div class=\"form-group duration-group\">\r\n\t\t\t<label>Duration (exception change)</label>\r\n\t\t\t<div>\r\n\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-repeat=\"duration in [30,60,90,120,150,180,210,240]\"\r\n\t\t\t\t\tng-click=\"vm.data.overwriteDuration[vm.instance] = duration\"\r\n\t\t\t\t\tng-class=\"{'btn-primary': vm.data.overwriteDuration[vm.instance] ? vm.data.overwriteDuration[vm.instance] === duration : vm.data.duration === duration}\">{{duration}}\r\n\t\t\t\t\tm</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<hr>\r\n\t\t<div class=\"form-group color-group\">\r\n\t\t\t<ul class=\"nav nav-tabs\" style=\"margin-bottom: 15px;\">\r\n\t\t\t\t<li role=\"presentation\" ng-class=\"{active: vm.tab === 'instance'}\"><a href=\"#\"\r\n\t\t\t\t\t\tng-click=\"vm.tab = 'instance'\">Instance Colour</a></li>\r\n\t\t\t\t<li role=\"presentation\" ng-class=\"{active: vm.tab === 'series'}\"><a href=\"#\"\r\n\t\t\t\t\t\tng-click=\"vm.tab = 'series'\">Series Colour</a></li>\r\n\t\t\t\t<li role=\"presentation\" ng-class=\"{active: vm.tab === 'starting'}\"><a href=\"#\"\r\n\t\t\t\t\t\tng-click=\"vm.tab = 'starting'\">From Here Colour</a></li>\r\n\t\t\t</ul>\r\n\t\t\t<div ng-show=\"vm.tab === 'instance'\" class=\"color-house\">\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.overwriteColor[vm.instance] = color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.overwriteColor[vm.instance] === color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box dark aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.overwriteColor[vm.instance] = 'dark ' + color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.overwriteColor[vm.instance] === 'dark ' + color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box striped aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.overwriteColor[vm.instance] = 'striped ' + color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.overwriteColor[vm.instance] === 'striped ' + color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div ng-show=\"vm.tab === 'series'\" class=\"color-house\">\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box aa{{color}}\" ng-repeat=\"color in vm.colors\" ng-click=\"vm.data.color = color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.color === color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box dark aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.color = 'dark ' + color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.color === 'dark ' + color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box striped aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.color = 'striped ' + color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.color === 'striped ' + color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div ng-show=\"vm.tab === 'starting'\" class=\"color-house\">\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.overwriteFromHere[vm.instance] = color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.overwriteFromHere[vm.instance] === color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box dark aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.overwriteFromHere[vm.instance] = 'dark ' + color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.overwriteFromHere[vm.instance] === 'dark ' + color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<span class=\"color-box striped aa{{color}}\" ng-repeat=\"color in vm.colors\"\r\n\t\t\t\t\t\tng-click=\"vm.data.overwriteFromHere[vm.instance] = 'striped ' + color\"\r\n\t\t\t\t\t\tng-class=\"{'active': vm.data.overwriteFromHere[vm.instance] === 'striped ' + color}\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<hr>\r\n\t\t<div class=\"form-group row\">\r\n\t\t\t<div class=\"col-sm-6\">\r\n\t\t\t\t<label>Global Notes</label>\r\n\t\t\t\t<textarea class=\"form-control\" ng-model=\"vm.data.globalNotes\" rows=\"4\"></textarea>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-sm-6\">\r\n\t\t\t\t<label>Specific Notes</label>\r\n\t\t\t\t<textarea class=\"form-control\" ng-model=\"vm.data.overwriteNotes[vm.instance]\" rows=\"4\"></textarea>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<hr>\r\n\t\t<div class=\"form-group row\">\r\n\t\t\t<div class=\"col-md-8\">\r\n\t\t\t\t<label>Overwrite Student Name</label>\r\n\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.data.overwriteName[vm.instance]\">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-sm-4\">\r\n\t\t\t\t<label>Changeover Line</label>\r\n\t\t\t\t<div>\r\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.data.changeover = true;\"\r\n\t\t\t\t\t\tng-class=\"{'btn-primary': vm.data.changeover}\">Series</button>\r\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.data.changeover = false;\"\r\n\t\t\t\t\t\tng-class=\"{'btn-primary': !vm.data.changeover}\">None</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<span ng-show=\"!vm.data.instances\">\r\n\t\t\t<hr>\r\n\t\t\t<label><input type=\"checkbox\" ng-model=\"vm.lastInstance\"> Make Last Instance</label>\r\n\t\t</span>\r\n\t\t<div class=\"alert alert-danger\" ng-show=\"vm.error\">\r\n\t\t\tThere was an error:<br>\r\n\t\t\t<code>{{vm.error}}</code>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"modal-footer\">\r\n\t\t<button type=\"submit\" class=\"btn btn-success btn-block btn-lg\">Save</button>\r\n\t</div>\r\n</form>"

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['data', '$filter', '$http'];
		function _class(data, $filter, $http) {
			_classCallCheck(this, _class);
	
			this.data = data;
			this.student = data.student;
			this.tutor = data.tutor;
			this.isTutor = data.isTutor;
			this.$filter = $filter;
			this.$http = $http;
			this.isTomorrow = data.isTomorrow;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.error = null;
				this.changed = false;
				if (this.isTutor) {
					this.setNumber(this.tutor.phone);
				} else {
					this.setNumber(this.student.clientPh);
				}
	
				this.setField('parent', this.student.clientFirstName, true);
				this.setField('studentName', this.student.firstName, true);
				this.setField('tutorName', this.tutor.firstName);
	
				var tomorrow = new Date();
				tomorrow.setDate(tomorrow.getDate() + 1);
				tomorrow = this.$filter('date')(tomorrow, 'dd/MM');
	
				this.date = this.$filter('date')(new Date(), 'dd/MM');
				this.time = this.$filter('segmentConvert')(this.data.time);
				if (!this.isTutor) {
					if (this.isTomorrow) {
						this.message = 'Hi ' + this.parent + '! Just a reminder that ' + this.studentName + ' has tuition tomorrow (' + tomorrow + ') at ' + this.time + '. Thanks, Pat (Personal Tutors)';
					} else {
						this.message = 'Hi ' + this.parent + '! Just a reminder that ' + this.studentName + ' has tuition this afternoon (' + this.date + ') at ' + this.time + '. Thanks, Pat (Personal Tutors)';
					}
				} else {
					if (this.isTomorrow) {
						this.message = 'Hi ' + this.tutorName + '! Just a reminder that you tutor tomorrow (' + tomorrow + ') from ' + this.time + ' to ' + this.time + ' (0 Hours). Thanks, Pat (Personal Tutors)';
					} else {
						this.message = 'Hi ' + this.tutorName + '! Just a reminder that you tutor this afternoon (' + this.date + ') from ' + this.time + ' to ' + this.time + ' (0 Hours). Thanks, Pat (Personal Tutors)';
					}
				}
	
				this.$http.get('/api/smssettings').then(function (response) {
					_this.defaultSenderNumber = response.data[0].mobileNumber1;
					_this.sendernumbers = [response.data[0].mobileNumber1, response.data[0].mobileNumber2, response.data[0].mobileNumber3];
				});
			}
		}, {
			key: 'setNumber',
			value: function setNumber(data) {
				if (!data) {
					return;
				}
				data = data.replace(' ', '');
				this.phone = data;
			}
		}, {
			key: 'setField',
			value: function setField(field, data, forStudent) {
				if (!data) {
					if (forStudent && !this.isTutor || this.isTutor && !forStudent) {
						this.error = 'Not all fields are set. Please revise.';
					}
				}
				this[field] = data || 'Unset';
			}
		}, {
			key: 'postSMS',
			value: function postSMS(phone, callback) {
				var _this2 = this;
	
				var message = decodeURI(this.message);
				this.$http.post('http://api.smsbroadcast.com.au/api-adv.php?username=pspeare&password=GSPT2011&to=' + phone + '&from=' + this.defaultSenderNumber + '&message=' + message).then(function (res) {
					callback(_this2.saveType);
				}).catch(function (res) {
					_this2.error = "Something went wrong.";
				});
			}
		}, {
			key: 'submit',
			value: function submit(callback) {
				var _this3 = this;
	
				this.error = null;
				var phone = this.phone.replace(' ', '');
				if (this.isTutor) {
					if (this.save) {
						console.log('saving');
						this.tutor.phone = phone;
						this.saveType = 'changed';
						this.$http.put('/api/tutors/' + this.tutor._id, this.tutor).then(function (res) {
							_this3.postSMS(phone, callback);
						}).catch(function (res) {
							_this3.error = 'Error when saving. SMS not sent. Please refresh.';
						});
					} else {
						this.saveType = 'success';
						this.postSMS(phone, callback);
					}
				} else {
					if (this.save) {
						console.log('saving');
						this.student.clientPh = phone;
						this.saveType = 'changed';
						this.$http.put('/api/students/' + this.student._id, this.student).then(function (res) {
							_this3.postSMS(phone, callback);
						}).catch(function (res) {
							_this3.error = 'Error when saving. SMS not sent. Please refresh.';
						});
					} else {
						this.saveType = 'success';
						this.postSMS(phone, callback);
					}
				}
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', '$filter'];
		function _class($http, $filter) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.$filter = $filter;
			this.showNotes = false;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.inf = true;
				this.newSession = {
					instances: 0,
					duration: 60,
					color: 'blue',
					frequency: 7
				};
				this.$http.get('/api/students').then(function (response) {
					_this.students = [];
					response.data.forEach(function (student) {
						if (student.isActive) _this.students.push(student);
					});
				});
				this.$http.get('/api/tutors').then(function (response) {
					_this.tutors = response.data;
				});
	
				this.colors = ['blue', 'orange', 'red', 'purple', 'grey', 'green', 'yellow', 'lime'];
			}
		}, {
			key: 'returnFilter',
			value: function returnFilter(results, $query) {
				return results.filter(function (item) {
					if (item.isActive === false) {
						return false;
					}
					return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
				});
			}
		}, {
			key: 'changeDuration',
			value: function changeDuration(duration) {
				this.newSession.duration = duration;
	
				if (duration === 30) {
					console.log('showing notes...');
					this.showNotes = true;
				}
			}
		}, {
			key: 'submit',
			value: function submit(data, callback) {
				var _this2 = this;
	
				if (!this.selectedStudent || !this.selectedTutor || !data) {
					this.error = 'Incomplete form or front-end bug. Refresh browser.';
					return;
				}
	
				this.newSession.startTime = data.startTime;
				this.newSession.room = data.room;
				this.newSession.location = data.location;
				this.newSession.date = this.$filter('date')(data.date, 'dd/MM/yyyy');
				this.newSession.clientUID = this.selectedStudent[0]._id;
				this.newSession.tutorUID = this.selectedTutor[0]._id;
	
				if (this.newSession._changeover === 'present') {
					this.newSession.changeover = true;
				}
	
				if (this.newSession._changeover === 'one off') {
					this.newSession.overwriteChangeover = { 0: true };
				}
	
				if (!this.newSession.frequency) this.newSession.instances = 1;
	
				if (this.newSession.frequency && this.inf) this.newSession.instances = 0;
	
	
				this.$http.post('/api/lessons', this.newSession).then(function (res) {
					_this2.error = '';
					callback({ reason: 'success', data: res.data });
				}).catch(function (res) {
					console.log(res);
					_this2.error = JSON.stringify(res.data, null, '\t');
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
		/*@ngInject*/
		_class.$inject = ['$http', '$filter', 'data'];
		function _class($http, $filter, data) {
			_classCallCheck(this, _class);
	
			this.selectedTutor = [];
	
			this.$http = $http;
			this.data = data;
			this.instance = this.data.aInstance;
			this.initialTutor = this.data.tutorUID;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.colors = ['blue', 'orange', 'red', 'purple', 'grey', 'green', 'yellow', 'lime'];
				this.tab = 'instance';
	
				this.$http.get('/api/tutors').then(function (res) {
					_this.tutors = res.data;
					var foundTutor = _this.tutors.find(function (t) {
						return t._id === _this.data.tutorUID;
					});
					_this.selectedTutor = foundTutor ? [foundTutor] : [];
				});
			}
		}, {
			key: 'returnName',
			value: function returnName(data) {
				if (data.overwriteName && data.overwriteName[data.aInstance]) {
					return data.overwriteName[data.aInstance];
				};
	
				return data.student.firstName + ' ' + data.student.lastName;
			}
		}, {
			key: 'returnFilter',
			value: function returnFilter(results, $query) {
				return results.filter(function (item) {
					if (item.isActive === false) {
						return false;
					}
					return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
				});
			}
		}, {
			key: 'submit',
			value: function submit(data, callback) {
				var _this2 = this;
	
				if (this.selectedTutor.length === 0) {
					this.error = 'Please enter a tutor.';
					return;
				}
	
				var instance = data.aInstance;
	
				if (this.lastInstance) {
					data.instances = instance + 1;
				}
	
				data.tutorUID = this.selectedTutor[0]._id;
	
				this.$http.put('/api/lessons/' + data._id, data).then(function (res) {
					_this2.error = '';
					callback({ reason: 'success', data: res.data });
				}).catch(function (res) {
					console.log(res);
					_this2.error = JSON.stringify(res.data, null, '\t');
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
		var split = date.split('/');
		var year = +split[2];
		if (year < 100) {
			year += 2000;
		}
		var month = +split[1] - 1;
		var day = +split[0];
		return new Date(year, month, day);
	}
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['todaysSessions', 'calendarDate', '$http', 'ColorFinder', 'HourFinder', 'StartFinder'];
		function _class(todaysSessions, calendarDate, $http, ColorFinder, HourFinder, StartFinder) {
			_classCallCheck(this, _class);
	
			this.todaysSessions = todaysSessions;
			this.counts = {
				'blue': 0,
				'green': 0,
				'dark green': 0,
				'dark blue': 0,
				'purple': 0,
				'dark purple': 0,
				'orange': 0,
				'dark orange': 0,
				'red': 0
			};
			this.total = 0;
			this.calendarDate = calendarDate;
			this.$http = $http;
			this.lastWrite = null;
			this.lastWriteId = null;
			this.loaded = false;
			this.saved = false;
			this.ColorFinder = ColorFinder;
			this.HourFinder = HourFinder;
			this.StartFinder = StartFinder;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/colour-writes').then(function (res) {
					var data = res.data;
	
					if (!data || data.length === 0) {
						return;
					}
	
					var found = data.find(function (datum) {
						return new Date(datum.calendarDate).getTime() === _this.calendarDate.getTime();
					});
	
					if (found) {
						_this.lastWrite = found.dateCreated;
						_this.lastWriteId = found._id;
					};
	
					_this.loaded = true;
				});
	
				this.todaysSessions.forEach(function (session) {
	
					var instance = session._instance;
	
					if (session.overwriteVisibility && session.overwriteVisibility[instance]) {
						return;
					}
	
					var _date = dateStringToDate(session.date);
					var day = _date.getDay();
	
					var time = _this.StartFinder(session, instance);
	
					var isWeekend = day === 0 || day === 6;
	
					if (!isWeekend && time < 930) {
						return;
					}
	
					var color = _this.ColorFinder(session, instance);
					var hours = _this.HourFinder(session, instance) / 60;
	
					if (typeof _this.counts[color] !== 'undefined') {
						_this.counts[color] += hours;
					}
				});
	
				this.total = Object.keys(this.counts).reduce(function (previous, key) {
					if (key === 'red') {
						return previous;
					}
	
					return previous + _this.counts[key];
				}, 0);
			}
		}, {
			key: 'writeDB',
			value: function writeDB() {
				var _this2 = this;
	
				console.log('fired');
				var data = {
					data: this.counts,
					calendarDate: this.calendarDate
				};
	
				if (this.lastWriteId) {
					this.$http.delete('/api/colour-writes/' + this.lastWriteId);
				}
	
				this.$http.post('/api/colour-writes', data).then(function (res) {
					_this2.lastWrite = new Date();
					_this2.saved = true;
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\" id=\"calendar-container\" ng-click=\"vm.clearMessages()\">\r\n\t<div class=\"row calendar-grey\">\r\n\t\t<div class=\"col-lg-9\">\r\n\t\t\t<div class=\"input-group date-group\">\r\n\t         \t<input type=\"text\" class=\"form-control date-input\" ng-change=\"vm.changingDay = true; vm.clearCal()\" uib-datepicker-popup=\"EEEE, MMMM d, y\" ng-model=\"vm.calendarDate\" is-open=\"opened\" close-text=\"Close\" style=\"pointer-events: none\" />\r\n\t         \t<span class=\"input-group-btn\">\r\n\t            \t<button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n\t          \t</span>\r\n\t        </div>\r\n\t        <div class=\"input-group search-group\">\r\n\t         \t<input type=\"text\" class=\"form-control\" ng-model=\"vm.searchFilter\" ng-change=\"vm.clearCal()\" placeholder=\"Search here...\" />\r\n\t         \t<span class=\"input-group-btn\">\r\n\t            \t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.searchFilter = ''; vm.clearCal()\"><i class=\"fa fa-close\"></i></button>\r\n\t          \t</span>\r\n\t        </div>\r\n\t        <span class=\"btn-group\" style=\"margin-right: 20px\">\r\n\t        \t<button class=\"btn btn-default\" ng-repeat=\"day in ['M', 'T', 'W', 'T', 'F', 'S', 'S'] track by $index\" ng-click=\"vm.setDayOfWeek($index)\" ng-disabled=\"vm.isCurrentDay(($index + 1) % 7)\">{{day}}</button>\r\n\t        </span>\r\n\t\t\t<span class=\"btn-group\">\r\n\t\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.addDays(-7)\"><i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i></button>\r\n\t\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.addDays(-1)\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button>\r\n\t\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.changingDay = true; vm.intDay(); vm.clearCal();\">Today</button>\r\n\t\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.addDays(1)\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button>\r\n\t\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.addDays(7)\"><i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></button>\r\n\t\t\t</span>\r\n\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.scrubDay()\" ng-show=\"vm.isSandbox\" style=\"margin-left: 40px;\">Scrub Day</button>\r\n\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.scrubAll()\" ng-show=\"vm.isSandbox\">Scrub All</button>\r\n\t\t\t<span class=\"btn-group\" style=\"margin-left: 20px;\">\r\n\t\t\t\t<button class=\"btn btn-default\" ng-click=\"vm.clearIconFilters(); vm.clearCal()\">\r\n\t\t\t\t\t<i class=\"fa fa-close\" aria-hidden=\"true\"></i>\r\n\t\t\t\t</button>\r\n\t\t\t\t<button class=\"btn\" ng-click=\"vm.iconFilterChange(key)\" ng-repeat=\"(key, value) in vm.icons\" ng-show=\"key[0] !== '_'\" ng-class=\"vm.iconFilters[key] ? 'btn-primary' : 'btn-default'\">\r\n\t\t\t\t\t<i class=\"fa fa-{{vm.icons[key]}}\" aria-hidden=\"true\"></i>\r\n\t\t\t\t</button>\r\n\t\t\t</span>\r\n\t\t</div>\r\n    <div class=\"col-lg-3 text-right\">\r\n      <button class=\"btn btn-default\" style=\"margin-right: 30px\" type=\"button\" ng-click=\"vm.colourCountModal()\">\r\n        <span>Colour Count</span>\r\n      </button>\r\n      <button class=\"btn btn-default\" ng-class=\"{'btn-primary': vm.location == 'paddington'}\" ng-click=\"vm.changeLocation('paddington')\">Paddington</button>\r\n      <button class=\"btn btn-default\" ng-class=\"{'btn-primary': vm.location == 'cannon hill'}\" ng-click=\"vm.changeLocation('cannon hill')\">Cannon Hill</button>\r\n      <button class=\"btn btn-default\" ng-class=\"{'btn-primary': vm.location == 'online'}\" ng-click=\"vm.changeLocation('online')\">Online</button>\r\n    </div>\r\n\t</div>\r\n\t<div class=\"row\">\r\n\t\t<table class=\"table table-striped a-calendar\" ng-class=\"{'loading': vm.loading}\">\r\n\t\t\t<thead>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<th class=\"time-col\"> </th>\r\n\t\t\t\t\t<th ng-repeat=\"room in vm.rooms[vm.location]\">Room {{room + 1}}</th>\r\n\t\t\t\t</tr>\r\n\t\t\t</thead>\r\n\t\t</table>\r\n\t</div>\r\n</div>\r\n<div>\r\n\t<div class=\"table-wrap\">\r\n\t\t<table class=\"table table-striped a-calendar\" ng-class=\"{'loading': vm.loading}\">\r\n\t\t\t<tbody>\r\n\t\t\t\t<tr ng-repeat=\"segment in vm.segments\">\r\n\t\t\t\t\t<th class=\"time-col text-center\"><span>{{segment | segmentConvert:true}}</span></th>\r\n\t\t\t\t  \t<td ng-repeat=\"room in vm.rooms[vm.location]\" class=\"free-col\" id=\"{{ 't' + (1440 / vm.segments.length * segment) + 'r' + room }}\" data-room=\"{{room}}\" data-time=\"{{1440 / vm.segments.length * segment}}\" ng-click=\"vm.handleClick($event)\" context-menu=\"vm.menuOptions\" ></td>\r\n\t\t\t\t</tr>\r\n\t\t\t</tbody>\r\n\t\t</table>\r\n\t</div>\r\n</div>\r\n<div class=\"a-success-wrap\" ng-show=\"vm.tempSuccess\">\r\n\t<div class=\"a-success-circle\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i></div>\r\n\t<div class=\"a-success-message\">Action successful.</div>\r\n</div>\r\n<div class=\"loading-wrap\" ng-show=\"vm.loading\">\r\n\t<svg id=\"load\" x=\"0px\" y=\"0px\" viewBox=\"0 0 150 150\">\r\n\t    <circle id=\"loading-inner\" cx=\"75\" cy=\"75\" r=\"60\"/>\r\n\t</svg>\r\n</div>\r\n"

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function () {
	  NavbarComponent.$inject = ['Auth', '$http'];
	  function NavbarComponent(Auth, $http) {
	    'ngInject';
	
	    _classCallCheck(this, NavbarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      state: 'main'
	    }];
	    this.isCollapsed = true;
	    this.isLoggedIn = Auth.isLoggedInSync;
	    this.isAdmin = Auth.isAdminSync;
	    this.getCurrentUser = Auth.getCurrentUserSync;
	    this.$http = $http;
	  }
	
	  _createClass(NavbarComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.isSandbox = location.host.includes('sandbox');
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      if (confirm('Are you sure you want to refresh the database?')) {
	        this.$http.get('/api/users/new-database');
	      }
	    }
	  }]);
	
	  return NavbarComponent;
	}();
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(63),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-static-top\" ng-class=\"{'red-nav': $ctrl.isSandbox}\">\r\n  <div class=\"container\">\r\n    <div class=\"navbar-header\">\r\n      <a ui-sref=\"calendar\" class=\"navbar-brand\">GSPT Calendar</a>\r\n    </div>\r\n    <ul class=\"nav navbar-nav\">\r\n      <li ui-sref-active=\"active\"><a ui-sref=\"admin.student\">Students</a></li>\r\n      <li ui-sref-active=\"active\"><a ui-sref=\"admin.tutor\">Tutors</a></li>\r\n      <li ui-sref-active=\"active\"><a ui-sref=\"admin.settings\">Settings</a></li>\r\n      <li ui-sref-active=\"active\"><a ui-sref=\"admin.colourSearch\">Colour Search</a></li>\r\n      <li ui-sref-active=\"active\"><a ui-sref=\"admin.studentInfo\">Student Report</a></li>\r\n      <li ui-sref-active=\"active\"><a ui-sref=\"admin.exportTutor\">Tutor Report</a></li>\r\n      <li ng-show=\"$ctrl.isSandbox\"><a ng-click=\"$ctrl.update()\" href=\"javascript:;\">New DB</a></li>\r\n\r\n    </ul>\r\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\r\n      <ul class=\"nav navbar-nav navbar-right\">\r\n        \r\n        <li ng-show=\"!$ctrl.isSandbox\"><a href=\"http://sandbox.gsptcal.com.au/\">Sandbox</a></li>\r\n        <li ng-show=\"$ctrl.isSandbox\"><a href=\"http://www.gsptcal.com.au/\">Real</a></li>\r\n        <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"main\">Login</a></li>\r\n        <li ng-show=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li>\r\n        <li ng-show=\"$ctrl.isLoggedIn()\"><a ui-sref=\"logout\">Logout - {{ $ctrl.getCurrentUser().name }}</a></li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['Auth', '$state', '$rootScope'];
	  function MainController(Auth, $state, $rootScope) {
	    _classCallCheck(this, MainController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	  }
	
	  _createClass(MainController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('calendar');
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	
	  return MainController;
	}();
	
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: __webpack_require__(65),
	    controller: 'MainController',
	    controllerAs: 'vm'
	  });
	}
	
	exports.default = _angular2.default.module('calApp.main', [_angularUiRouter2.default]).config(routes).controller('MainController', MainController).name;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex v-center h-center\" style=\"height: 80vh\">\r\n  <div style=\"    padding: 30px;\r\n    background-color: #ececec;\r\n    border-radius: 4px;\r\n    border: 1px solid #ccc;\">\r\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.login(form)\" novalidate style=\"min-width: 600px\">\r\n        <h1 class=\"w600\" style=\"margin-bottom: 20px; font-weight: 600;\">Login to GSPT Calendar</h1>\r\n\r\n        <div class=\"form-group\">\r\n\r\n          <input type=\"email\" name=\"email\" placeholder=\"Email Address\" class=\"form-control input-lg\" ng-model=\"vm.user.email\" required>\r\n        </div>\r\n\r\n        <div class=\"form-group\">\r\n\r\n          <input type=\"password\" name=\"password\" placeholder=\"Password\" class=\"form-control input-lg\" ng-model=\"vm.user.password\" required>\r\n        </div>\r\n\r\n        <div class=\"form-group has-error\">\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && form.password.$error.required && vm.submitted\">\r\n             Please enter your email and password.\r\n          </p>\r\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\r\n             Please enter a valid email.\r\n          </p>\r\n\r\n          <p class=\"help-block\">{{ vm.errors.login }}</p>\r\n        </div>\r\n\r\n        <div>\r\n          <button class=\"btn btn-primary btn-lg btn-block\" type=\"submit\" style=\"font-weight: 600\">\r\n            Login\r\n          </button>\r\n          <!-- <a class=\"btn btn-default btn-lg btn-register\" ui-sref=\"signup\">\r\n            Register\r\n          </a> -->\r\n        </div>\r\n\r\n      </form>\r\n  </div>\r\n</div>"

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Modal.$inject = ['$rootScope', '$uibModal'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modal = Modal;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Modal($rootScope, $uibModal) {
	  'ngInject';
	
	  function openModal() {
	    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var modalClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modal-default';
	
	    var modalScope = $rootScope.$new();
	
	    _angular2.default.extend(modalScope, scope);
	
	    return $uibModal.open({
	      template: __webpack_require__(67),
	      windowClass: modalClass,
	      scope: modalScope
	    });
	  }
	
	  return {
	    editStudent: function editStudent(student) {
	      $uibModal.open({
	        template: __webpack_require__(68),
	        controller: 'StudentController',
	        controllerAs: 'admin',
	        windowClass: 'student-modal',
	        resolve: {
	          data: function data() {
	            return student;
	          }
	        }
	      });
	    },
	    editTutor: function editTutor(tutor) {
	      $uibModal.open({
	        template: __webpack_require__(69),
	        controller: 'TutorController',
	        controllerAs: 'admin',
	        windowClass: 'student-modal',
	        resolve: {
	          data: function data() {
	            return tutor;
	          }
	        }
	      });
	    },
	
	    confirm: {
	      delete: function _delete() {
	        var del = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var slicedArgs = Reflect.apply(Array.prototype.slice, args);
	          var name = slicedArgs.shift();
	          var deleteModal;
	
	          deleteModal = openModal({
	            modal: {
	              dismissable: true,
	              title: 'Confirm Delete',
	              html: '<p>Are you sure you want to delete <strong>' + name + '</strong> ?</p>',
	              buttons: [{
	                classes: 'btn-danger',
	                text: 'Delete',
	                click: function click(e) {
	                  deleteModal.close(e);
	                }
	              }, {
	                classes: 'btn-default',
	                text: 'Cancel',
	                click: function click(e) {
	                  deleteModal.dismiss(e);
	                }
	              }]
	            }
	          }, 'modal-danger');
	
	          deleteModal.result.then(function (event) {
	            Reflect.apply(del, event, slicedArgs);
	          });
	        };
	      }
	    }
	  };
	}
	
	exports.default = _angular2.default.module('calApp.Modal', []).factory('Modal', Modal).name;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <button ng-if=\"modal.dismissable\" type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button>\r\n  <h4 ng-if=\"modal.title\" ng-bind=\"modal.title\" class=\"modal-title\"></h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <p ng-if=\"modal.text\" ng-bind=\"modal.text\"></p>\r\n  <div ng-if=\"modal.html\" ng-bind-html=\"modal.html\"></div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button ng-repeat=\"button in modal.buttons\" ng-class=\"button.classes\" ng-click=\"button.click($event)\" ng-bind=\"button.text\" class=\"btn\"></button>\r\n</div>\r\n"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body\">\r\n\t<button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss()\"><span aria-hidden=\"true\">&times;</span></button>\r\n<form ng-submit=\"admin.patchStudent($resolve.data, $dismiss);\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>First Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"$resolve.data.firstName\" placeholder=\"First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"$resolve.data.lastName\" placeholder=\"Last Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Data</label>\r\n        <div class=\"data-button-wrap\">\r\n          <button type=\"button\"  ng-click=\"$resolve.data.var1 =! $resolve.data.var1\" ng-class=\"{'active': $resolve.data.var1}\"><i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i></button>\r\n          <button type=\"button\" ng-click=\"$resolve.data.var2 =! $resolve.data.var2\" ng-class=\"{'active': $resolve.data.var2}\"><i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i></button>\r\n          <button type=\"button\" ng-click=\"$resolve.data.var3 =! $resolve.data.var3\" ng-class=\"{'active': $resolve.data.var3}\"><i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Grade</label>\r\n        <div class=\"input-group\">\r\n          <input type=\"number\" class=\"form-control\" ng-min=\"1\" ng-max=\"12\" placeholder=\"Grade\" ng-model=\"$resolve.data.grade\" ng-disabled=\"$resolve.data.isTertiary\" ng-required=\"!$resolve.data.isTertiary\">\r\n          <span class=\"input-group-addon tertiary\" ng-click=\"$resolve.data.isTertiary = !$resolve.data.isTertiary\" ng-class=\"{'active': $resolve.data.isTertiary}\" title=\"Is this a tertiary student?\">\r\n            <i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Client First Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.clientFirstName\" placeholder=\"Client First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Client Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.clientLastName\" placeholder=\"Client Last Name\">\r\n      </div>\r\n  </div>\r\n  <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>CRM ID</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.crmID\" placeholder=\"CRM ID\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2\">\r\n      <div class=\"form-group\">\r\n        <label>Price</label>\r\n        <select class=\"form-control\" required ng-model=\"$resolve.data.price\" placeholder=\"Price\">\r\n          <option ng-value=\"price\" ng-repeat=\"price in admin.prices\">{{price}}</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    \r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Contact Email</label>\r\n        <input type=\"email\" class=\"form-control\" ng-model=\"$resolve.data.clientEmail\" placeholder=\"Contact Email\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Contact PH</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.clientPh\" placeholder=\"Contact PH\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Subjects</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.subjects\" placeholder=\"Subjects\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" ng-show=\"editNotes\">\r\n    <div class=\"col-sm-12\">\r\n      <div class=\"form-group\">\r\n        <label>Student Notes</label>\r\n        <textarea class=\"form-control\" ng-model=\"$resolve.data.studentNotes\" rows=\"4\"></textarea>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n  \t<div class=\"col-sm-12\">\r\n  \t\t<div class=\"checkbox\">\r\n\t\t    <label>\r\n\t\t      <input type=\"checkbox\" ng-model=\"$resolve.data.isActive\"> Student is active\r\n\t\t    </label>\r\n\t  \t</div>\r\n  \t</div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group add-notes-group\">\r\n        <button type=\"button\" class=\"btn btn-primary btn-lg btn-block\" ng-click=\"editNotes =! editNotes\">Edit Notes</button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-8 add-notes-group\">\r\n      <button type=\"submit\" class=\"btn btn-success btn-lg btn-block\">Save Student</button>\r\n    </div>\r\n    \r\n  </div>\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n</div>\r\n \r\n</form>\r\n</div>"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body\">\r\n\t<button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss()\"><span aria-hidden=\"true\">&times;</span></button>\r\n<form ng-submit=\"admin.patchTutor($resolve.data, $dismiss);\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>First Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"$resolve.data.firstName\" placeholder=\"First Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" required ng-model=\"$resolve.data.lastName\" placeholder=\"Last Name\">\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n        <label>Phone</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.phone\" placeholder=\"Phone\">\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n      <div class=\"form-group\">\r\n        <label>Email Address</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"$resolve.data.email\" placeholder=\"Email Address\">\r\n      </div>\r\n    </div>\r\n  \t<div class=\"col-sm-6\">\r\n  \t\t<div class=\"checkbox\">\r\n\t\t    <label>\r\n\t\t      <input type=\"checkbox\" ng-model=\"$resolve.data.isActive\"> Tutor is active\r\n\t\t    </label>\r\n\t  \t</div>\r\n  \t</div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <button type=\"submit\" class=\"btn btn-success btn-lg btn-block\">Save Tutor</button>\r\n    </div>\r\n    \r\n  </div>\r\n  <div class=\"alert alert-danger\" ng-show=\"admin.error\">\r\n    There was an error:<br>\r\n    <code>{{admin.error}}</code>\r\n  </div>\r\n</form>\r\n</div>"

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _roundUp = __webpack_require__(71);
	
	var _roundUp2 = _interopRequireDefault(_roundUp);
	
	var _segmentConvert = __webpack_require__(72);
	
	var _segmentConvert2 = _interopRequireDefault(_segmentConvert);
	
	var _startFrom = __webpack_require__(73);
	
	var _startFrom2 = _interopRequireDefault(_startFrom);
	
	var _reparseDate = __webpack_require__(74);
	
	var _reparseDate2 = _interopRequireDefault(_reparseDate);
	
	var _toDateString = __webpack_require__(75);
	
	var _toDateString2 = _interopRequireDefault(_toDateString);
	
	var _minuteConvert = __webpack_require__(76);
	
	var _minuteConvert2 = _interopRequireDefault(_minuteConvert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('calApp.filters', []).filter('roundUp', _roundUp2.default).filter('segmentConvert', _segmentConvert2.default).filter('startFrom', _startFrom2.default).filter('reparseDate', _reparseDate2.default).filter('toDateString', _toDateString2.default).filter('minuteConvert', _minuteConvert2.default).name;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (value) {
	    return Math.ceil(value);
	  };
	};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (segment, leadingZero) {
			var hours = Math.floor(segment / 2);
			var mins = segment % 2 ? '30' : '00';
			var end = ' AM';
			if (hours >= 12) {
				hours -= 12;
				end = ' PM';
			}
			hours = hours ? String(hours) : '12';
			if (hours.length === 1 && leadingZero) {
				hours = '0' + hours;
			}
	
			return hours + ':' + mins + end;
		};
	};
	
	;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return function (input, start) {
	    start = +start;
	    try {
	      return input.slice(start);
	    } catch (err) {
	      return [];
	    }
	  };
	};
	
	;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (date) {
			if (!date) {
				return new Date(2020, 10, 10);
			}
			var split = date.split('/');
			var year = +split[2];
			var month = +split[1] - 1;
			var day = +split[0];
			return new Date(year, month, day);
		};
	};
	
	;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	exports.default = function () {
			return function (value) {
					if (value instanceof Date) {
							var result = value;
					} else {
							var result = new Date(value);
					}
	
					var dd = result.getDate();
					var mm = result.getMonth() + 1;
					var yyyy = result.getFullYear();
	
					if (dd < 10) {
							dd = dd;
					}
					if (mm < 10) {
							mm = mm;
					}
	
					return dd + '/' + mm + '/' + yyyy;
			};
	};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (minutes, leadingZero) {
			var hours = Math.floor(minutes / 60);
			var mins = minutes % 60;
			var end = ' AM';
			if (hours >= 12) {
				hours -= 12;
				end = ' PM';
			}
			hours = hours ? String(hours) : '12';
			if (hours.length === 1 && leadingZero) {
				hours = '0' + hours;
			}
	
			if (mins === 0) {
				mins = '00';
			}
	
			return hours + ':' + mins + end;
		};
	};
	
	;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonToCsv = __webpack_require__(78);
	
	var _jsonToCsv2 = _interopRequireDefault(_jsonToCsv);
	
	var _copyTextToClipboard = __webpack_require__(79);
	
	var _copyTextToClipboard2 = _interopRequireDefault(_copyTextToClipboard);
	
	var _colorFinder = __webpack_require__(80);
	
	var _colorFinder2 = _interopRequireDefault(_colorFinder);
	
	var _hourFinder = __webpack_require__(81);
	
	var _hourFinder2 = _interopRequireDefault(_hourFinder);
	
	var _startFinder = __webpack_require__(82);
	
	var _startFinder2 = _interopRequireDefault(_startFinder);
	
	var _validIndexes = __webpack_require__(83);
	
	var _validIndexes2 = _interopRequireDefault(_validIndexes);
	
	var _dateFinder = __webpack_require__(84);
	
	var _dateFinder2 = _interopRequireDefault(_dateFinder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('calApp.MiscServices', []).factory('ColorFinder', _colorFinder2.default).factory('HourFinder', _hourFinder2.default).factory('StartFinder', _startFinder2.default).factory('JSONToCSVConvertor', _jsonToCsv2.default).factory('copyTextToClipboard', _copyTextToClipboard2.default).factory('ValidIndexes', _validIndexes2.default).factory('DateFinder', _dateFinder2.default).name;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function () {
		return function (JSONData, ReportTitle, ShowLabel) {
			var arrData = (typeof JSONData === 'undefined' ? 'undefined' : _typeof(JSONData)) != 'object' ? JSON.parse(JSONData) : JSONData;
	
			var CSV = '';
	
			if (ShowLabel) {
				var row = "";
	
				for (var index in arrData[0]) {
					row += index + ',';
				}
	
				row = row.slice(0, -1);
	
				CSV += row + '\r\n';
			}
	
			for (var i = 0; i < arrData.length; i++) {
				var row = "";
	
				for (var index in arrData[i]) {
					row += '"' + arrData[i][index] + '",';
				}
	
				row.slice(0, row.length - 1);
	
				CSV += row + '\r\n';
			}
	
			if (CSV == '') {
				alert("Invalid data");
				return;
			}
	
			var fileName = ReportTitle.replace(/ /g, "_");
	
			var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
	
			var link = document.createElement("a");
			link.href = uri;
	
			link.style = "visibility:hidden";
			link.download = fileName + ".csv";
	
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};
	};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	exports.default = function () {
			return function (text) {
					var textArea = document.createElement("textarea");
	
					textArea.style.position = 'fixed';
					textArea.style.top = 0;
					textArea.style.left = 0;
	
					textArea.style.width = '2em';
					textArea.style.height = '2em';
	
					textArea.style.padding = 0;
	
					textArea.style.border = 'none';
					textArea.style.outline = 'none';
					textArea.style.boxShadow = 'none';
	
					textArea.style.background = 'transparent';
	
					textArea.value = text;
	
					document.body.appendChild(textArea);
					textArea.focus();
					textArea.select();
	
					try {
							var successful = document.execCommand('copy');
							var msg = successful ? 'successful' : 'unsuccessful';
							console.log('Copying text command was ' + msg);
					} catch (err) {
							console.log('Oops, unable to copy');
					}
	
					document.body.removeChild(textArea);
			};
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function () {
		return function (session, instance) {
			if (!session) {
				return '';
			}
	
			var color;
	
			if (session.overwriteColor && instance in session.overwriteColor) {
				color = session.overwriteColor[instance];
			} else {
				color = session.color;
				var i;
				if (_typeof(session.overwriteFromHere) === 'object') {
					for (i = 0; i <= instance; i++) {
						color = session.overwriteFromHere[i] || color;
					}
				}
			}
	
			return color;
		};
	};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (session, instance) {
			if (!session) {
				return '';
			}
	
			var hours;
	
			if (session.overwriteDuration && instance in session.overwriteDuration) {
				hours = session.overwriteDuration[instance];
			} else {
				hours = session.duration;
			}
	
			return hours;
		};
	};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (session, instance) {
			if (!session) {
				return;
			}
	
			var start;
	
			if (session.overwriteStart && instance in session.overwriteStart) {
				start = session.overwriteStart[instance];
			} else {
				start = session.startTime;
			}
	
			return start;
		};
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (session, start, end) {
			var msDay = 1000 * 60 * 60 * 24;
			var sessionStart = this.$filter('reparseDate')(session.date);
	
			if (!start || !(start instanceof Date)) {
				console.warn('Invalid start date passed to service: Valid Indexes');
				return;
			}
	
			if (!end || !(end instanceof Date)) {
				console.warn('Invalid end date passed to service: Valid Indexes');
				return;
			}
	
			if (sessionStart > end) {
				return [];
			}
	
			if (end < start) {
				console.warn('End date less than start date in service: Valid Indexes');
				return [];
			}
	
			if (session.isHidden) {
				return [];
			}
	
			if (session.frequency === 0) {
				if (end >= sessionStart && start <= sessionStart) {
					var maxPossible = 1;
					var startIndex = 0;
				} else {
					return [];
				}
			} else {
				var maxPossible = Math.floor((end.getTime() - sessionStart.getTime()) / msDay / session.frequency);
	
				if (session.instances !== 0 && session.instances < maxPossible) {
					maxPossible = session.instances;
				}
	
				var startIndex = 0;
				if (start > sessionStart) {
					var dif = (start.getTime() - sessionStart.getTime()) / msDay;
					startIndex = Math.ceil(dif / session.frequency);
	
					if (startIndex < 0) {
						console.warn('Negative index in service: Valid Indexes');
	
						startIndex = 0;
					}
				}
	
				if (startIndex > maxPossible) {
					return [];
				}
	
				if (session.instances !== 0 && session.instances <= startIndex) {
					return [];
				}
			}
	
			var validIndexes = [];
	
			for (var i = startIndex; i <= maxPossible; i++) {
				if (session.instances !== 0 && session.instances === i) {
					continue;
				}
				if (session.overwriteVisibility && session.overwriteVisibility[i] === true) {
					continue;
				}
	
				validIndexes.push(i);
			};
	
			return validIndexes;
		};
	};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (session, instance) {
			if (!session) {
				console.warn('No session provided in service: Date Finder');
				return;
			}
	
			if (typeof instance === 'undefined') {
				console.warn('No instance provided in service: Date Finder');
				return;
			}
	
			var split = session.date.split('/');
			var year = +split[2];
			var month = +split[1] - 1;
			var day = +split[0];
			var sessionDate = new Date(year, month, day);
	
			return sessionDate.setDate(sessionDate.getDate() + session.frequency * instance);
		};
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(86);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(90)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(87)();
	// imports
	exports.i(__webpack_require__(88), "");
	exports.i(__webpack_require__(89), "");
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700);", ""]);
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input.btn[type=date],.input-group-sm>.input-group-btn>input.btn[type=datetime-local],.input-group-sm>.input-group-btn>input.btn[type=month],.input-group-sm>.input-group-btn>input.btn[type=time],.input-group-sm>input.form-control[type=date],.input-group-sm>input.form-control[type=datetime-local],.input-group-sm>input.form-control[type=month],.input-group-sm>input.form-control[type=time],.input-group-sm>input.input-group-addon[type=date],.input-group-sm>input.input-group-addon[type=datetime-local],.input-group-sm>input.input-group-addon[type=month],.input-group-sm>input.input-group-addon[type=time],.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input.btn[type=date],.input-group-lg>.input-group-btn>input.btn[type=datetime-local],.input-group-lg>.input-group-btn>input.btn[type=month],.input-group-lg>.input-group-btn>input.btn[type=time],.input-group-lg>input.form-control[type=date],.input-group-lg>input.form-control[type=datetime-local],.input-group-lg>input.form-control[type=month],.input-group-lg>input.form-control[type=time],.input-group-lg>input.input-group-addon[type=date],.input-group-lg>input.input-group-addon[type=datetime-local],.input-group-lg>input.input-group-addon[type=month],.input-group-lg>input.input-group-addon[type=time],.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select.btn[multiple],.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select.form-control[multiple],.input-group-sm>select.input-group-addon[multiple],.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select.btn[multiple],.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select.form-control[multiple],.input-group-lg>select.input-group-addon[multiple],.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e5e5;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e5e5;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5d5d;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090808;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}.red-nav{background-color:#710000!important}body{text-rendering:optimizeLegibility!important;-webkit-font-smoothing:antialiased!important;-moz-osx-font-smoothing:grayscale!important;font-family:Source Sans Pro,Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif}body .navbar-default .navbar-nav>.active>a{background-color:transparent!important;box-shadow:inset 0 -4px 0 0 #fff;cursor:default}body .navbar-default .navbar-nav>.active>a:hover{opacity:1!important}.navbar-brand{font-weight:600}button.close{position:absolute;right:15px;top:10px;padding:3px;z-index:5}.page-wrap{max-width:1920px;margin:0 auto}.loading-wrap{position:fixed;top:0;left:0;right:0;bottom:0;text-align:center}#load{margin-top:40vh;width:150px;animation:loading 3s linear infinite}#load #loading-inner{stroke-dashoffset:0;stroke-dasharray:300;stroke-width:10;stroke-miterlimit:10;stroke-linecap:round;animation:loading-circle 2s linear infinite;stroke:#51bba7;fill:transparent}@keyframes loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes loading-circle{0%{stroke-dashoffset:0}to{stroke-dashoffset:-600}}navbar .navbar-default{background:#3d484e}navbar .navbar-default *{color:#fff!important}navbar .navbar-default a:hover{color:#fff!important;opacity:.7}.flex{display:-ms-flexbox;display:flex}.flex .flex-grow{-ms-flex-positive:1;flex-grow:1}.flex.flex-wrap{-ms-flex-wrap:wrap;flex-wrap:wrap}.flex.h-center{-ms-flex-pack:center;justify-content:center}.flex.h-right{-ms-flex-pack:end;justify-content:flex-end}.flex.v-center{-ms-flex-align:center;align-items:center}.flex.v-bottom{-ms-flex-align:end;align-items:flex-end}.flex.h-separate{-ms-flex-pack:justify;justify-content:space-between}.flex.child-stretch>*{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0}.flex.child-stretch .no-stretch{-ms-flex-positive:0;flex-grow:0}.flex.v-flex{-ms-flex-direction:column;flex-direction:column}.row-bleed{margin-left:-10px;margin-right:-10px}.o70{opacity:.7}.o0{opacity:0}.w600{font-weight:600}.w700{font-weight:700}.width60{width:60%}.fs18{font-size:18px}.fs16,.fs-15{font-size:16px}.fs14{font-size:14px}.fs12{font-size:12px}.fs10{font-size:10px}.no-click{pointer-events:none;cursor:default}.big-shadow{box-shadow:0 20px 66px 0 rgba(34,48,73,.2)}.small-shadow{box-shadow:0 0 10px 0 rgba(34,48,73,.2)}.smaller-shadow{box-shadow:0 0 5px 0 rgba(34,48,73,.2)}.m-r-xs{margin-right:6px}.m-r-sm{margin-right:12px}.m-r-md{margin-right:18px}.m-r-lg{margin-right:24px}.m-r-xl{margin-right:30px}.m-l-xs{margin-left:6px}.m-l-sm{margin-left:12px}.m-l-md{margin-left:18px}.m-l-lg{margin-left:24px}.m-l-xl{margin-left:30px}.m-t-xs{margin-top:6px}.m-t-sm{margin-top:12px}.m-t-md{margin-top:18px}.m-t-lg{margin-top:24px}.m-t-xl{margin-top:30px}.m-b-xs{margin-bottom:6px}.m-b-sm{margin-bottom:12px}.m-b-md{margin-bottom:18px}.m-b-lg{margin-bottom:24px}.m-b-xl{margin-bottom:30px}.p-xs{padding:6px}.p-sm{padding:12px}.p-md{padding:18px}.p-lg{padding:24px}.p-xl{padding:30px}.b-r{border-radius:4px}.abs-cover{position:absolute;top:0;left:0;right:0;bottom:0}.fill-bg{background-size:cover;background-position:50%}.bg-white{background-color:#fff}.border-grey{border:1px solid #ccc}@font-face{font-family:in-Avenir LT Std;src:url(\"/assets/fonts/avenir/AvenirLTStd-Roman.eot\");src:local(\"\\263A\"),url(\"/assets/fonts/avenir/AvenirLTStd-Roman.woff\") format(\"woff\"),url(\"/assets/fonts/avenir/AvenirLTStd-Roman.ttf\") format(\"truetype\"),url(\"/assets/fonts/avenir/AvenirLTStd-Roman.svg\") format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:in-Avenir LT Std;src:url(\"/assets/fonts/avenir/AvenirLTStd-Medium.eot\");src:local(\"\\263A\"),url(\"/assets/fonts/avenir/AvenirLTStd-Medium.woff\") format(\"woff\"),url(\"/assets/fonts/avenir/AvenirLTStd-Medium.ttf\") format(\"truetype\"),url(\"/assets/fonts/avenir/AvenirLTStd-Medium.svg\") format(\"svg\");font-weight:600;font-style:normal}@font-face{font-family:in-Avenir LT Std;src:url(\"/assets/fonts/avenir/AvenirLTStd-Heavy.eot\");src:local(\"\\263A\"),url(\"/assets/fonts/avenir/AvenirLTStd-Heavy.woff\") format(\"woff\"),url(\"/assets/fonts/avenir/AvenirLTStd-Heavy.ttf\") format(\"truetype\"),url(\"/assets/fonts/avenir/AvenirLTStd-Heavy.svg\") format(\"svg\");font-weight:800;font-style:normal}@font-face{font-family:in-Avenir LT Std;src:url(\"/assets/fonts/avenir/AvenirLTStd-Black.eot\");src:local(\"\\263A\"),url(\"/assets/fonts/avenir/AvenirLTStd-Black.woff\") format(\"woff\"),url(\"/assets/fonts/avenir/AvenirLTStd-Black.ttf\") format(\"truetype\"),url(\"/assets/fonts/avenir/AvenirLTStd-Black.svg\") format(\"svg\");font-weight:900;font-style:normal}.tertiary.active{color:#fff;background-color:#286090;border-color:#204d74}.add-notes-group{margin-top:12px}.data-button-wrap button{line-height:34px;height:34px;width:34px;border:none;border-radius:3px;background-color:#d2d2d2;outline:none!important}.data-button-wrap button.active{background-color:#333;color:#fff}.data-button-wrap>div{opacity:.4;display:inline-block}.data-button-wrap>div.active{opacity:1;color:#bb0a0a}.student-modal.modal>.modal-dialog{width:950px}.session-modal.modal>.modal-dialog{width:700px}.edit-button{font-size:12px;line-height:1;margin-top:-4px;margin-bottom:-2px}.date-group{max-width:250px;float:left;margin-right:20px}#calendar-container{margin-top:-10px}.search-group{float:left;margin-right:20px;max-width:300px}.a-calendar{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.single-cell span.student{display:none!important}.single-cell span.tutor{font-size:13px;font-weight:700;padding-top:1px}.session-cell.changeover:after{content:\"\";position:absolute;bottom:0;left:0;height:4px;right:0;background-color:#565656}.free-col{position:relative}.free-col.drag-cell{background-color:#aaa}.calendar-grey{padding-bottom:10px;background:#e2e7eb;margin-top:-10px;padding-top:10px}.calendar-grey button.btn-primary{background-color:#9db4c5!important;border-color:#333!important;color:#333!important;cursor:default}.calendar-grey button:focus{outline:none!important}.a-calendar.table tr>td,.a-calendar.table tr>th{padding:2px 8px}.a-calendar.table tr>th{font-weight:400}.session-cell{width:calc(50% - 2px);position:absolute;top:0;left:0;z-index:10;padding:5px;line-height:1.1;overflow:hidden}.session-cell.single-cell{padding:3px 2px;font-size:11px}.session-cell.single-cell span.student{display:block;font-size:12px;margin-bottom:3px}.session-cell.single-cell span{white-space:nowrap;display:block;text-overflow:ellipsis;overflow:hidden}.session-cell.single-cell .icon-row{opacity:.6;padding:2px 0 2px 3px;border-radius:3px 0 0;z-index:10;font-size:10px}.session-cell.single-cell .icon-row i{margin-right:2px}.session-cell:only-child{width:calc(100% - 4px)}.session-cell:nth-child(2){left:auto;right:4px}.session-cell:hover{background-color:#fff}.session-cell:hover .a-bg{opacity:.25}.session-cell .a-bg{position:absolute;top:0;left:0;bottom:0;right:0;opacity:.5;z-index:-1;border:1px solid rgba(0,0,0,.5)}.session-cell span.student{display:block;font-size:14px;line-height:1.1;font-weight:700}.session-cell span.tutor{font-size:12px}.session-cell span.notes{-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto;margin-top:10px;display:inline-block;overflow:hidden;font-size:12px}.a-calendar td{border-left:1px solid #ccc;cursor:pointer}.a-calendar td:hover{background-color:rgba(0,0,0,.1)}.date-input{pointer-events:none}.date-group .uib-clear{display:none}.time-col{width:80px}.a-calendar thead tr th{text-align:center;font-weight:700!important}.icon-row{position:absolute;bottom:0;right:0;text-align:center;color:#fff!important;background-color:#565656;padding:5px 2px 2px 5px;border-radius:3px 0 0;z-index:10}.icon-row i{margin-right:5px;font-size:12px}.select-wrap{position:relative}.select-wrap button.btn{position:absolute;top:0;right:0}.select-wrap .remove-button{display:none}.select-wrap li.tag-item{background-color:transparent!important;border:0!important;color:#333!important}.select-wrap tags-input .tags.focused{border:1px solid #ccc;box-shadow:none!important}.select-wrap :focus,.select-wrap div.tags:focus{outline:none!important}.duration-group button{margin-right:8px}.color-house>div{margin-bottom:8px;margin-left:-8px;margin-right:-8px}.color-group>div{margin-bottom:12px;text-align:center}.color-group span.color-box{width:70px;height:50px;display:inline-block;text-align:center;margin:0 5px;border-radius:3px;vertical-align:bottom}.color-group span.color-box.active{border:3px solid #ccc}.a-calendar.loading{opacity:.5;pointer-events:none}.a-calendar tbody td,.a-calendar tbody th{border-top:none!important}table.in-drag .session-cell:not(.in-drag){z-index:-1}.table-striped.a-calendar>tbody>tr:nth-of-type(odd){background-color:hsla(0,0%,100%,.35)}.table-striped.a-calendar>tbody>tr:nth-of-type(odd) th{opacity:0}.table-striped.a-calendar>tbody>tr:nth-of-type(2n){background-color:hsla(0,1%,86%,.35)}.a-success-wrap{background:rgba(7,204,0,.21);border:2px solid #119200;border-radius:3px;padding:15px 30px 15px 10px;display:-ms-flexbox;display:flex;position:fixed;right:50px;bottom:20px}.a-success-wrap .a-success-circle{border-radius:100px;background:hsla(0,0%,100%,.44);border:1px solid #119200;height:50px;width:50px;display:inline-block;margin-right:15px;text-align:center;position:relative;-ms-flex:0 0 auto;flex:0 0 auto}.a-success-wrap .a-success-circle i{font-size:26px;color:#119200;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.a-success-wrap .a-success-message{font-size:22px;color:#119200;line-height:30px;display:inline-block;margin-top:8px}.table-wrap{height:calc(100vh - 131px);overflow-y:auto}.a-calendar{margin-bottom:0}.dropdown-menu{width:185px}.striped{background-size:cover!important}td .striped{background-size:10px 10px!important;opaicty:.3!important}.aablue{background-color:#337ab7}.aablue.dark{background-color:#002346}.aablue.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#337ab7 0,#337ab7 50%,#eee 0,#eee 75%,#337ab7 0)}.aaorange{background-color:#cb8515}.aaorange.dark{background-color:#b44e0e}.aaorange.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#cb8515 0,#cb8515 50%,#eee 0,#eee 75%,#cb8515 0)}.aared{background-color:#d32626}.aared.dark{background-color:#8b0b0b}.aared.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#d32626 0,#d32626 50%,#eee 0,#eee 75%,#d32626 0)}.aapurple{background-color:#a76ae6}.aapurple.dark{background-color:#390c68}.aapurple.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#a76ae6 0,#a76ae6 50%,#eee 0,#eee 75%,#a76ae6 0)}.aagrey{background-color:#afafaf}.aagrey.dark{background-color:#5f5f5f}.aagrey.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#afafaf 0,#afafaf 50%,#eee 0,#eee 75%,#afafaf 0)}.aagreen{background-color:#31be3f}.aagreen.dark{background-color:#096312}.aagreen.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#31be3f 0,#31be3f 50%,#eee 0,#eee 75%,#31be3f 0)}.aayellow{background-color:#d2be4a}.aayellow.dark{background-color:#7c6f00}.aayellow.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#d2be4a 0,#d2be4a 50%,#eee 0,#eee 75%,#d2be4a 0)}.aalime{background-color:#d7f542}.aalime.dark{background-color:#b7d03a}.aalime.striped{background:-webkit-linear-gradient(45deg,#eee 25%,#d7f542 0,#d7f542 50%,#eee 0,#eee 75%,#d7f542 0)}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}", ""]);
	
	// exports


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(87)();
	// imports
	
	
	// module
	exports.push([module.id, "tags-input{display:block}tags-input *,tags-input :after,tags-input :before{box-sizing:border-box}tags-input .host{position:relative;margin-top:5px;margin-bottom:5px;height:100%}tags-input .host:active{outline:0}tags-input .tags{-moz-appearance:textfield;-webkit-appearance:textfield;padding:1px;overflow:hidden;word-wrap:break-word;cursor:text;background-color:#fff;border:1px solid #a9a9a9;box-shadow:inset 1px 1px 1px 0 #d3d3d3;height:100%}tags-input .tags.focused{outline:0;box-shadow:0 0 3px 1px rgba(5,139,242,.6)}tags-input .tags .tag-list{margin:0;padding:0;list-style-type:none}tags-input .tags .tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;font:14px Helvetica Neue,Helvetica,Arial,sans-serif;height:26px;line-height:25px;border:1px solid #acacac;border-radius:3px;background:linear-gradient(180deg,#f0f9ff 0,#cbebff 47%,#a1dbff)}tags-input .tags .tag-item.selected{background:linear-gradient(180deg,#febbbb 0,#fe9090 45%,#ff5c5c)}tags-input .tags .tag-item .remove-button{margin:0 0 0 5px;padding:0;border:none;background:0 0;cursor:pointer;vertical-align:middle;font:700 16px Arial,sans-serif;color:#585858}tags-input .tags .input.invalid-tag,tags-input .tags .tag-item .remove-button:active{color:red}tags-input .tags .input{border:0;outline:0;margin:2px;padding:0 0 0 5px;float:left;height:26px;font:14px Helvetica Neue,Helvetica,Arial,sans-serif}tags-input .tags .input::-ms-clear{display:none}tags-input.ng-invalid .tags{box-shadow:0 0 3px 1px rgba(255,0,0,.6)}tags-input[disabled] .host:focus{outline:0}tags-input[disabled] .tags{background-color:#eee;cursor:default}tags-input[disabled] .tags .tag-item{opacity:.65;background:linear-gradient(180deg,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62))}tags-input[disabled] .tags .tag-item .remove-button{cursor:default}tags-input[disabled] .tags .tag-item .remove-button:active{color:#585858}tags-input[disabled] .tags .input{background-color:#eee;cursor:default}tags-input .autocomplete{margin-top:5px;position:absolute;padding:5px 0;z-index:999;width:100%;background-color:#fff;border:1px solid rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}tags-input .autocomplete .suggestion-list{margin:0;padding:0;list-style-type:none;max-height:280px;overflow-y:auto;position:relative}tags-input .autocomplete .suggestion-item{padding:5px 10px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:16px Helvetica Neue,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#fff;background-color:#0097cf}tags-input .autocomplete .suggestion-item em{font:normal 700 16px Helvetica Neue,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(87)();
	// imports
	
	
	// module
	exports.push([module.id, "tags-input{box-shadow:none;border:none;padding:0;min-height:34px}tags-input .host{margin:0}tags-input .tags{-moz-appearance:none;-webkit-appearance:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}tags-input .tags .tag-item{color:#fff;background:#428bca;border:1px solid #357ebd;border-radius:4px}tags-input .tags .tag-item.selected{color:#fff;background:#d9534f;border:1px solid #d43f3a}tags-input .tags .tag-item .remove-button:hover{text-decoration:none}tags-input .tags.focused{border:1px solid #66afe9;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}tags-input .autocomplete{border-radius:4px}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#262626;background-color:#f5f5f5}tags-input .autocomplete .suggestion-item em{color:#000;background-color:#fff}tags-input.ng-invalid .tags{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}tags-input[disabled] .tags{background-color:#eee}tags-input[disabled] .tags .tag-item{background:#337ab7;opacity:.65}tags-input[disabled] .tags .input{background-color:#eee}.input-group tags-input{padding:0;display:table-cell}.input-group tags-input:not(:first-child) .tags{border-top-left-radius:0;border-bottom-left-radius:0}.input-group tags-input:not(:last-child) .tags{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-lg tags-input:first-child .tags{border-top-left-radius:6px;border-bottom-left-radius:6px}.input-group-lg tags-input:last-child .tags{border-top-right-radius:6px;border-bottom-right-radius:6px}.input-group-sm tags-input:first-child .tags{border-top-left-radius:3px;border-bottom-left-radius:3px}.input-group-sm tags-input:last-child .tags{border-top-right-radius:3px;border-bottom-right-radius:3px}.input-group-lg tags-input,tags-input.ti-input-lg{min-height:46px}.input-group-lg tags-input .tags,tags-input.ti-input-lg .tags{border-radius:6px}.input-group-lg tags-input .tags .tag-item,tags-input.ti-input-lg .tags .tag-item{height:38px;line-height:37px;font-size:18px;border-radius:6px}.input-group-lg tags-input .tags .tag-item .remove-button,tags-input.ti-input-lg .tags .tag-item .remove-button{font-size:20px}.input-group-lg tags-input .tags .input,tags-input.ti-input-lg .tags .input{height:38px;font-size:18px}.input-group-sm tags-input,tags-input.ti-input-sm{min-height:30px}.input-group-sm tags-input .tags,tags-input.ti-input-sm .tags{border-radius:3px}.input-group-sm tags-input .tags .tag-item,tags-input.ti-input-sm .tags .tag-item{height:22px;line-height:21px;font-size:12px;border-radius:3px}.input-group-sm tags-input .tags .tag-item .remove-button,tags-input.ti-input-sm .tags .tag-item .remove-button{font-size:16px}.input-group-sm tags-input .tags .input,tags-input.ti-input-sm .tags .input{height:22px;font-size:12px}.has-feedback tags-input .tags{padding-right:30px}.has-success tags-input .tags{border-color:#3c763d}.has-success tags-input .tags.focused{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-error tags-input .tags{border-color:#a94442}.has-error tags-input .tags.focused{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-warning tags-input .tags{border-color:#8a6d3b}.has-warning tags-input .tags.focused{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}", ""]);
	
	// exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.c339009c7c3ca8f80348.js